import { getUser, getToken } from './service/AuthService';
import { getUserGoal } from './service/GoalService';

import Timer from './Timer';
import ProblematicLogEntry from './ProblematicLogEntry';
import TextExpander from './TextExpander';


import axios from 'axios';
import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';


import './css/WellnessGym.css';
import './css/Daily.css';
import './css/PopupForm.css';

import { WellnessGymCustomWorkoutFeature } from './WellnessGymCustomWorkoutFeature';

import { DailyPromptTextField, WellnessGymJournalEntry } from './MaterialComponents';
import AudioRecorder from './AudioRecorder'
import editBttn from './assets/editBttn.svg';
import GuidedRelapse from './GuidedRelapse'
import Chat from "./ChatDemo2";


import boxedBreathing from './assets/cropped_box_breathing.gif';
import meditationAudio from './assets/general-meditation-wellness-gym.mp3';
import workoutBgA from './assets/workout-backgrounds/pexels-pixelstories-29350450.jpg';
import workoutBgB from './assets/workout-backgrounds/pexels-stevarnol-35788171.jpg';
import workoutBgC from './assets/workout-backgrounds/pexels-alejandro-orozco-211352387-23645341.jpg';
import workoutBgD from './assets/workout-backgrounds/pexels-allan-carvalho-264847051-16343431.jpg';
import workoutBgE from './assets/workout-backgrounds/pexels-maximilian-orlowsky-515733-32846085.jpg';
import workoutBgF from './assets/workout-backgrounds/pexels-brunoscramgnon-596134.jpg';
import workoutBgG from './assets/workout-backgrounds/pexels-ian-panelo-8885563.jpg';
import workoutBgH from './assets/workout-backgrounds/pexels-iamtausifhossain9321-5429904.jpg';
import workoutBgI from './assets/workout-backgrounds/pexels-figaaaaaaahh-30239523.jpg';
import workoutBgJ from './assets/workout-backgrounds/pexels-damir-35133653.jpg';
import workoutBgK from './assets/workout-backgrounds/pexels-erik-karits-2093459-7663483.jpg';
import workoutBgL from './assets/workout-backgrounds/pexels-nicolas-diaz-66355688-14358792.jpg';
import AudioPlayer from 'react-h5-audio-player';
import 'react-h5-audio-player/lib/styles.css';

const logFetchUrl = 'https://lkrse43p4g.execute-api.us-east-1.amazonaws.com/dev/problematiclogfetch';
const gymSubmitUrl = 'https://lkrse43p4g.execute-api.us-east-1.amazonaws.com/dev/gymsubmit';
/** Trigger library — align with API Gateway route name on the backend */
const triggerLibraryFetchUrl = 'https://lkrse43p4g.execute-api.us-east-1.amazonaws.com/dev/triggerlibraryfetch';
const triggerLibraryUpdateUrl = 'https://lkrse43p4g.execute-api.us-east-1.amazonaws.com/dev/triggerlibraryupdate';
const triggerLibraryCreateUrl = 'https://lkrse43p4g.execute-api.us-east-1.amazonaws.com/dev/triggerlibrarycreate';

const apiKeyHeader = { 'x-api-key': 'mCQrNSvy7X5AUdJlF2ybc3LdEFGndN885kzttyvB' };

const dateObj = new Date()

/** @typedef {{ id: string, name: string, pillar: string, oldPattern: string, replacement: string, affirmation: string, fears: string[], bodySensations: string[] }} TsTrigger */

const SEED_TRIGGERS = [
    {
        id: 'seed-feeling-dismissed',
        name: 'Feeling dismissed',
        pillar: 'Nervous System Regulation',
        oldPattern: 'Go quiet and replay the moment on a loop.',
        replacement: 'Name the feeling out loud — one sentence. Then ask a clarifying question.',
        affirmation: 'I can feel unseen and still speak my truth.',
        fears: ['rejection', 'being wrong', 'not mattering'],
        bodySensations: ['chest tight', 'jaw clenched', 'pulling away'],
    },
    {
        id: 'seed-not-heard',
        name: 'Not being heard',
        pillar: 'Emotional Capacity',
        oldPattern: 'Get louder or shut down completely.',
        replacement: 'Lower your voice. Slow down. Say: \'I want to make sure I\'m clear.\'',
        affirmation: 'My voice matters even when it isn\'t received.',
        fears: ['being invisible', 'losing control', 'disconnection'],
        bodySensations: ['throat tight', 'shallow breath', 'heat in face'],
    },
    {
        id: 'seed-criticism-work',
        name: 'Criticism at work',
        pillar: 'Mindset Awareness',
        oldPattern: 'Defend immediately. Explain why you were right.',
        replacement: 'Wait 3 seconds. Then ask: \'Tell me more about what you saw.\'',
        affirmation: 'Feedback is data, not a verdict on who I am.',
        fears: ['failure', 'being exposed', 'not enough'],
        bodySensations: ['stomach drops', 'heart races', 'freeze'],
    },
    {
        id: 'seed-conflict-avoidance',
        name: 'Conflict avoidance',
        pillar: 'Connection & Communication',
        oldPattern: 'Agree on the surface, resent privately.',
        replacement: 'Say the true thing once, calmly. You don\'t need them to agree.',
        affirmation: 'Honesty is an act of respect — for them and for me.',
        fears: ['conflict', 'abandonment', 'being too much'],
        bodySensations: ['go numb', 'hold breath', 'heaviness in chest'],
    },
];

function normalizeTriggerFromApi(item) {
    if (!item || typeof item !== 'object') return null;
    const fearsRaw = item.fears ?? item.Fears;
    const bodyRaw = item.bodySensations ?? item.body ?? item.body_sensations;
    return {
        id: String(item.id ?? item.trigger_id ?? item.sk ?? ''),
        name: String(item.name ?? ''),
        pillar: String(item.pillar ?? ''),
        oldPattern: String(item.oldPattern ?? item.old_pattern ?? ''),
        replacement: String(item.replacement ?? ''),
        affirmation: String(item.affirmation ?? ''),
        fears: Array.isArray(fearsRaw) ? fearsRaw.map(String) : [],
        bodySensations: Array.isArray(bodyRaw) ? bodyRaw.map(String) : [],
    };
}

function normalizeTriggersFromResponse(data) {
    if (data == null) return [];
    const raw =
        data.triggers ??
        data.triggerLibrary ??
        data.items ??
        data.dynamoTriggers ??
        (Array.isArray(data) ? data : null);
    if (!Array.isArray(raw)) return [];
    return raw.map(normalizeTriggerFromApi).filter((t) => t && t.id);
}

function deriveDurationMinutes(submission) {
    if (!submission || typeof submission !== 'object') return 0;
    const mins =
        submission.durationMinutes ??
        submission.duration_minutes ??
        submission.sessionDurationMinutes ??
        submission.session_duration_minutes;
    if (mins != null) return Math.max(0, Number(mins) || 0);
    if (submission.sessionDurationMs != null) return Math.max(0, Number(submission.sessionDurationMs) / 60000 || 0);
    if (submission.session_duration != null) return Math.max(0, Number(submission.session_duration) / 60000 || 0);
    if (submission.sessionDuration != null) return Math.max(0, Number(submission.sessionDuration) / 60000 || 0);
    if (submission.repDurationSeconds != null) return Math.max(0, Number(submission.repDurationSeconds) / 60 || 0);
    return 0;
}

function withWorkoutTracking(submission, username) {
    const completedAtDate = new Date(
        submission.completedAt ?? submission.completed_at ?? submission.timestamp ?? Date.now()
    );
    return {
        ...submission,
        workoutType: String(submission.workoutType ?? submission.workout_type ?? submission.exercise_type ?? 'wellness_workout'),
        durationMinutes: Math.round(deriveDurationMinutes(submission) * 10) / 10,
        completedAt: completedAtDate.toISOString(),
        userId: submission.userId ?? username,
    };
}

const NSR_BODY_SIGNALS = [
    'Tight chest',
    'Shallow breathing',
    'Jaw tension',
    'Restless energy',
    'Heavy limbs',
    'Blank / numb',
    'Racing thoughts',
    'Stomach tension',
];

const NSR_BOX_PHASES = [
    { label: 'Inhale', ms: 4000, scale: 1.22 },
    { label: 'Hold', ms: 4000, scale: 1.22 },
    { label: 'Exhale', ms: 4000, scale: 0.92 },
    { label: 'Hold', ms: 4000, scale: 0.92 },
];

const NSR_EXT_PHASES = [
    { label: 'Inhale', ms: 4000, scale: 1.2 },
    { label: 'Exhale', ms: 8000, scale: 0.9 },
];

const NSR_TIME_SLOTS = ['Morning', 'Afternoon', 'Evening', 'Night', 'Other'];
const EXPOSURE_CHALLENGES_STORAGE_KEY = 'th_exposure_challenges';
const EXPOSURE_SESSIONS_STORAGE_KEY = 'th_exposure_sessions';
const EXPOSURE_DISCLAIMER_SEEN_KEY = 'th_exposure_disclaimer_seen';

function convertTimestampToDateString(timestamp) {
    const date = new Date(timestamp);
    const options = {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric',
    };
    const dateString = date.toLocaleDateString('en-US', options)
    //console.log(dateString)
    return dateString;
}

function convertTimestampToFullDateString(timestamp) {
    const date = new Date(timestamp);
    const options = {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: '2-digit', // "02"
        minute: '2-digit', // "30"
        second: '2-digit', // "15"
        timeZoneName: 'short' // "GMT+1"
    };
    const dateString = date.toLocaleDateString('en-US', options)
    //console.log(dateString)
    return dateString;
}

/** Emotional Capacity & Expression — quadrant vocabulary and copy */
const ECE_QUADRANT_WORDS = {
    high_energy_unpleasant: ['tense', 'irritated', 'anxious', 'overwhelmed', 'frantic', 'on edge'],
    high_energy_pleasant: ['energized', 'excited', 'motivated', 'hopeful', 'inspired', 'focused'],
    low_energy_unpleasant: ['drained', 'sad', 'numb', 'disconnected', 'heavy', 'defeated'],
    low_energy_pleasant: ['calm', 'content', 'peaceful', 'grounded', 'reflective', 'still'],
};

const ECE_BODY_ZONES = [
    'Chest',
    'Stomach',
    'Shoulders',
    'Throat',
    'Jaw',
    'Head',
    'Behind the eyes',
    'Arms or hands',
    'Legs or feet',
    'Low back',
    'Whole body',
];

const ECE_BODY_NORMALIZE = {
    tense: 'Tension often gathers in the jaw, neck, and shoulders before we name it.',
    irritated: 'Irritation can show up as heat in the face and tightness in the chest.',
    anxious: 'Anxiety often lives in the chest and stomach before we have words for it.',
    overwhelmed: 'When everything feels like too much, the chest and breath are often the first to respond.',
    frantic: 'A frantic state often pulses in the chest and limbs — your system is trying to move faster than the moment.',
    'on edge': 'Being on edge often lives in the jaw, shoulders, and shallow breath.',
    energized: 'Energy tends to wake up the chest, limbs, and face — your body is online.',
    excited: 'Excitement often buzzes in the chest and stomach with a forward lean in the body.',
    motivated: 'Motivation often feels like warmth and readiness in the chest and gut.',
    hopeful: 'Hope can soften the shoulders and bring a little more space in the breath.',
    inspired: 'Inspiration often lifts the chest and brightens the eyes and face.',
    focused: 'Focus often steadies the eyes, jaw, and breath into a narrower channel.',
    drained: 'Depletion tends to settle in the legs and behind the eyes.',
    sad: 'Sadness often weighs in the chest, throat, and behind the eyes.',
    numb: 'Numbness can flatten sensation everywhere or pull away from the chest and gut first.',
    disconnected: 'Disconnection often feels spaced out behind the eyes or hollow in the chest.',
    heavy: 'Heaviness often pools in the legs, chest, and low back.',
    defeated: 'Defeat often lands in the shoulders dropping and a weight behind the eyes.',
    calm: 'Calm often feels like softness in the shoulders and a slower breath.',
    content: 'Contentment often spreads as ease in the chest, belly, and jaw.',
    peaceful: 'Peace often shows up as slower breath and looseness in the shoulders and hands.',
    grounded: 'Grounding often feels like weight and contact through the feet, legs, and seat.',
    reflective: 'Reflective states often quiet the face and draw attention inward behind the eyes.',
    still: 'Stillness often softens the belly and slows everything — without forcing anything.',
};

const ECE_REFLECTION_PROMPT = {
    tense: "What's pressing on you right now?",
    irritated: "What rubbed you the wrong way?",
    anxious: "What's uncertain for you right now?",
    overwhelmed: "What's taking more than you have to give right now?",
    frantic: "What are you racing toward or away from?",
    'on edge': "What's making you watchful right now?",
    energized: "What wants your attention right now?",
    excited: "What's this energy pointing toward?",
    motivated: "What are you moving toward?",
    hopeful: "What are you hoping might be true?",
    inspired: "What stirred this in you?",
    focused: "What are you narrowing in on?",
    drained: "What have you been carrying lately?",
    sad: "What are you grieving or missing?",
    numb: "What might be underneath the numbness?",
    disconnected: "Where did you last feel fully here?",
    heavy: "What's weighing on you?",
    defeated: "What did you need that didn't show up?",
    calm: "What's underneath this calm for you?",
    content: "What's making this moment feel okay?",
    peaceful: "What feels settled right now?",
    grounded: "What's helping you feel steady?",
    reflective: "What are you sitting with?",
    still: "What quiet are you in right now?",
};

const ECE_REFRAME_BY_QUADRANT = {
    high_energy_unpleasant:
        'High, difficult energy is your system mobilizing around something that matters. It is not broken — it is trying to respond.',
    high_energy_pleasant:
        'Pleasant high energy is your system engaged and resourced. Notice it — you can channel it without chasing it.',
    low_energy_unpleasant: "Depletion is information. It is your body asking for something it hasn't gotten.",
    low_energy_pleasant: 'This is what regulation feels like. Notice it so you can find your way back.',
};

const ECE_REFRAME_BY_FEELING = {
    anxious: "Anxiety is your system scanning for what matters. It is not broken — it is paying attention.",
    drained: "Depletion is information. It is your body asking for something it hasn't gotten.",
    calm: 'This is what regulation feels like. Notice it so you can find your way back.',
    content: 'This is what regulation feels like. Notice it so you can find your way back.',
    peaceful: 'This is what regulation feels like. Notice it so you can find your way back.',
    grounded: 'This is what regulation feels like. Notice it so you can find your way back.',
    still: 'This is what regulation feels like. Notice it so you can find your way back.',
    reflective: 'This is what regulation feels like. Notice it so you can find your way back.',
};

function eceGetQuadrant(nx, ny) {
    const highEnergy = nx >= 0.5;
    const pleasant = ny >= 0.5;
    if (highEnergy && !pleasant) return 'high_energy_unpleasant';
    if (highEnergy && pleasant) return 'high_energy_pleasant';
    if (!highEnergy && !pleasant) return 'low_energy_unpleasant';
    return 'low_energy_pleasant';
}

function eceFormatFeelingLabel(word) {
    if (!word || !word.trim()) return 'this';
    const t = word.trim();
    return t.charAt(0).toUpperCase() + t.slice(1);
}

function eceFormatBodyZonesPhrase(zones) {
    if (!zones || !zones.length) return 'body';
    const lower = zones.map((z) => String(z).toLowerCase());
    if (lower.length === 1) return lower[0];
    if (lower.length === 2) return `${lower[0]} and ${lower[1]}`;
    return `${lower.slice(0, -1).join(', ')}, and ${lower[lower.length - 1]}`;
}

/** Connection & Communication — storytelling workout (learning index 10) */
const CCC_STORY_OPTIONS = [
    { id: 'didnt_expect', title: "A moment I didn't expect", muscle: 'Openness and presence' },
    { id: 'got_wrong', title: 'Something I got wrong', muscle: 'Humility and self-awareness' },
    { id: 'changed_me', title: 'A person who changed me', muscle: 'Gratitude and relational depth' },
    { id: 'most_like_self', title: 'A time I felt most like myself', muscle: 'Identity and authenticity' },
    { id: 'never_said', title: "Something I've never said out loud", muscle: 'Courage and intimacy' },
];

const CCC_CLOSE_LINES = {
    didnt_expect: 'Being surprised requires being present. You were.',
    got_wrong: "Telling this story without defending yourself is rare. That's what trust is built on.",
    changed_me: "Knowing who changed you means you know who you are. That's not nothing.",
    most_like_self: "You just located something real. That's the story worth telling.",
    never_said: 'Naming something for the first time is an act of courage, even alone.',
};

function cccStoryTitle(id) {
    return CCC_STORY_OPTIONS.find((o) => o.id === id)?.title || '';
}

/**
 * Easy image-to-workout mapping for home workout cards.
 * Swap any value below to assign a different image to that workout button.
 */
const WORKOUT_BACKGROUND_BY_TITLE = {
    'Guided Journaling': workoutBgA,
    'Breath Exercise': workoutBgB,
    'Wellness Coach': workoutBgC,
    'Guided Meditation': workoutBgD,
    'Capacity & Expression': workoutBgE,
    'Manage Triggers': workoutBgF,
    'Nervous System Regulation': workoutBgG,
    'Mindset & Awareness': workoutBgH,
    'TH Community': workoutBgI,
    'Resilience & Purpose': workoutBgJ,
    'Connection & Communication': workoutBgK,
    'Exposure Training': workoutBgL,
};

const categories = [
  {
    title: 'Guided Journaling',
    page: 0,
    subtitle: 'Explore your thoughts with structured prompts',
    image: '/assets/strength.png',
    bgColor: '#3D414D',
  },
  {
    title: 'Breath Exercise',
    page: 1,
    subtitle: 'Calm your nervous system with mindful breathing',
    image: '/assets/cardio.png',
    bgColor: '#3D414D',
  },
  {
    title: 'Guided Meditation',
    page: 3,
    subtitle: 'Center your mind and body through stillness',
    image: '/assets/stretch.png',
    bgColor: '#3D414D',
  },
  {
    title: 'Capacity & Expression',
    page: 4,
    subtitle: 'Depth · 5–7 min',
    image: '/assets/mobility.png',
    bgColor: '#3D414D',
  },
  {
    title: 'Wellness Coach',
    page: 2,
    subtitle: 'Get personalized support to reset and refocus',
    image: '/assets/mobility.png',
    bgColor: '#3D414D',
  },
  {
    title: 'Manage Triggers',
    page: 5,
    subtitle: 'Practice new responses to emotional triggers',
    image: '/assets/strength.png',
    bgColor: '#3D414D',
  },
  {
    title: 'Nervous System Regulation',
    page: 6,
    subtitle: 'Stability · 5–7 min',
    image: '/assets/cardio.png',
    bgColor: '#3D414D',
  },
  {
    title: 'Mindset & Awareness',
    page: 7,
    subtitle: 'Clarity · 6–8 min',
    image: '/assets/strength.png',
    bgColor: '#3D414D',
  },
  {
    title: 'TH Community',
    page: 8,
    subtitle: 'Share wins and set backs with the community ',
    image: '/assets/mobility.png',
    bgColor: '#3D414D',
  },
   {
    title: 'Resilience & Purpose',
    page: 9,
    subtitle: 'Endurance · 6–8 min',
    image: '/assets/cardio.png',
    bgColor: '#3D414D',
  },
  {
    title: 'Connection & Communication',
    page: 10,
    subtitle: 'Relation · 7–10 min',
    image: '/assets/mobility.png',
    bgColor: '#3D414D',
  },
  {
    title: 'Exposure Training',
    page: 11,
    subtitle: 'Resilience & Purpose · 6–10 min',
    image: '/assets/strength.png',
    bgColor: '#3D414D',
  },
];




const WellnessGym = () => {
    // //console.log('getting user goal');
    // //console.log(getUserGoal());

    const entries = []
    const [entryHTML, setEntryHTML] = useState(null);
    const [timerHTML, setTimerHTML] = useState(null);
    const [lastSubmitDate, setLastSubmitDate] = useState('');
    const [lastRelapseDate, setLastRelapseDate] = useState('');
    const [lastTitle, setLastTitle] = useState('');
    const [lastDescription, setLastDescription] = useState('');
    const [lastLesson, setLastLesson] = useState('');
    const [lastImpact, setLastImpact] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [gymWorkoutTab, setGymWorkoutTab] = useState('core');
    const user = getUser();
    const username = user !== 'undefined' && user ? user.username: '';
    const token = getToken();
    const goal = getUserGoal();
    const today = new Date()
    const navigate = useNavigate();
    let logHidden = true;

    const [currentQuestion, setCurrentQuestion] = useState(0);
    const [answers, setAnswers] = useState([]);
    const [showPopup, setShowPopup] = useState(false);
    const [showLearningPopup, setShowLearningPopup] = useState(false);
    const [learningContent, setLearningContent] = useState('');
    const [journalAudio, setAudio] = useState(null);
    const [dailyPromptText, setDailyPromptText] = useState('');
    const [dailyJournalBody, setDailyJournalBody] = useState('');
    const [motivationPrompts, setMotivationPrompts] = useState('');
    const [chat, setChat] = useState('')
    const [meditation, setMeditation] = useState('')
    const [journalEntry, setJournalEntry] = useState('')

    const [triggers, setTriggers] = useState([]);
    const [triggersLoading, setTriggersLoading] = useState(true);
    const [selectedTriggerId, setSelectedTriggerId] = useState(null);
    const [repFollowedThrough, setRepFollowedThrough] = useState(false);
    const [repSelFears, setRepSelFears] = useState([]);
    const [repSelBody, setRepSelBody] = useState([]);
    const [draftFear, setDraftFear] = useState('');
    const [draftBody, setDraftBody] = useState('');
    const [triggerStep, setTriggerStep] = useState(1);
    const [triggerDoneFollowedThrough, setTriggerDoneFollowedThrough] = useState(false);
    const [isEditingFears, setIsEditingFears] = useState(false);
    const [isEditingBody, setIsEditingBody] = useState(false);
    const [triggerFlowView, setTriggerFlowView] = useState('board');
    const [breathStartedAt, setBreathStartedAt] = useState(0);
    const [breathProgress, setBreathProgress] = useState(0);
    const [breathPhase, setBreathPhase] = useState('breathe in');
    const [repRevealStage, setRepRevealStage] = useState(0);
    const [newTriggerName, setNewTriggerName] = useState('');
    const [newTriggerOldPattern, setNewTriggerOldPattern] = useState('');
    const [newTriggerReplacement, setNewTriggerReplacement] = useState('');
    const [newTriggerAffirmation, setNewTriggerAffirmation] = useState('');
    const [newTriggerPillar, setNewTriggerPillar] = useState('Nervous System Regulation');

    const [nsrStep, setNsrStep] = useState(1);
    const [nsrActivationBefore, setNsrActivationBefore] = useState(5);
    const [nsrSignalsScan, setNsrSignalsScan] = useState([]);
    const [nsrDrill, setNsrDrill] = useState(null);
    const [nsrDrillCycles, setNsrDrillCycles] = useState(0);
    const [nsrDrillRunning, setNsrDrillRunning] = useState(false);
    const [nsrDrillRoundComplete, setNsrDrillRoundComplete] = useState(false);
    const [nsrDrillCycleCount, setNsrDrillCycleCount] = useState(0);
    const [nsrDrillPhaseLabel, setNsrDrillPhaseLabel] = useState('Inhale');
    const [nsrDrillScale, setNsrDrillScale] = useState(1);
    const [nsrActivationAfter, setNsrActivationAfter] = useState(5);
    const [nsrSignalsEarlier, setNsrSignalsEarlier] = useState([]);
    const [nsrWhenNoticedSlot, setNsrWhenNoticedSlot] = useState('');
    const [nsrWhenNoticedText, setNsrWhenNoticedText] = useState('');
    const nsrSessionStartedAtRef = useRef(0);
    const nsrDrillEngineRef = useRef({ phaseIdx: 0, cycle: 0, deadline: 0 });

    const [maStep, setMaStep] = useState(1);
    const [maSurface, setMaSurface] = useState('');
    const [maBehavior, setMaBehavior] = useState('');
    const [maProtectionLayer, setMaProtectionLayer] = useState('');
    const [maBeliefLevel, setMaBeliefLevel] = useState('');
    const [maValueLevel, setMaValueLevel] = useState('');
    const [maOriginLevel, setMaOriginLevel] = useState('');
    const [maIdentityLevel, setMaIdentityLevel] = useState('');
    const [maInflectionLevel, setMaInflectionLevel] = useState('');
    const [maNewBelief, setMaNewBelief] = useState('');
    const [maExLevel, setMaExLevel] = useState(1);
    const [maExPause, setMaExPause] = useState(false);
    const [maBuildingArc, setMaBuildingArc] = useState(false);
    const [maArcLogVisible, setMaArcLogVisible] = useState(false);
    const maSessionStartedAtRef = useRef(0);
    const maSessionLoggedRef = useRef(false);
    const maStepRef = useRef(1);
    const maExLevelRef = useRef(1);
    const maDurationsRef = useRef({ surface: 0, behavior: 0, protection: 0, excavation: 0, newBelief: 0 });
    const maSectionStartedAtRef = useRef(0);
    const maActiveSectionKeyRef = useRef(null);

    useEffect(() => {
        maStepRef.current = maStep;
    }, [maStep]);
    useEffect(() => {
        maExLevelRef.current = maExLevel;
    }, [maExLevel]);

    useEffect(() => {
        if (!maExPause) return undefined;
        const t = setTimeout(() => {
            setMaExPause(false);
            setMaExLevel(5);
        }, 1500);
        return () => clearTimeout(t);
    }, [maExPause]);

    useEffect(() => {
        if (!maBuildingArc) return undefined;
        const t = setTimeout(() => {
            setMaBuildingArc(false);
            setMaStep(6);
            setMaArcLogVisible(false);
        }, 2000);
        return () => clearTimeout(t);
    }, [maBuildingArc]);

    useEffect(() => {
        if (maStep !== 6) return undefined;
        setMaArcLogVisible(false);
        const t = setTimeout(() => setMaArcLogVisible(true), 1500);
        return () => clearTimeout(t);
    }, [maStep]);

    function maFlushActiveSection() {
        const key = maActiveSectionKeyRef.current;
        if (key && maDurationsRef.current[key] != null && maSectionStartedAtRef.current) {
            maDurationsRef.current[key] += Date.now() - maSectionStartedAtRef.current;
        }
        maSectionStartedAtRef.current = 0;
    }

    function maStartSection(key) {
        maFlushActiveSection();
        maActiveSectionKeyRef.current = key;
        maSectionStartedAtRef.current = Date.now();
    }

    function resetMaFlow() {
        setMaStep(1);
        setMaSurface('');
        setMaBehavior('');
        setMaProtectionLayer('');
        setMaBeliefLevel('');
        setMaValueLevel('');
        setMaOriginLevel('');
        setMaIdentityLevel('');
        setMaInflectionLevel('');
        setMaNewBelief('');
        setMaExLevel(1);
        setMaExPause(false);
        setMaBuildingArc(false);
        setMaArcLogVisible(false);
        maSessionStartedAtRef.current = 0;
        maSessionLoggedRef.current = false;
        maStepRef.current = 1;
        maExLevelRef.current = 1;
        maDurationsRef.current = { surface: 0, behavior: 0, protection: 0, excavation: 0, newBelief: 0 };
        maSectionStartedAtRef.current = 0;
        maActiveSectionKeyRef.current = null;
    }

    function submitMindsetSession({ abandoned = false } = {}) {
        maFlushActiveSection();
        const ts = Date.now();
        const started = maSessionStartedAtRef.current || ts;
        const screenDurations = { ...maDurationsRef.current };
        const abandonedAt = abandoned
            ? `step_${maStepRef.current}_ex_${maExLevelRef.current}${maExPause ? '_pause' : ''}`
            : null;
        const requestBody = {
            username,
            token,
            date: convertTimestampToFullDateString(ts),
            exerciseSubmission: withWorkoutTracking({
                content: '',
                mode: 'text',
                exercise_type: 'mindset_awareness_session',
                userId: username,
                timestamp: ts,
                sessionDuration: ts - started,
                surface: maSurface,
                behavior: maBehavior,
                protectionLayer: maProtectionLayer,
                beliefLevel: maBeliefLevel,
                valueLevel: maValueLevel,
                originLevel: maOriginLevel,
                identityLevel: maIdentityLevel,
                inflectionLevel: maInflectionLevel,
                newBelief: maNewBelief,
                screenDurations,
                abandonedAt,
            }, username),
        };
        axios.post(gymSubmitUrl, requestBody, { headers: apiKeyHeader }).catch((err) => {
            console.error('mindset awareness session submit failed', err);
        });
    }

    const [eceStep, setEceStep] = useState(1);
    const [eceGridX, setEceGridX] = useState(0.5);
    const [eceGridY, setEceGridY] = useState(0.5);
    const [eceGridPlaced, setEceGridPlaced] = useState(false);
    const [eceFeelingKey, setEceFeelingKey] = useState(null);
    const [eceUseCustomFeeling, setEceUseCustomFeeling] = useState(false);
    const [eceCustomFeeling, setEceCustomFeeling] = useState('');
    const [eceBodyZonesSel, setEceBodyZonesSel] = useState([]);
    const [eceReflectionText, setEceReflectionText] = useState('');
    const eceGridRef = useRef(null);
    const eceGridDraggingRef = useRef(false);
    const eceSessionStartedAtRef = useRef(0);
    const eceSessionLoggedRef = useRef(false);
    const eceStepRef = useRef(1);

    useEffect(() => {
        eceStepRef.current = eceStep;
    }, [eceStep]);

    function resetEceFlow() {
        setEceStep(1);
        setEceGridX(0.5);
        setEceGridY(0.5);
        setEceGridPlaced(false);
        setEceFeelingKey(null);
        setEceUseCustomFeeling(false);
        setEceCustomFeeling('');
        setEceBodyZonesSel([]);
        setEceReflectionText('');
        eceGridDraggingRef.current = false;
        eceSessionStartedAtRef.current = 0;
        eceSessionLoggedRef.current = false;
        eceStepRef.current = 1;
    }

    function submitEceSession({ abandoned = false } = {}) {
        const ts = Date.now();
        const started = eceSessionStartedAtRef.current || ts;
        const feeling =
            eceUseCustomFeeling && eceCustomFeeling.trim()
                ? eceCustomFeeling.trim()
                : eceFeelingKey || '';
        const quadrant = eceGetQuadrant(eceGridX, eceGridY);
        const abandonedAt = abandoned ? `step_${eceStepRef.current}` : null;
        const requestBody = {
            username,
            token,
            date: convertTimestampToFullDateString(ts),
            exerciseSubmission: withWorkoutTracking({
                content: '',
                mode: 'text',
                exercise_type: 'emotional_capacity_expression_session',
                userId: username,
                timestamp: ts,
                gridPosition: { x: eceGridX, y: eceGridY },
                quadrant,
                feelingWord: feeling,
                bodyZones: eceBodyZonesSel,
                reflectionText: eceReflectionText.trim() || undefined,
                sessionDuration: ts - started,
                abandonedAt,
            }, username),
        };
        axios.post(gymSubmitUrl, requestBody, { headers: apiKeyHeader }).catch((err) => {
            console.error('emotional capacity session submit failed', err);
        });
    }

    function eceCurrentFeelingWord() {
        if (eceUseCustomFeeling) return eceCustomFeeling.trim();
        return (eceFeelingKey || '').trim();
    }

    function eceUpdateGridFromClient(clientX, clientY) {
        const el = eceGridRef.current;
        if (!el) return;
        const rect = el.getBoundingClientRect();
        const x = Math.min(Math.max((clientX - rect.left) / rect.width, 0), 1);
        const y = Math.min(Math.max((clientY - rect.top) / rect.height, 0), 1);
        setEceGridX(x);
        setEceGridY(y);
        setEceGridPlaced(true);
    }

    const [rrStep, setRrStep] = useState(1);
    const [rrHeadline, setRrHeadline] = useState('');
    const [rrLearningExtracted, setRrLearningExtracted] = useState('');
    const [rrIdentityReflection, setRrIdentityReflection] = useState('');
    const [rrValuesAlignment, setRrValuesAlignment] = useState('');
    const [rrValuesAlignmentResponse, setRrValuesAlignmentResponse] = useState('');
    const [rrExtractBeatVisible, setRrExtractBeatVisible] = useState(true);
    const [rrValuesBeatVisible, setRrValuesBeatVisible] = useState(true);
    const [rrSettleProgress, setRrSettleProgress] = useState(0);
    const [rrSettlePhase, setRrSettlePhase] = useState('Breathe in');
    const [rrSettleDone, setRrSettleDone] = useState(false);
    const [rrSettleCloseVisible, setRrSettleCloseVisible] = useState(false);
    const [rrSettleCtaVisible, setRrSettleCtaVisible] = useState(false);
    const rrSessionStartedAtRef = useRef(0);
    const rrSessionLoggedRef = useRef(false);
    const rrStepRef = useRef(1);
    const rrDurationsRef = useRef({ name_it: 0, extract_data: 0, identity_close: 0, values_check: 0, settle: 0 });
    const rrScreenStartedAtRef = useRef(0);
    const rrActiveScreenRef = useRef(null);

    const [cccStep, setCccStep] = useState(1);
    const [cccStoryId, setCccStoryId] = useState('');
    const [cccMoment, setCccMoment] = useState('');
    const [cccBeatPhase, setCccBeatPhase] = useState(1);
    const [cccBeatSetup, setCccBeatSetup] = useState('');
    const [cccBeatTurn, setCccBeatTurn] = useState('');
    const [cccBeatMeaning, setCccBeatMeaning] = useState('');
    const [cccReflectPhase, setCccReflectPhase] = useState('read');
    const [cccLeftOut, setCccLeftOut] = useState('');
    const [cccTrusted, setCccTrusted] = useState('');
    const cccSessionStartedAtRef = useRef(0);
    const cccSessionLoggedRef = useRef(false);
    const [exposureChallenges, setExposureChallenges] = useState([]);
    const [exposureSessions, setExposureSessions] = useState([]);
    const [exposureLoading, setExposureLoading] = useState(false);
    const [exposureView, setExposureView] = useState('board');
    const [selectedExposureChallengeId, setSelectedExposureChallengeId] = useState('');
    const [exposureShowDisclaimer, setExposureShowDisclaimer] = useState(false);
    const [exposureCreateStep, setExposureCreateStep] = useState(1);
    const [exposureNameInput, setExposureNameInput] = useState('');
    const [exposureFearInput, setExposureFearInput] = useState('');
    const [exposureWhyInput, setExposureWhyInput] = useState('');
    const [exposureRepWhat, setExposureRepWhat] = useState('');
    const [exposureRepOutcome, setExposureRepOutcome] = useState('');
    const [exposureActivationBefore, setExposureActivationBefore] = useState(5);
    const [exposureActivationDuring, setExposureActivationDuring] = useState(5);
    const [exposureActivationAfter, setExposureActivationAfter] = useState(5);
    const [exposureActivationTouched, setExposureActivationTouched] = useState({ before: false, during: false, after: false });
    const [exposureLogText, setExposureLogText] = useState('');
    const [exposureBeliefFrom, setExposureBeliefFrom] = useState('');
    const [exposureBeliefTo, setExposureBeliefTo] = useState('');
    const [exposureRepStep, setExposureRepStep] = useState(1);
    const [exposureOutcomeTouched, setExposureOutcomeTouched] = useState(false);
    const [exposureRepCompleteSnapshot, setExposureRepCompleteSnapshot] = useState(null);
    const exposureTimerStartedAtRef = useRef(0);
    const exposureRepSessionLoggedRef = useRef(false);
    const [exposureNowTick, setExposureNowTick] = useState(0);

    useEffect(() => {
        rrStepRef.current = rrStep;
    }, [rrStep]);

    useEffect(() => {
        if (currentQuestion !== 11 || exposureRepStep !== 2) return undefined;
        const timer = setInterval(() => setExposureNowTick(Date.now()), 500);
        return () => clearInterval(timer);
    }, [currentQuestion, exposureRepStep]);

    useEffect(() => {
        if (rrStep !== 2 || !rrExtractBeatVisible) return undefined;
        const t = setTimeout(() => setRrExtractBeatVisible(false), 1500);
        return () => clearTimeout(t);
    }, [rrStep, rrExtractBeatVisible]);

    useEffect(() => {
        if (rrStep !== 4 || !rrValuesBeatVisible) return undefined;
        const t = setTimeout(() => setRrValuesBeatVisible(false), 1000);
        return () => clearTimeout(t);
    }, [rrStep, rrValuesBeatVisible]);

    useEffect(() => {
        if (rrStep !== 5 || rrSettleDone) return undefined;
        const startedAt = Date.now();
        setRrSettleProgress(0);
        setRrSettlePhase('Breathe in');
        setRrSettleCloseVisible(false);
        setRrSettleCtaVisible(false);
        const i = setInterval(() => {
            const elapsed = Date.now() - startedAt;
            const pct = Math.min((elapsed / 6000) * 100, 100);
            setRrSettleProgress(pct);
            setRrSettlePhase(elapsed < 3000 ? 'Breathe in' : 'Breathe out');
            if (elapsed >= 6000) {
                clearInterval(i);
                setRrSettleDone(true);
                setRrSettleCloseVisible(true);
                setTimeout(() => setRrSettleCtaVisible(true), 1000);
            }
        }, 80);
        return () => clearInterval(i);
    }, [rrStep, rrSettleDone]);

    function rrScreenForStep(step = rrStepRef.current) {
        if (step === 1) return 'name_it';
        if (step === 2) return 'extract_data';
        if (step === 3) return 'identity_close';
        if (step === 4) return 'values_check';
        if (step === 5) return 'settle';
        return null;
    }

    function rrFlushScreenDuration() {
        const key = rrActiveScreenRef.current;
        if (key && rrDurationsRef.current[key] != null && rrScreenStartedAtRef.current) {
            rrDurationsRef.current[key] += Date.now() - rrScreenStartedAtRef.current;
        }
        rrScreenStartedAtRef.current = 0;
    }

    function rrStartScreen(key) {
        rrFlushScreenDuration();
        rrActiveScreenRef.current = key;
        rrScreenStartedAtRef.current = Date.now();
    }

    function handle_submit_gym_exercise(exerciseSubmission) {
        const ts = Date.now();
        const requestBody = {
            username,
            token,
            date: convertTimestampToFullDateString(ts),
            exerciseSubmission: withWorkoutTracking(exerciseSubmission, username),
        };
        axios.post(gymSubmitUrl, requestBody, { headers: apiKeyHeader }).catch((err) => {
            console.error('resilience reframe submit failed', err);
        });
    }

    function submitResilienceSession({ abandoned = false } = {}) {
        rrFlushScreenDuration();
        const ts = Date.now();
        const started = rrSessionStartedAtRef.current || ts;
        const payload = {
            content: '',
            mode: 'text',
            exercise_type: 'resilience_reframe',
            event_headline: rrHeadline.trim(),
            learning_extracted: rrLearningExtracted.trim(),
            identity_reflection: rrIdentityReflection.trim(),
            values_alignment: rrValuesAlignment || '',
            values_alignment_response: rrValuesAlignmentResponse || '',
            completed_settle: !!rrSettleDone,
            session_duration: ts - started,
            screen_durations: { ...rrDurationsRef.current },
            abandoned_at: abandoned ? rrScreenForStep() : null,
            timestamp: ts,
            userId: username,
        };
        handle_submit_gym_exercise(payload);
    }

    function resetResilienceFlow() {
        setRrStep(1);
        setRrHeadline('');
        setRrLearningExtracted('');
        setRrIdentityReflection('');
        setRrValuesAlignment('');
        setRrValuesAlignmentResponse('');
        setRrExtractBeatVisible(true);
        setRrValuesBeatVisible(true);
        setRrSettleProgress(0);
        setRrSettlePhase('Breathe in');
        setRrSettleDone(false);
        setRrSettleCloseVisible(false);
        setRrSettleCtaVisible(false);
        rrSessionStartedAtRef.current = 0;
        rrSessionLoggedRef.current = false;
        rrStepRef.current = 1;
        rrDurationsRef.current = { name_it: 0, extract_data: 0, identity_close: 0, values_check: 0, settle: 0 };
        rrScreenStartedAtRef.current = 0;
        rrActiveScreenRef.current = null;
    }

    function resetConnectionCommFlow() {
        setCccStep(1);
        setCccStoryId('');
        setCccMoment('');
        setCccBeatPhase(1);
        setCccBeatSetup('');
        setCccBeatTurn('');
        setCccBeatMeaning('');
        setCccReflectPhase('read');
        setCccLeftOut('');
        setCccTrusted('');
        cccSessionStartedAtRef.current = 0;
        cccSessionLoggedRef.current = false;
    }

    function exposureHydrate() {
        try {
            const rawChallenges = localStorage.getItem(EXPOSURE_CHALLENGES_STORAGE_KEY);
            const rawSessions = localStorage.getItem(EXPOSURE_SESSIONS_STORAGE_KEY);
            setExposureChallenges(rawChallenges ? JSON.parse(rawChallenges) : []);
            setExposureSessions(rawSessions ? JSON.parse(rawSessions) : []);
        } catch (err) {
            setExposureChallenges([]);
            setExposureSessions([]);
        }
    }

    function persistExposureData(challenges, sessions) {
        localStorage.setItem(EXPOSURE_CHALLENGES_STORAGE_KEY, JSON.stringify(challenges));
        localStorage.setItem(EXPOSURE_SESSIONS_STORAGE_KEY, JSON.stringify(sessions));
    }

    function resetExposureFlow() {
        setExposureView('board');
        setSelectedExposureChallengeId('');
        setExposureShowDisclaimer(false);
        setExposureCreateStep(1);
        setExposureNameInput('');
        setExposureFearInput('');
        setExposureWhyInput('');
        setExposureRepWhat('');
        setExposureRepOutcome('');
        setExposureActivationBefore(5);
        setExposureActivationDuring(5);
        setExposureActivationAfter(5);
        setExposureActivationTouched({ before: false, during: false, after: false });
        setExposureLogText('');
        setExposureBeliefFrom('');
        setExposureBeliefTo('');
        setExposureRepStep(1);
        setExposureOutcomeTouched(false);
        setExposureRepCompleteSnapshot(null);
        exposureTimerStartedAtRef.current = 0;
        exposureRepSessionLoggedRef.current = false;
        setExposureNowTick(0);
    }

    function openExposureCreateFlow() {
        const seen = localStorage.getItem(EXPOSURE_DISCLAIMER_SEEN_KEY) === '1';
        setExposureShowDisclaimer(!seen);
        setExposureCreateStep(1);
        setExposureNameInput('');
        setExposureFearInput('');
        setExposureWhyInput('');
        setExposureView('create');
    }

    function saveExposureChallenge() {
        const now = Date.now();
        const challenge = {
            id: `challenge-${now}`,
            userId: username,
            name: exposureNameInput.trim().slice(0, 80),
            fearStatement: exposureFearInput.trim().slice(0, 140),
            why: exposureWhyInput.trim().slice(0, 140),
            repCount: 0,
            lastTrainedAt: null,
            firstRepCompleted: false,
            createdAt: now,
        };
        if (!challenge.name || !challenge.fearStatement || !challenge.why) return;
        const nextChallenges = [challenge, ...exposureChallenges];
        persistExposureData(nextChallenges, exposureSessions);
        setExposureChallenges(nextChallenges);
        setSelectedExposureChallengeId(challenge.id);
        setExposureView('detail');
    }

    function openExposureRepForChallenge(challengeId) {
        const ch = exposureChallenges.find((c) => c.id === challengeId);
        if (!ch) return;
        setSelectedExposureChallengeId(challengeId);
        setExposureRepWhat('');
        setExposureRepOutcome('');
        setExposureActivationBefore(5);
        setExposureActivationDuring(5);
        setExposureActivationAfter(5);
        setExposureActivationTouched({ before: false, during: false, after: false });
        setExposureLogText('');
        setExposureBeliefFrom('');
        setExposureBeliefTo('');
        setExposureOutcomeTouched(false);
        setExposureRepCompleteSnapshot(null);
        if (!ch.firstRepCompleted) {
            setExposureRepStep(1.5);
        } else {
            setExposureRepStep(2);
            exposureTimerStartedAtRef.current = Date.now();
            setExposureNowTick(Date.now());
        }
        setExposureView('rep');
    }

    function submitExposureRep() {
        const challenge = exposureChallenges.find((c) => c.id === selectedExposureChallengeId);
        if (!challenge) return;
        const ts = Date.now();
        const durationSeconds = Math.max(0, Math.floor((ts - (exposureTimerStartedAtRef.current || ts)) / 1000));
        const activationArc = `${exposureActivationBefore}→${exposureActivationDuring}→${exposureActivationAfter}`;
        const repSession = {
            id: `rep-${ts}`,
            challengeId: challenge.id,
            userId: username,
            whatTheyDid: exposureRepWhat.trim().slice(0, 120),
            outcome: exposureRepOutcome,
            activationBefore: exposureActivationBefore,
            activationDuring: exposureActivationDuring,
            activationAfter: exposureActivationAfter,
            activationArc,
            logText: exposureLogText.trim().slice(0, 300),
            beliefFrom: exposureBeliefFrom.trim().slice(0, 100),
            beliefTo: exposureBeliefTo.trim().slice(0, 100),
            repDurationSeconds: durationSeconds,
            timestamp: ts,
        };
        const nextSessions = [repSession, ...exposureSessions];
        const nextChallenges = exposureChallenges.map((c) =>
            c.id === challenge.id
                ? {
                      ...c,
                      repCount: Number(c.repCount || 0) + 1,
                      lastTrainedAt: ts,
                      firstRepCompleted: true,
                  }
                : c
        );
        persistExposureData(nextChallenges, nextSessions);
        setExposureSessions(nextSessions);
        setExposureChallenges(nextChallenges);
        setExposureRepCompleteSnapshot({
            outcome: exposureRepOutcome,
            repCount: Number(challenge.repCount || 0) + 1,
            challengeId: challenge.id,
        });
        handle_submit_gym_exercise({
            content: '',
            mode: 'text',
            exercise_type: 'exposure_training_rep',
            ...repSession,
        });
        exposureRepSessionLoggedRef.current = true;
        setExposureRepStep(5);
    }

    function submitConnectionCommSession({ abandoned = false, completed = false } = {}) {
        const ts = Date.now();
        const started = cccSessionStartedAtRef.current || ts;
        const payload = {
            content: '',
            mode: 'text',
            exercise_type: 'connection_communication_story',
            userId: username,
            storyCategory: cccStoryId || '',
            specificMoment: cccMoment.trim(),
            beatSetup: cccBeatSetup.trim(),
            beatTurn: cccBeatTurn.trim(),
            beatMeaning: cccBeatMeaning.trim(),
            leftOut: cccLeftOut.trim() || undefined,
            trustedVersion: cccTrusted.trim() || undefined,
            sessionDuration: ts - started,
            sessionDurationMs: ts - started,
            abandoned_at: abandoned ? `step_${cccStep}` : null,
            completed,
            timestamp: ts,
        };
        handle_submit_gym_exercise(payload);
    }

    function cccStepBack() {
        if (cccStep <= 1) return;
        if (cccStep === 2) {
            setCccStep(1);
            return;
        }
        if (cccStep === 3) {
            if (cccBeatPhase > 1) {
                setCccBeatPhase((p) => p - 1);
                return;
            }
            setCccStep(2);
            return;
        }
        if (cccStep === 4) {
            if (cccReflectPhase === 'questions') {
                setCccReflectPhase('read');
                return;
            }
            setCccStep(3);
            setCccBeatPhase(3);
            return;
        }
        if (cccStep === 5) {
            setCccStep(4);
            setCccReflectPhase('questions');
        }
    }

    function resetNsrFlow() {
        setNsrStep(1);
        setNsrActivationBefore(5);
        setNsrSignalsScan([]);
        setNsrDrill(null);
        setNsrDrillCycles(0);
        setNsrDrillRunning(false);
        setNsrDrillRoundComplete(false);
        setNsrDrillCycleCount(0);
        setNsrDrillPhaseLabel('Inhale');
        setNsrDrillScale(1);
        setNsrActivationAfter(5);
        setNsrSignalsEarlier([]);
        setNsrWhenNoticedSlot('');
        setNsrWhenNoticedText('');
        nsrSessionStartedAtRef.current = 0;
        nsrDrillEngineRef.current = { phaseIdx: 0, cycle: 0, deadline: 0 };
    }

    function submitNsrSession() {
        const ts = Date.now();
        const started = nsrSessionStartedAtRef.current || ts;
        const requestBody = {
            username,
            token,
            date: convertTimestampToFullDateString(ts),
            exerciseSubmission: withWorkoutTracking({
                content: '',
                mode: 'text',
                exercise_type: 'nervous_system_regulation_session',
                userId: username,
                activationBefore: nsrActivationBefore,
                activationAfter: nsrActivationAfter,
                drillSelected: nsrDrill,
                drillCycles: nsrDrillCycles,
                signalsBefore: nsrSignalsScan,
                signalsAfter: nsrSignalsEarlier,
                signalTimeOfDay: [nsrWhenNoticedSlot, nsrWhenNoticedText].filter(Boolean).join(' · ') || '',
                timestamp: ts,
                sessionDurationMs: ts - started,
            }, username),
        };
        axios.post(gymSubmitUrl, requestBody, { headers: apiKeyHeader }).catch((err) => {
            console.error('nsr session submit failed', err);
        });
    }

    function nsrBeginDrillRound() {
        if (!nsrDrill) return;
        const phases = nsrDrill === 'box' ? NSR_BOX_PHASES : NSR_EXT_PHASES;
        const now = Date.now();
        nsrDrillEngineRef.current = { phaseIdx: 0, cycle: 0, deadline: now + phases[0].ms };
        setNsrDrillCycleCount(0);
        setNsrDrillPhaseLabel(phases[0].label);
        setNsrDrillScale(phases[0].scale);
        setNsrDrillRoundComplete(false);
        setNsrDrillRunning(true);
    }

    function nsrStepBack() {
        if (nsrStep === 1) return;
        if (nsrStep === 4 && nsrDrillRunning && !nsrDrillRoundComplete) return;
        if (nsrStep === 4) {
            setNsrDrillRunning(false);
            setNsrDrillRoundComplete(false);
            setNsrStep(3);
            return;
        }
        setNsrStep((s) => s - 1);
    }

    useEffect(() => {
        if (currentQuestion !== 6 || nsrStep !== 4 || !nsrDrill || !nsrDrillRunning || nsrDrillRoundComplete) return undefined;
        const phases = nsrDrill === 'box' ? NSR_BOX_PHASES : NSR_EXT_PHASES;
        const id = setInterval(() => {
            const now = Date.now();
            let { phaseIdx, cycle, deadline } = nsrDrillEngineRef.current;
            if (now < deadline) return;
            phaseIdx += 1;
            if (phaseIdx >= phases.length) {
                phaseIdx = 0;
                cycle += 1;
                if (cycle >= 3) {
                    setNsrDrillRoundComplete(true);
                    setNsrDrillRunning(false);
                    setNsrDrillCycles((c) => c + 1);
                    clearInterval(id);
                    return;
                }
            }
            deadline = now + phases[phaseIdx].ms;
            nsrDrillEngineRef.current = { phaseIdx, cycle, deadline };
            setNsrDrillCycleCount(cycle);
            setNsrDrillPhaseLabel(phases[phaseIdx].label);
            setNsrDrillScale(phases[phaseIdx].scale);
        }, 80);
        return () => clearInterval(id);
    }, [currentQuestion, nsrStep, nsrDrill, nsrDrillRunning, nsrDrillRoundComplete]);

    function persistTriggerPatch(triggerId, patch) {
        axios
            .post(
                triggerLibraryUpdateUrl,
                {
                    username,
                    token,
                    triggerId,
                    ...patch,
                },
                { headers: apiKeyHeader }
            )
            .catch((err) => {
                console.error('triggerLibraryUpdate failed', err);
            });
    }

    /** Same endpoint and envelope as handleSubmitGymExercises; does not alter that handler. */
    function submitTriggerRep(followedThroughValue) {
        if (!selectedTriggerId) return;
        setErrorMessage(null);
        const ts = Date.now();
        const requestBody = {
            username,
            token,
            date: convertTimestampToFullDateString(ts),
            exerciseSubmission: withWorkoutTracking({
                content: '',
                mode: 'text',
                exercise_type: 'trigger_rep',
                trigger_id: selectedTriggerId,
                followed_through: !!followedThroughValue,
                selected_fears: repSelFears,
                selected_body_sensations: repSelBody,
                timestamp: ts,
            }, username),
        };
        axios
            .post(gymSubmitUrl, requestBody, { headers: apiKeyHeader })
            .catch((error) => {
                console.error('trigger rep submit', error);
                if (error === undefined || error === null || error === '') {
                    setErrorMessage('Sorry the server is down. Please try again later.');
                    return;
                }
                if (error.response && (error.response.status === 401 || error.response.status === 403)) {
                    setErrorMessage(error.response.data.message);
                } else {
                    setErrorMessage('Sorry the server is down. Please try again later.');
                }
            });
    }

    function openTriggerStep(nextStep) {
        setTriggerStep(nextStep);
        if (nextStep === 4) {
            setBreathStartedAt(Date.now());
            setBreathProgress(0);
            setBreathPhase('breathe in');
            setRepRevealStage(0);
        }
    }

    function resetTriggerFlowState() {
        setTriggerStep(1);
        setTriggerFlowView('board');
        setRepSelFears([]);
        setRepSelBody([]);
        setDraftFear('');
        setDraftBody('');
        setIsEditingFears(false);
        setIsEditingBody(false);
        setRepFollowedThrough(false);
        setBreathProgress(0);
        setBreathPhase('breathe in');
        setRepRevealStage(0);
    }

    useEffect(() => {
        let cancelled = false;
        setTriggersLoading(true);
        axios
            .post(triggerLibraryFetchUrl, { username, token }, { headers: apiKeyHeader })
            .then(({ data }) => {
                if (cancelled) return;
                const list = normalizeTriggersFromResponse(data);
                if (list.length) {
                    setTriggers(list);
                } else {
                    setTriggers(SEED_TRIGGERS);
                }
            })
            .catch(() => {
                if (!cancelled) setTriggers(SEED_TRIGGERS);
            })
            .finally(() => {
                if (!cancelled) setTriggersLoading(false);
            });
        return () => {
            cancelled = true;
        };
    }, [username, token]);

    useEffect(() => {
        if (!triggers.length) return;
        setSelectedTriggerId((prev) => (prev && triggers.some((t) => t.id === prev) ? prev : triggers[0].id));
    }, [triggers]);

    useEffect(() => {
        setRepFollowedThrough(false);
        setRepSelFears([]);
        setRepSelBody([]);
    }, [selectedTriggerId]);

    useEffect(() => {
        if (triggerStep !== 4 || triggerFlowView !== 'board') return undefined;
        const totalMs = 10000;
        const timer = setInterval(() => {
            const elapsed = Date.now() - breathStartedAt;
            const pct = Math.max(0, Math.min(100, (elapsed / totalMs) * 100));
            setBreathProgress(pct);
            if (elapsed < 4000) setBreathPhase('breathe in');
            else if (elapsed < 6000) setBreathPhase('hold');
            else setBreathPhase('breathe out');
            if (elapsed >= totalMs) {
                clearInterval(timer);
                setRepRevealStage(1);
            }
        }, 80);
        return () => clearInterval(timer);
    }, [triggerStep, triggerFlowView, breathStartedAt]);

    const relapseHandler = (event) => {
        event.preventDefault();
        navigate('/relapse');

    }

    function handleAudioState(newValue) {
        setAudio(newValue);
    }

    const handleEditPrompt = () => {
        //console.log('editing prompt...')
        document.getElementsByClassName("dailyAudioJournal")[0].style.display =  "none"
        document.getElementsByClassName("audioJournalEdit")[0].style.display =  "flex"
        document.getElementsByClassName("editPromptBttn")[0].style.display =  "none"
        document.getElementsByClassName("doneEditPromptBttn")[0].style.display =  "flex"
    };

    const handleDoneEditPrompt = () => {
        //console.log('editing prompt...')
        document.getElementsByClassName("dailyAudioJournal")[0].style.display =  "flex"
        document.getElementsByClassName("audioJournalEdit")[0].style.display =  "none"
        document.getElementsByClassName("editPromptBttn")[0].style.display =  "flex"
        document.getElementsByClassName("doneEditPromptBttn")[0].style.display =  "none"
    };

    const handleWrittenMode = () => {
        //console.log('editing prompt...')
        document.getElementsByClassName("audioJournalUI")[0].style.display =  "none"
        document.getElementsByClassName("writtenJournalUI")[0].style.display =  "block"
        document.getElementsByClassName("writtenJournalUIBttn")[0].style.display =  "none"
        document.getElementsByClassName("audioJournalUIBttn")[0].style.display =  "block"
    };

    const handleAudioMode = () => {
        //console.log('editing prompt...')
        document.getElementsByClassName("audioJournalUI")[0].style.display =  "block"
        document.getElementsByClassName("writtenJournalUI")[0].style.display =  "none"
        document.getElementsByClassName("writtenJournalUIBttn")[0].style.display =  "block"
        document.getElementsByClassName("audioJournalUIBttn")[0].style.display =  "none"    };

    function handleDailyJournalPrompt(newValue) {
        // let newDailyPrompt = dailyPrompt
        // newDailyPrompt.previousPrompt = newDailyPrompt.textcontent
        // newDailyPrompt.textcontent = newValue
        // newDailyPrompt.status = 'updated'
        // setDailyPrompt(newDailyPrompt);
        setDailyPromptText(newValue);
        // setUserGoal({ "textcontent": dailyGoalTitle, "notifications": dailyGoalNotification})
    }

    function handleJournalEntry(newValue) {
        // let newDailyPrompt = dailyPrompt
        // newDailyPrompt.previousPrompt = newDailyPrompt.textcontent
        // newDailyPrompt.textcontent = newValue
        // newDailyPrompt.status = 'updated'
        // setDailyPrompt(newDailyPrompt);
        setJournalEntry(newValue);
        // setUserGoal({ "textcontent": dailyGoalTitle, "notifications": dailyGoalNotification})
    }

    const formatTime = (seconds) => {
        const mins = Math.floor(seconds / 60);
        const secs = Math.floor(seconds % 60);
        return `${mins}:${secs < 10 ? '0' : ''}${secs}`;
    };


    // const expandLog = () => {
    //     //console.log('clicked yo')
    //     if(logHidden){
    //         document.querySelector('#pastProblematicLog').classList.remove('display-none')
    //         document.querySelector('#logBttn').innerText = "Hide Past Problematc Use"
    //         logHidden = false
    //     }
    //     else{
    //         document.querySelector('#pastProblematicLog').classList.add('display-none')
    //         document.querySelector('#logBttn').innerText = "Show Past Problematc Use"
    //         logHidden = true
    //     }
    // }

    const audioRef = useRef(null);
    const [isPlaying, setIsPlaying] = useState(false);
    const [currentTime, setCurrentTime] = useState(0);
    const [duration, setDuration] = useState(0);

    const togglePlay = () => {
        const audio = audioRef.current;
        if (!audio) return;

        if (isPlaying) {
            audio.pause();
        } else {
            audio.play();
        }
        setIsPlaying(!isPlaying);
        alert(!isPlaying)
    };

    const stopAudio = () => {
        const audio = audioRef.current;
        if (!audio) return;
        audio.pause();
        audio.currentTime = 0;
        setIsPlaying(false);
    };

    const handleSeek = (e) => {
    const audio = audioRef.current;
    if (!audio) return;
    const time = parseFloat(e.target.value);
    audio.currentTime = time;
    };

    const [useTextJournal, setUseTextJournal] = useState(false); // false = audio by default
    const [writtenEntry, setWrittenEntry] = useState('');

    const handleSaveWrittenEntry = () => {
        if (!writtenEntry.trim()) return;
        console.log('Saved written journal:', writtenEntry);
        // Save to backend or state
    };
    const controlButtonStyle = {
        background: 'none',
        border: 'none',
        fontSize: '1.5rem',
        cursor: 'pointer',
        color: '#333',
        padding: '0.5rem',
        };

        const rewindAudio = () => {
        if (audioRef.current) {
            audioRef.current.currentTime = Math.max(0, audioRef.current.currentTime - 10); // go back 10s
        }
        };

        const forwardAudio = () => {
        if (audioRef.current) {
            audioRef.current.currentTime = Math.min(duration, audioRef.current.currentTime + 10); // go forward 10s
        }
        };

    async function fetchRelapseLog(){
         // do stuff here...
        //console.log('fetching the relapse log :)')
        //TODO: move this to an environment variable
        const requestConfig = {
            headers: {
                'x-api-key': 'mCQrNSvy7X5AUdJlF2ybc3LdEFGndN885kzttyvB'
            }
        }

        //console.log('here ; wath')

        const moduleParams = {
            mode: 'default'
        };

        //console.log('pre request object <3: ')
        const requestBody = {
            username: user.username,
            token: token,
            module: moduleParams,
        }

        //console.log('request object: ', requestBody)
        setDailyPromptText('What situation keeps repeating in your life? What do you think it’s trying to teach you?')

        setDailyJournalBody(
            <div className="learningFeedback wellnessGymMeditationFlow" style={{ maxHeight: '100%' }}>
                <div className="audioJournal wellnessGymJournalShell">
                    {/* <div className="relapseQuestion">When you will complete the goal by</div> */}
                    {/* <div className="audioJournalEdit">
                        <div className="relapseQuestion" style={{ marginTop: '1rem'}}>Suggested Daily Prompt</div>
                        <DailyPromptTextField id="dailyPrompt" name="dailyPrompt" label="Set Prompt" defaultValue={content.journal.content.textcontent} handleChange={handleDailyJournalPrompt} value={dailyPromptText} />
                    </div> */}
                    <div className="relapseQuestion wellnessGymPromptBlock"> 
                        <div className="wellnessGymPromptToolbar">
                            <div className="wellnessGymPromptLabel">Prompt:</div>
                            <button
                                className="editPromptBttn wellnessGymPromptButton" 
                                onClick={handleEditPrompt}
                                >
                                {/* <img
                                    className="editBttn"
                                    src={editBttn}
                                    alt="edit"
                                    style={{ height: '16px', width: '16px' }}
                                /> */}
                                <div>Edit</div>
                            </button>
                            <button
                                className="doneEditPromptBttn wellnessGymPromptButton" 
                                onClick={handleDoneEditPrompt}
                                style={{ display: 'none' }}
                                >
                                {/* <img
                                    className="editBttn"
                                    src={editBttn}
                                    alt="edit"
                                    style={{ height: '16px', width: '16px' }}
                                /> */}
                                <div>Done</div>
                            </button>

                            {/* Toggle Button for Written Mode */}
                            <button
                                className="writtenJournalUIBttn wellnessGymPromptButton" 
                                onClick={handleWrittenMode}
                                >
                                Write
                            </button>
                            <button
                                className="audioJournalUIBttn wellnessGymPromptButton" 
                                onClick={handleAudioMode}
                                style={{ display: 'none' }}
                                >
                                Audio
                            </button>
                        </div>
                        <div className="dailyAudioJournal wellnessGymPromptText">{ 'What situation keeps repeating in your life? What do you think it’s trying to teach you?' } </div>
                        <div className="audioJournalEdit" style={{ display: 'none'}}>
                            {/* <div className="relapseQuestion" style={{ marginTop: '1rem'}}>Update daily prompt</div> */}
                            <DailyPromptTextField rows="2" label="Update Prompt" defaultValue={"What situation keeps repeating in your life? What do you think it’s trying to teach you?"} handleChange={handleDailyJournalPrompt} />
                        </div>
                    </div>
                    {/* <div>
                        <div className="relapseQuestion" style={{ marginTop: '1.6rem'}}>Suggested daily prompt</div>
                        <MateriaBasicTextField label="Set Prompt" defaultValue={content.journal.content.textcontent} handleChange={handleDailyGoalTitle} />
                    </div> */}
                    {/* <div> <AudioRecorder saveAudio= {handleAudioState} /> </div>   */}
                    <div className="writtenJournalUI" style={{ display: 'none', width: '100%' }}>
                        <div style={{ marginTop: '1rem' }}>
                            {/* <textarea
                                value={writtenEntry}
                                onChange={(e) => setWrittenEntry(e.target.value)}
                                placeholder="Write your thoughts hereeeee..."
                                rows={3}
                                style={{
                                    width: '80%',
                                    minHeight: '100px',
                                    padding: '1rem',
                                    fontSize: '1rem',
                                    borderRadius: '0.5rem',
                                    border: '1px solid #ccc',
                                }}
                            /> */}
                            <WellnessGymJournalEntry rows="3" label="Journal Entry" defaultValue={"Dive deeper. Use the 5 whys."} handleChange={handleJournalEntry} />
                        </div>

                    </div>
                    <div className="audioJournalUI">
                        <div style={{ marginTop: '2rem' }}>
                            <AudioRecorder saveAudio={handleAudioState} />
                            </div>
                    </div>
                    {/* Toggle Button / Text Mode */}
                    {/* <button
                        onClick={() => setShowTextJournal(!showTextJournal)}
                        className="w-full px-4 py-2 text-white bg-red-500 rounded-md hover:bg-red-600 transition"
                    >
                        {showTextJournal ? "Cancel Text Journal" : "Too loud to record?"}
                    </button>
                    {showTextJournal && (
                        <div className="mt-4 p-4 border rounded-md bg-gray-100">
                        <textarea
                            className="w-full p-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-400"
                            placeholder="Write your thoughts here..."
                            value={textJournal}
                            onChange={handleTextChange}
                            rows="4"
                        ></textarea>

                        <button
                            className="mt-2 w-full px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 transition"
                        >
                            Save Journal Entry
                        </button>
                        </div>
                    )}                  */}
                </div>
                {/* <div className="audioJournalEdit"  style={{ display: 'none'}}>
                    <div>
                        <div className="relapseQuestion" style={{ marginTop: '1.6rem'}}>Suggested daily prompt</div>
                        <MateriaBasicTextField label="Set Prompt" defaultValue={content.journal.content.textcontent} handleChange={handleDailyJournalPrompt} />
                    </div>
                    <div className="formBttnContainer" >
                        <button className="popupButton" style={{ marginBottom: '1rem'}} onClick={handleUpdatePrompt} > Update </button>
                    </div>                  
                </div> */}
                 <div className="formBttnContainer">
                    {/* <button className="popupButton" onClick={handleRelapsePreventionPlan} >Prevention Plan</button> */}
                    {/* <button className="popupButton" onClick={} style={{ marginTop: '1rem' }} >Get Back on Track</button> */}
                    {/* <button className="popupButton" onClick={handleNextQuestion} style={{ marginTop: '1rem' }} >Set Back Journal</button> */}
                    <button className="popupButton" style={{ marginTop: '1rem' }} onClick={handleSubmitGymExercises} >Save Journal Entry</button>
                </div>
            </div> 
            
        )

        setMotivationPrompts(
            <div className="learningFeedback" style={{ maxHeight: '100%' }}>
                <div>
                    {/* <p className="questionInfo" style={{marginTop:"0"}}> Take it one intentional step at a time.</p> */}
                </div>
                <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    textAlign: 'center',
                }}>
                    <div className="relapseQuestion">Let's breathe and recenter. Follow the box breathing pattern on your screen. When you're done click the back to wellness gym and jump back.</div>
                    <img className="learningProgressIcon" src={boxedBreathing} style={{borderRadius: "10rem", height:'240px', width:'240px', marginTop:'1rem'}} alt="Logo" />
                    {/* <div className="guidedRelapse" style={{
                        position: 'absolute',
                        bottom: '6.5rem',
                        right: '5rem',
                        }}>
                            <div> <GuidedRelapse saveAudio= {handleAudioState} /> </div>                   
                    </div> */}
                </div>
                <div className="formBttnContainer" style={{bottom:'0rem'}}>
                    <button className="popupButton" onClick={handleCloseLearningPopup} style={{ marginTop: '1rem' }} >Back to Wellness Gym</button>
                </div>
            </div> 
        )

        setChat(<Chat/>)

        setMeditation(
            <div className="learningFeedback" style={{ maxHeight: '100%' }}>
                <div>
                <p className="questionInfo" style={{ marginTop: "0" }}>
                    Let's slow down. You’re allowed to pause. A few deep breaths can bring you back into balance.
                </p>
                </div>

                <div
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    textAlign: 'center',
                    marginTop: '1rem',
                }}
                >
                <div className="relapseQuestion" style={{ marginBottom: '1rem', textAlign: 'center' }}>
                    Inhale. Exhale. You're safe here.
                </div>
                {/* <div
                    style={{
                    width: '200px',
                    height: '200px',
                    borderRadius: '50%',
                    background: 'radial-gradient(circle, #d0f0e8, #e8f5e9)',
                    marginTop: '1.5rem',
                    marginBottom: '2rem',
                    animation: 'pulse 6s ease-in-out infinite',
                    }}
                /> */}

                <audio ref={audioRef} src={meditationAudio} preload="auto" />

                {/* <div style={{ width: '100%', maxWidth: '400px', marginTop: '1rem' }}>
                    <input
                    type="range"
                    min="0"
                    max={duration}
                    value={currentTime}
                    onChange={handleSeek}
                    step="0.1"
                    style={{ width: '100%' }}
                    />
                    <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '0.9rem', color: '#666' }}>
                    <span>{formatTime(currentTime)}</span>
                    <span>{formatTime(duration)}</span>
                    </div>
                </div>

                <div style={{ marginTop: '1rem', display: 'flex', gap: '1rem' }}>
                    <button className="popupButton" onClick={togglePlay}>
                    {isPlaying ? 'Pause' : 'Play'}
                    </button>
                    <button className="popupButton" onClick={stopAudio}>
                    Stop
                    </button>
                </div> */}
                <div className="wellnessGymMeditationPlayerWrap">
                    <AudioPlayer
                        className="wellnessGymMeditationPlayer"
                        src={meditationAudio}
                        onPlay={e => console.log("onPlay")}
                    />
                </div>

                </div>

                <div className="formBttnContainer" style={{ bottom: '0rem' }}>
                <button
                    className="popupButton"
                    onClick={handleCloseLearningPopup}
                    style={{ marginTop: '2rem' }}
                >
                   Back to Wellness Gym
                </button>
                </div>
            </div>
            );


        // setMeditation(
        //     <div className="learningFeedback">
        //         <div>
        //         <p className="questionInfo" style={{ marginTop: "0" }}>
        //             Let's slow down. You’re allowed to pause. A few deep breaths can bring you back into balance.
        //         </p>
        //         </div>

        //         <div
        //         style={{
        //             display: 'flex',
        //             flexDirection: 'column',
        //             justifyContent: 'center',
        //             alignItems: 'center',
        //             textAlign: 'center',
        //         }}
        //         >
        //         <div className="relapseQuestion">
        //             Inhale. Exhale. Feel the present moment. You're safe here.
        //         </div>

        //         <div
        //             style={{
        //             width: '200px',
        //             height: '200px',
        //             borderRadius: '50%',
        //             background: 'radial-gradient(circle, #d0f0e8, #e8f5e9)',
        //             marginTop: '1.5rem',
        //             marginBottom: '2rem',
        //             animation: 'pulse 6s ease-in-out infinite',
        //             }}
        //         />

        //         <button
        //             onClick={togglePlayback}
        //             style={{
        //             backgroundColor: '#a5d6a7',
        //             color: '#1b5e20',
        //             border: 'none',
        //             padding: '0.75rem 2rem',
        //             fontSize: '1rem',
        //             borderRadius: '2rem',
        //             cursor: 'pointer',
        //             transition: 'background 0.3s ease',
        //             }}
        //         >
        //             {isPlaying ? 'Pause' : 'Play'}
        //         </button>

        //         <audio ref={audioRef} src={meditationAudio} preload="auto" />
        //         </div>

        //         <div className="formBttnContainer" style={{ bottom: '0rem' }}>
        //         <button
        //             className="popupButton"
        //             onClick={closeBttn}
        //             style={{ marginTop: '1rem' }}
        //         >
        //             Return to Center
        //         </button>
        //         </div>
        //     </div>
        //     );

        return
    }

    const handleCloseLearningPopup = () => {
        const wasExposure = currentQuestion === 11;
        const exposureMidRep = wasExposure && exposureView === 'rep' && exposureRepStep >= 1 && exposureRepStep < 5;
        if (exposureMidRep) {
            const shouldLeave = window.confirm("Leave this workout? Your progress won't be saved.");
            if (!shouldLeave) return;
        }
        const wasMindset = currentQuestion === 7;
        const wasEce = currentQuestion === 4;
        const wasResilience = currentQuestion === 9;
        const wasConnection = currentQuestion === 10;
        if (wasMindset && !maSessionLoggedRef.current) {
            submitMindsetSession({ abandoned: true });
        }
        if (wasEce && !eceSessionLoggedRef.current) {
            submitEceSession({ abandoned: true });
        }
        if (wasResilience && !rrSessionLoggedRef.current) {
            submitResilienceSession({ abandoned: true });
        }
        if (wasConnection && !cccSessionLoggedRef.current) {
            submitConnectionCommSession({ abandoned: true, completed: false });
        }
        setShowPopup(false);
        setCurrentQuestion(0);
        setAnswers([]);
        resetTriggerFlowState();
        resetNsrFlow();
        resetMaFlow();
        resetEceFlow();
        resetResilienceFlow();
        resetConnectionCommFlow();
        resetExposureFlow();
        document.getElementsByClassName('popupContainer')[0].style.display = 'none';
        document.getElementsByClassName('popupContainer')[0].style.visibility = 'hidden';
    };

    function maStepBack() {
        if (maBuildingArc || maStep === 7) return;
        if (maStep === 6) {
            setMaStep(5);
            setMaArcLogVisible(false);
            maStartSection('newBelief');
            return;
        }
        if (maStep === 5) {
            setMaStep(4);
            setMaExLevel(5);
            maStartSection('excavation');
            return;
        }
        if (maStep === 4) {
            if (maExPause) return;
            if (maExLevel > 1) {
                setMaExLevel((n) => n - 1);
                return;
            }
            setMaStep(3);
            maStartSection('protection');
            return;
        }
        if (maStep === 3) {
            setMaStep(2);
            maStartSection('behavior');
            return;
        }
        if (maStep === 2) {
            setMaStep(1);
            maStartSection('surface');
        }
    }

    function eceStepBack() {
        if (eceStep <= 1 || eceStep > 5) return;
        setEceStep((s) => s - 1);
    }

    function rrStepBack() {
        if (rrStep <= 1 || rrStep === 5 || rrStep > 5) return;
        if (rrStep === 2) rrStartScreen('name_it');
        if (rrStep === 3) rrStartScreen('extract_data');
        if (rrStep === 4) rrStartScreen('identity_close');
        setRrStep((s) => s - 1);
    }

    function addFearToSelected() {
        const t = draftFear.trim();
        if (!t || !selectedTriggerId) return;
        setTriggers((prev) => {
            const tr = prev.find((x) => x.id === selectedTriggerId);
            if (!tr || tr.fears.includes(t)) return prev;
            const fears = [...tr.fears, t];
            persistTriggerPatch(selectedTriggerId, { fears, bodySensations: tr.bodySensations });
            return prev.map((x) => (x.id === selectedTriggerId ? { ...x, fears } : x));
        });
        setDraftFear('');
    }

    function removeFearFromSelected(f) {
        if (!selectedTriggerId) return;
        setTriggers((prev) => {
            const tr = prev.find((x) => x.id === selectedTriggerId);
            if (!tr) return prev;
            const fears = tr.fears.filter((x) => x !== f);
            persistTriggerPatch(selectedTriggerId, { fears, bodySensations: tr.bodySensations });
            return prev.map((x) => (x.id === selectedTriggerId ? { ...x, fears } : x));
        });
        setRepSelFears((prev) => prev.filter((x) => x !== f));
    }

    function addBodyToSelected() {
        const t = draftBody.trim();
        if (!t || !selectedTriggerId) return;
        setTriggers((prev) => {
            const tr = prev.find((x) => x.id === selectedTriggerId);
            if (!tr || tr.bodySensations.includes(t)) return prev;
            const bodySensations = [...tr.bodySensations, t];
            persistTriggerPatch(selectedTriggerId, { fears: tr.fears, bodySensations });
            return prev.map((x) => (x.id === selectedTriggerId ? { ...x, bodySensations } : x));
        });
        setDraftBody('');
    }

    function removeBodyFromSelected(b) {
        if (!selectedTriggerId) return;
        setTriggers((prev) => {
            const tr = prev.find((x) => x.id === selectedTriggerId);
            if (!tr) return prev;
            const bodySensations = tr.bodySensations.filter((x) => x !== b);
            persistTriggerPatch(selectedTriggerId, { fears: tr.fears, bodySensations });
            return prev.map((x) => (x.id === selectedTriggerId ? { ...x, bodySensations } : x));
        });
        setRepSelBody((prev) => prev.filter((x) => x !== b));
    }

    function toggleRepFear(f) {
        setRepSelFears((prev) => (prev.includes(f) ? prev.filter((x) => x !== f) : [...prev, f]));
    }

    function toggleRepBody(b) {
        setRepSelBody((prev) => (prev.includes(b) ? prev.filter((x) => x !== b) : [...prev, b]));
    }

    function saveNewTrigger() {
        const payload = {
            id: `trigger-${Date.now()}`,
            name: newTriggerName.trim(),
            pillar: newTriggerPillar.trim(),
            oldPattern: newTriggerOldPattern.trim(),
            replacement: newTriggerReplacement.trim(),
            affirmation: newTriggerAffirmation.trim(),
            fears: [],
            bodySensations: [],
        };
        if (!payload.name || !payload.pillar || !payload.oldPattern || !payload.replacement || !payload.affirmation) return;
        setTriggers((prev) => [payload, ...prev]);
        setSelectedTriggerId(payload.id);
        setTriggerFlowView('board');
        setTriggerStep(1);
        setNewTriggerName('');
        setNewTriggerOldPattern('');
        setNewTriggerReplacement('');
        setNewTriggerAffirmation('');
        setNewTriggerPillar('Nervous System Regulation');
        axios.post(triggerLibraryCreateUrl, { username, token, trigger: payload }, { headers: apiKeyHeader }).catch((err) => {
            console.error('triggerLibraryCreate failed', err);
        });
    }

    const selectedTrigger = triggers.find((t) => t.id === selectedTriggerId) || triggers[0] || null;
    const selectedTriggerRepCount = Number(selectedTrigger?.rep_count || selectedTrigger?.repCount || 0);
    const selectedTriggerFollowPct = Number(selectedTrigger?.follow_through_pct || selectedTrigger?.followThroughPct || 0);
    const totalReps = triggers.reduce((sum, t) => sum + Number(t.rep_count || t.repCount || 0), 0);

    const triggerStepBack = () => {
        if (triggerFlowView === 'add') {
            setTriggerFlowView('board');
            return;
        }
        if (triggerStep > 1) setTriggerStep((s) => s - 1);
    };

    const triggerFlowShellStyle = {
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        minHeight: 0,
        width: '100%',
        maxWidth: '100%',
        overflow: 'hidden',
        boxSizing: 'border-box',
    };

    const triggerFlowScrollStyle = {
        flex: 1,
        minHeight: 0,
        overflowY: 'auto',
        overflowX: 'hidden',
        width: '100%',
        maxWidth: '100%',
        boxSizing: 'border-box',
        WebkitOverflowScrolling: 'touch',
        paddingTop: '1.5rem'
    };

    const triggerFieldStyle = {
        width: '100%',
        maxWidth: '100%',
        minWidth: 0,
        boxSizing: 'border-box',
    };

    /** Pinned footer; main column scrolls above */
    const triggerFlowFooterStyle = {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        width: '100%',
        maxWidth: '100%',
        flexShrink: 0,
        boxSizing: 'border-box',
        paddingTop: '0.75rem',
        paddingBottom: 'calc(0.25rem + env(safe-area-inset-bottom, 0px))',
    };

    const triggerFlowFooterRowStyle = {
        ...triggerFlowFooterStyle,
        flexDirection: 'row',
        alignItems: 'stretch',
        gap: '0.5rem',
        paddingLeft: '0.15rem',
        paddingRight: '0.15rem',
    };

    const triggerHeadlineStyle = {
        marginTop: '0.2rem',
        marginBottom: '0.4rem',
        textAlign: 'left',
        width: '100%',
        maxWidth: '100%',
        overflowWrap: 'break-word',
        boxSizing: 'border-box',
        fontFamily: "'Fraunces', serif",
        fontWeight: 300,
        fontSize: 'clamp(1.2rem, 4.2vw, 1.7rem)',
        lineHeight: 1.2,
        color: 'rgba(255, 255, 255, 0.95)',
    };

    const triggerMetaStyle = {
        textAlign: 'left',
        width: '100%',
        maxWidth: '100%',
        opacity: 0.74,
        boxSizing: 'border-box',
        color: 'rgba(255, 255, 255, 0.7)',
        fontFamily: "'DM Sans', sans-serif",
        letterSpacing: '0.04em',
        textTransform: 'uppercase',
        fontSize: '0.68rem',
    };

    const triggerCardStyle = {
        width: '100%',
        maxWidth: '100%',
        border: '1px solid rgba(255, 255, 255, 0.12)',
        borderRadius: '16px',
        padding: '0.8rem',
        marginBottom: '0.55rem',
        boxSizing: 'border-box',
        background: 'linear-gradient(160deg, rgba(255, 255, 255, 0.08), rgba(255, 255, 255, 0.03))',
        boxShadow: '0 12px 28px rgba(4, 8, 16, 0.18)',
    };

    const triggerInputStyle = {
        ...triggerFieldStyle,
        padding: '0.65rem 0.72rem',
        borderRadius: '12px',
        marginTop: '0.5rem',
        border: '1px solid rgba(255, 255, 255, 0.22)',
        background: 'rgba(255, 255, 255, 0.07)',
        color: 'rgba(255, 255, 255, 0.94)',
        fontFamily: "'DM Sans', sans-serif",
        fontSize: '0.92rem',
    };

    const triggerPrimaryButtonStyle = {
        width: '100%',
        borderRadius: '50px',
        border: '1px solid rgba(255, 255, 255, 0.45)',
        padding: '0.95rem 1rem',
        textAlign: 'center',
        background: 'transparent',
        cursor: 'pointer',
        fontSize: '0.95rem',
        color: '#FFFFFF',
        fontFamily: "'DM Sans', sans-serif",
        fontWeight: 500,
        boxSizing: 'border-box',
    };

    const triggerExerciseAssets = (
        <div
            className="learningFeedback"
            style={{
                flex: 1,
                minHeight: 0,
                maxHeight: '100%',
                height: '100%',
                textAlign: 'left',
                padding: '0 0.75rem',
                alignItems: 'stretch',
                display: 'flex',
                flexDirection: 'column',
                overflow: 'hidden',
                width: '100%',
                maxWidth: '100%',
                boxSizing: 'border-box',
            }}
        >
            {triggersLoading ? (
                <p className="relapseQuestion" style={{ textAlign: 'center', marginTop: '3rem' }}>Loading triggers…</p>
            ) : (
                <div style={triggerFlowShellStyle}>
                    {(triggerStep > 1 || triggerFlowView === 'add') && (
                        <div className="popupButtonGroup" style={{ position: 'static', width: '100%', flexShrink: 0, marginTop: 0, marginBottom: '0.25rem' }}>
                            <button type="button" className="landing-onboarding-top-back" onClick={triggerStepBack} aria-label="Previous step">
                                <svg width="22" height="22" viewBox="0 0 14 14" fill="none" aria-hidden="true">
                                    <path d="M11 7H3M7 3L3 7l4 4" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                            </button>
                        </div>
                    )}
                    {triggerFlowView === 'add' ? (
                        <>
                            <div style={triggerFlowScrollStyle}>
                                <p className="questionInfo" style={triggerMetaStyle}>new trigger</p>
                                <h2 style={triggerHeadlineStyle}>Name the trigger</h2>
                                <p className="questionInfo" style={{ ...triggerMetaStyle, textTransform: 'none', letterSpacing: 'normal', fontSize: '0.78rem' }}>
                                    Be specific. The more honest the name, the more useful the rep.
                                </p>
                                <input value={newTriggerName} onChange={(e) => setNewTriggerName(e.target.value)} placeholder="Trigger name" style={triggerInputStyle} />
                                <textarea rows={2} value={newTriggerOldPattern} onChange={(e) => setNewTriggerOldPattern(e.target.value)} placeholder="What you usually do" style={{ ...triggerInputStyle, resize: 'vertical' }} />
                                <textarea rows={2} value={newTriggerReplacement} onChange={(e) => setNewTriggerReplacement(e.target.value)} placeholder="What you're training toward" style={{ ...triggerInputStyle, resize: 'vertical' }} />
                                <textarea rows={2} value={newTriggerAffirmation} onChange={(e) => setNewTriggerAffirmation(e.target.value)} placeholder="Affirmation for this trigger" style={{ ...triggerInputStyle, resize: 'vertical' }} />
                                <select value={newTriggerPillar} onChange={(e) => setNewTriggerPillar(e.target.value)} style={{ ...triggerInputStyle, marginBottom: '0.5rem' }}>
                                    <option>Nervous System Regulation</option>
                                    <option>Mindset Awareness</option>
                                    <option>Emotional Capacity</option>
                                    <option>Resilience & Purpose</option>
                                    <option>Connection & Communication</option>
                                </select>
                            </div>
                            <div style={triggerFlowFooterStyle}>
                                <button
                                    className="popupButton"
                                    type="button"
                                    onClick={saveNewTrigger}
                                    disabled={!(newTriggerName.trim() && newTriggerOldPattern.trim() && newTriggerReplacement.trim() && newTriggerAffirmation.trim() && newTriggerPillar.trim())}
                                    style={{ ...triggerPrimaryButtonStyle, opacity: newTriggerName.trim() && newTriggerOldPattern.trim() && newTriggerReplacement.trim() && newTriggerAffirmation.trim() && newTriggerPillar.trim() ? 1 : 0.45 }}
                                >
                                    Save trigger
                                </button>
                            </div>
                        </>
                    ) : triggerStep === 1 ? (
                        <>
                            <div style={triggerFlowScrollStyle}>
                                <p className="questionInfo" style={triggerMetaStyle}>training floor</p>
                                <h2 style={{ ...triggerHeadlineStyle, marginBottom: '0.8rem' }}>What are you working through?</h2>
                                <div style={{ width: '100%', maxWidth: '100%', display: 'grid', gridTemplateColumns: 'minmax(0, 1fr) minmax(0, 1fr)', gap: '0.5rem', boxSizing: 'border-box' }}>
                                    {triggers.map((tr) => {
                                        const rc = Number(tr.rep_count || tr.repCount || 0);
                                        const fp = Number(tr.follow_through_pct || tr.followThroughPct || 0);
                                        return (
                                            <button
                                                key={tr.id}
                                                type="button"
                                                onClick={() => {
                                                    setSelectedTriggerId(tr.id);
                                                    openTriggerStep(2);
                                                }}
                                                style={{ border: '1px solid rgba(255, 255, 255, 0.12)', borderRadius: '14px', textAlign: 'left', padding: '0.65rem', background: 'linear-gradient(160deg, rgba(255, 255, 255, 0.09), rgba(255, 255, 255, 0.03))', minWidth: 0, maxWidth: '100%', boxSizing: 'border-box', color: '#fff' }}
                                            >
                                                <div style={{ display: 'inline-block', fontSize: '0.64rem', opacity: 0.85, border: '1px solid rgba(255, 255, 255, 0.24)', padding: '0.14rem 0.4rem', borderRadius: '999px', marginBottom: '0.35rem', maxWidth: '100%', overflowWrap: 'break-word', fontFamily: "'DM Sans', sans-serif", color: 'rgba(255, 255, 255, 0.9)' }}>{tr.pillar}</div>
                                                <div style={{ fontSize: '1.03rem', fontFamily: "'Fraunces', serif", marginBottom: '0.3rem', overflowWrap: 'break-word', wordBreak: 'break-word', color: '#fff' }}>{tr.name}</div>
                                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '0.25rem', minWidth: 0 }}>
                                                    <span style={{ fontSize: '0.72rem', opacity: 0.76, overflowWrap: 'break-word', minWidth: 0, color: 'rgba(255, 255, 255, 0.78)', fontFamily: "'DM Sans', sans-serif" }}>{rc} reps · {fp}% follow-through</span>
                                                    <span style={{ width: 8, height: 8, borderRadius: '50%', display: 'inline-block', flexShrink: 0, background: rc > 3 ? 'rgba(255, 255, 255, 0.95)' : 'rgba(255, 255, 255, 0.35)' }} />
                                                </div>
                                            </button>
                                        );
                                    })}
                                </div>
                            </div>
                            <div style={{ ...triggerFlowFooterStyle, alignItems: 'stretch' }}>
                                <button
                                    type="button"
                                    onClick={() => setTriggerFlowView('add')}
                                    style={{
                                        ...triggerPrimaryButtonStyle,
                                        border: '1px dashed rgba(255, 255, 255, 0.35)',
                                        textAlign: 'left',
                                    }}
                                >
                                    <span style={{ marginRight: '0.35rem', fontWeight: 600 }}>+</span> Add a trigger
                                </button>
                            </div>
                        </>
                    ) : triggerStep === 2 && selectedTrigger ? (
                        <>
                            <div style={triggerFlowScrollStyle}>
                                <p className="questionInfo" style={triggerMetaStyle}>check in</p>
                                <h2 style={triggerHeadlineStyle}>{selectedTrigger.name}</h2>
                                <p className="questionInfo" style={{ ...triggerMetaStyle, textTransform: 'none', letterSpacing: 'normal', fontSize: '0.78rem' }}>Check in before you begin. What's alive right now?</p>

                                <div style={{ width: '100%', maxWidth: '100%', marginTop: '0.5rem', boxSizing: 'border-box' }}>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '0.35rem', minWidth: 0 }}>
                                        <p className="questionInfo" style={{ textAlign: 'left', margin: 0, fontSize: '0.62rem', letterSpacing: '0.08em', opacity: 0.7, flex: 1, minWidth: 0 }}>what you're avoiding</p>
                                        <button type="button" onClick={() => setIsEditingFears((v) => !v)} style={{ border: 'none', background: 'none', fontSize: '0.72rem', flexShrink: 0, color: 'rgba(255, 255, 255, 0.72)', fontFamily: "'DM Sans', sans-serif" }}>{isEditingFears ? 'done' : '+ add'}</button>
                                    </div>
                                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.35rem', marginTop: '0.4rem', maxWidth: '100%' }}>
                                        {selectedTrigger.fears.map((f) => (
                                            <button key={f} type="button" onClick={() => toggleRepFear(f)} style={{ border: '1px solid rgba(255, 255, 255, 0.22)', background: repSelFears.includes(f) ? 'rgba(255, 255, 255, 0.2)' : 'rgba(255, 255, 255, 0.08)', borderRadius: '999px', padding: '0.25rem 0.5rem', fontSize: '0.73rem', maxWidth: '100%', overflowWrap: 'break-word', color: 'rgba(255, 255, 255, 0.9)', fontFamily: "'DM Sans', sans-serif" }}>
                                                {f}{isEditingFears ? <span onClick={(e) => { e.stopPropagation(); removeFearFromSelected(f); }} style={{ marginLeft: '0.35rem' }}>✕</span> : null}
                                            </button>
                                        ))}
                                    </div>
                                    {isEditingFears ? (
                                        <div style={{ display: 'flex', gap: '0.35rem', marginTop: '0.45rem', maxWidth: '100%', minWidth: 0 }}>
                                            <input value={draftFear} onChange={(e) => setDraftFear(e.target.value)} onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); addFearToSelected(); } }} style={{ ...triggerInputStyle, flex: 1, minWidth: 0, maxWidth: '100%', marginTop: 0 }} />
                                            <button className="popupButton" type="button" onClick={addFearToSelected} style={{ padding: '0.45rem 0.8rem', width: 'auto', flexShrink: 0 }}>Add</button>
                                        </div>
                                    ) : null}
                                </div>

                                <div style={{ width: '100%', maxWidth: '100%', marginTop: '0.7rem', boxSizing: 'border-box' }}>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '0.35rem', minWidth: 0 }}>
                                        <p className="questionInfo" style={{ textAlign: 'left', margin: 0, fontSize: '0.62rem', letterSpacing: '0.08em', opacity: 0.7, flex: 1, minWidth: 0 }}>how it lives in your body</p>
                                        <button type="button" onClick={() => setIsEditingBody((v) => !v)} style={{ border: 'none', background: 'none', fontSize: '0.72rem', flexShrink: 0, color: 'rgba(255, 255, 255, 0.72)', fontFamily: "'DM Sans', sans-serif" }}>{isEditingBody ? 'done' : '+ add'}</button>
                                    </div>
                                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.35rem', marginTop: '0.4rem', maxWidth: '100%' }}>
                                        {selectedTrigger.bodySensations.map((b) => (
                                            <button key={b} type="button" onClick={() => toggleRepBody(b)} style={{ border: '1px solid rgba(255, 255, 255, 0.22)', background: repSelBody.includes(b) ? 'rgba(255, 255, 255, 0.2)' : 'rgba(255, 255, 255, 0.08)', borderRadius: '999px', padding: '0.25rem 0.5rem', fontSize: '0.73rem', maxWidth: '100%', overflowWrap: 'break-word', color: 'rgba(255, 255, 255, 0.9)', fontFamily: "'DM Sans', sans-serif" }}>
                                                {b}{isEditingBody ? <span onClick={(e) => { e.stopPropagation(); removeBodyFromSelected(b); }} style={{ marginLeft: '0.35rem' }}>✕</span> : null}
                                            </button>
                                        ))}
                                    </div>
                                    {isEditingBody ? (
                                        <div style={{ display: 'flex', gap: '0.35rem', marginTop: '0.45rem', maxWidth: '100%', minWidth: 0 }}>
                                            <input value={draftBody} onChange={(e) => setDraftBody(e.target.value)} onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); addBodyToSelected(); } }} style={{ ...triggerInputStyle, flex: 1, minWidth: 0, maxWidth: '100%', marginTop: 0 }} />
                                            <button className="popupButton" type="button" onClick={addBodyToSelected} style={{ padding: '0.45rem 0.8rem', width: 'auto', flexShrink: 0 }}>Add</button>
                                        </div>
                                    ) : null}
                                </div>
                            </div>
                            <div style={triggerFlowFooterStyle}>
                                <button type="button" className="popupButton" onClick={() => openTriggerStep(3)}>I see what's happening</button>
                            </div>
                        </>
                    ) : triggerStep === 3 && selectedTrigger ? (
                        <>
                            <div style={triggerFlowScrollStyle}>
                                <p className="questionInfo" style={triggerMetaStyle}>{selectedTrigger.pillar} · pattern interrupt</p>
                                <h2 style={{ ...triggerHeadlineStyle, marginBottom: '0.6rem' }}>{selectedTrigger.name}</h2>
                                <div style={triggerCardStyle}>
                                    <p className="questionInfo" style={{ textAlign: 'left', width: '100%', maxWidth: '100%', opacity: 0.7, margin: 0, boxSizing: 'border-box' }}>What you usually do</p>
                                    <div style={{ fontSize: '0.9rem', marginTop: '0.3rem', overflowWrap: 'break-word', wordBreak: 'break-word', color: 'rgba(255, 255, 255, 0.88)', fontFamily: "'DM Sans', sans-serif" }}>{selectedTrigger.oldPattern}</div>
                                </div>
                                <div style={triggerCardStyle}>
                                    <p className="questionInfo" style={{ textAlign: 'left', width: '100%', maxWidth: '100%', opacity: 0.7, margin: 0, boxSizing: 'border-box' }}>What you're training toward</p>
                                    <div style={{ fontSize: '0.94rem', marginTop: '0.3rem', fontStyle: 'italic', fontFamily: "'Fraunces', serif", overflowWrap: 'break-word', wordBreak: 'break-word', color: '#fff' }}>{selectedTrigger.replacement}</div>
                                </div>
                            </div>
                            <div style={triggerFlowFooterStyle}>
                                <button type="button" className="popupButton" onClick={() => openTriggerStep(4)}>Start the rep</button>
                            </div>
                        </>
                    ) : triggerStep === 4 && selectedTrigger ? (
                        <>
                            <div style={{ ...triggerFlowScrollStyle, display: 'flex', flexDirection: 'column', alignItems: 'stretch' }}>
                                <p className="questionInfo" style={{ textAlign: 'left', width: '100%', maxWidth: '100%', opacity: 0.7, flexShrink: 0, boxSizing: 'border-box' }}>breathe</p>
                                <div style={{ width: '100%', maxWidth: '100%', display: 'flex', justifyContent: 'center', marginTop: '0.6rem', flexShrink: 0 }}>
                                    <div style={{ width: 120, height: 120, maxWidth: '100%', borderRadius: '50%', border: '1px solid #a9a7a4', transform: `scale(${1 + (breathPhase === 'breathe in' ? breathProgress / 250 : breathPhase === 'breathe out' ? (100 - breathProgress) / 250 : 0.3)})`, transition: 'transform 120ms linear' }} />
                                </div>
                                <p className="questionInfo" style={{ textAlign: 'center', width: '100%', maxWidth: '100%', marginTop: '0.6rem', letterSpacing: '0.08em', fontSize: '0.62rem', opacity: 0.7, flexShrink: 0, boxSizing: 'border-box' }}>{repRevealStage === 0 ? breathPhase : ''}</p>
                                <div style={{ width: '100%', maxWidth: '100%', height: 4, borderRadius: 4, background: 'rgba(255, 255, 255, 0.2)', overflow: 'hidden', marginTop: '0.3rem', flexShrink: 0, boxSizing: 'border-box' }}>
                                    <div style={{ width: `${repRevealStage === 0 ? breathProgress : 100}%`, height: '100%', background: 'rgba(255, 255, 255, 0.92)' }} />
                                </div>
                                {repRevealStage >= 1 ? (
                                    <div style={{ width: '100%', maxWidth: '100%', marginTop: '1rem', opacity: 1, transition: 'opacity 0.3s ease', flexShrink: 0, boxSizing: 'border-box' }}>
                                        <p className="questionInfo" style={{ textAlign: 'left', width: '100%', maxWidth: '100%', opacity: 0.7, margin: 0, boxSizing: 'border-box' }}>Hold this</p>
                                        <div
                                            style={{
                                                marginTop: '0.35rem',
                                                fontStyle: 'italic',
                                                fontFamily: 'serif',
                                                fontSize: '0.95rem',
                                                lineHeight: 1.45,
                                                width: '100%',
                                                maxWidth: '100%',
                                                overflowWrap: 'break-word',
                                                wordBreak: 'break-word',
                                                boxSizing: 'border-box',
                                            }}
                                        >
                                            {selectedTrigger.affirmation}
                                        </div>
                                    </div>
                                ) : null}
                            </div>
                            <div style={triggerFlowFooterStyle}>
                                <button
                                    type="button"
                                    className="popupButton"
                                    disabled={repRevealStage < 1}
                                    style={{ ...triggerPrimaryButtonStyle, opacity: repRevealStage < 1 ? 0.45 : 1 }}
                                    onClick={() => openTriggerStep(5)}
                                >
                                    I'm ready to try it
                                </button>
                                <button
                                    type="button"
                                    onClick={() => openTriggerStep(5)}
                                    style={{ border: 'none', background: 'none', marginTop: '0.65rem', fontSize: '0.78rem', color: 'rgba(255, 255, 255, 0.72)', fontFamily: "'DM Sans', sans-serif" }}
                                >
                                    Skip breath — I'm already grounded
                                </button>
                            </div>
                        </>
                    ) : triggerStep === 5 && selectedTrigger ? (
                        <>
                            <div style={triggerFlowScrollStyle}>
                                <p className="questionInfo" style={triggerMetaStyle}>Did you follow through?</p>
                                <h2 style={triggerHeadlineStyle}>Did you use it?</h2>
                                <p className="questionInfo" style={{ ...triggerMetaStyle, textTransform: 'none', letterSpacing: 'normal', fontSize: '0.78rem' }}>Honesty is the rep. No judgment either way.</p>
                                <div style={{ ...triggerCardStyle, marginTop: '0.5rem' }}>
                                    <p className="questionInfo" style={{ textAlign: 'left', width: '100%', maxWidth: '100%', opacity: 0.7, margin: 0, boxSizing: 'border-box' }}>Your move was</p>
                                    <div style={{ marginTop: '0.3rem', fontStyle: 'italic', fontFamily: "'Fraunces', serif", overflowWrap: 'break-word', wordBreak: 'break-word', color: '#fff' }}>{selectedTrigger.replacement}</div>
                                </div>
                            </div>
                            <div style={triggerFlowFooterRowStyle}>
                                <button
                                    type="button"
                                    className="popupButton"
                                    style={{ ...triggerPrimaryButtonStyle, flex: 1, minWidth: 0, padding: '1rem 0.35rem', fontSize: '0.85rem' }}
                                    onClick={() => {
                                        setTriggerDoneFollowedThrough(true);
                                        submitTriggerRep(true);
                                        openTriggerStep(6);
                                    }}
                                >
                                    Yes, I used it
                                </button>
                                <button
                                    type="button"
                                    className="popupButton"
                                    style={{ ...triggerPrimaryButtonStyle, flex: 1, minWidth: 0, padding: '1rem 0.35rem', opacity: 0.75, fontSize: '0.85rem' }}
                                    onClick={() => {
                                        setTriggerDoneFollowedThrough(false);
                                        submitTriggerRep(false);
                                        openTriggerStep(6);
                                    }}
                                >
                                    Not this time
                                </button>
                            </div>
                        </>
                    ) : (
                        <>
                            <div style={triggerFlowScrollStyle}>
                                <div style={{ width: '100%', maxWidth: '100%', textAlign: 'center', marginTop: '1rem', fontSize: '2rem', boxSizing: 'border-box' }}>{triggerDoneFollowedThrough ? '◉' : '◌'}</div>
                                <h2 style={{ ...triggerHeadlineStyle, textAlign: 'center', marginTop: '0.7rem', marginBottom: '0.2rem' }}>
                                    {triggerDoneFollowedThrough ? 'Rep complete.' : 'Awareness logged.'}
                                </h2>
                                <p className="questionInfo" style={{ width: '100%', maxWidth: '100%', opacity: 0.7, boxSizing: 'border-box' }}>
                                    {triggerDoneFollowedThrough ? "You paused, you chose differently. That's the muscle." : 'Noticing is the first rep. The follow-through comes with time.'}
                                </p>
                                <div style={{ width: '100%', maxWidth: '100%', display: 'flex', gap: '0.35rem', marginTop: '0.8rem', minWidth: 0, boxSizing: 'border-box' }}>
                                    <div style={{ ...triggerCardStyle, flex: 1, minWidth: 0, padding: '0.45rem', marginBottom: 0 }}>
                                        <div style={{ fontSize: '0.65rem', opacity: 0.7, color: 'rgba(255, 255, 255, 0.75)', fontFamily: "'DM Sans', sans-serif" }}>Total reps</div>
                                        <div style={{ fontSize: '1rem', marginTop: '0.2rem', color: '#fff', fontFamily: "'Fraunces', serif" }}>{totalReps}</div>
                                    </div>
                                    <div style={{ ...triggerCardStyle, flex: 1, minWidth: 0, padding: '0.45rem', marginBottom: 0 }}>
                                        <div style={{ fontSize: '0.65rem', opacity: 0.7, color: 'rgba(255, 255, 255, 0.75)', fontFamily: "'DM Sans', sans-serif" }}>Follow-through</div>
                                        <div style={{ fontSize: '1rem', marginTop: '0.2rem', color: '#fff', fontFamily: "'Fraunces', serif" }}>{selectedTriggerFollowPct}%</div>
                                    </div>
                                    <div style={{ ...triggerCardStyle, flex: 1, minWidth: 0, padding: '0.45rem', marginBottom: 0 }}>
                                        <div style={{ fontSize: '0.65rem', opacity: 0.7, color: 'rgba(255, 255, 255, 0.75)', fontFamily: "'DM Sans', sans-serif" }}>This trigger</div>
                                        <div style={{ fontSize: '1rem', marginTop: '0.2rem', color: '#fff', fontFamily: "'Fraunces', serif" }}>{selectedTriggerRepCount}</div>
                                    </div>
                                </div>
                            </div>
                            <div style={triggerFlowFooterStyle}>
                                <button type="button" className="popupButton" onClick={resetTriggerFlowState}>Back to board</button>
                            </div>
                        </>
                    )}
                </div>
            )}
        </div>
    );

    const nsrImproved = nsrActivationAfter < nsrActivationBefore;
    const nsrCompleteReflection =
        nsrImproved && nsrDrill === 'extended_exhale'
            ? 'Long exhale, clear shift. That is the work.'
            : nsrImproved
              ? 'Your nervous system responded. That is the training working.'
              : 'Regulation is repetition. Showing up still moves the needle.';

    const nsrExerciseAssets = (
        <div
            className="learningFeedback"
            style={{
                flex: 1,
                minHeight: 0,
                maxHeight: '100%',
                height: '100%',
                textAlign: 'left',
                padding: '0 0.75rem',
                alignItems: 'stretch',
                display: 'flex',
                flexDirection: 'column',
                overflow: 'hidden',
                width: '100%',
                maxWidth: '100%',
                boxSizing: 'border-box',
            }}
        >
            <div style={triggerFlowShellStyle}>
                {nsrStep > 1 && !(nsrStep === 4 && nsrDrillRunning && !nsrDrillRoundComplete) ? (
                    <div className="popupButtonGroup" style={{ position: 'static', width: '100%', flexShrink: 0, marginTop: 0, marginBottom: '0.25rem' }}>
                        <button type="button" className="landing-onboarding-top-back" onClick={nsrStepBack} aria-label="Previous step">
                            <svg width="22" height="22" viewBox="0 0 14 14" fill="none" aria-hidden="true">
                                <path d="M11 7H3M7 3L3 7l4 4" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </button>
                    </div>
                ) : null}
                {nsrStep === 1 ? (
                    <>
                        <div style={triggerFlowScrollStyle}>
                            <h2 style={{ ...triggerHeadlineStyle, marginTop: '0.5rem', marginBottom: '1.25rem', textAlign: 'center' }}>
                                How activated are you right now?
                            </h2>
                            <div style={{ width: '100%', maxWidth: '100%', padding: '0 0.25rem', boxSizing: 'border-box' }}>
                                <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '0.72rem', opacity: 0.72, marginBottom: '0.35rem', color: 'rgba(255, 255, 255, 0.75)', fontFamily: "'DM Sans', sans-serif" }}>
                                    <span>settled</span>
                                    <span>wired</span>
                                </div>
                                <input
                                    type="range"
                                    min={1}
                                    max={10}
                                    value={nsrActivationBefore}
                                    onChange={(e) => setNsrActivationBefore(Number(e.target.value))}
                                    style={{ width: '100%', maxWidth: '100%', boxSizing: 'border-box' }}
                                />
                                <div style={{ textAlign: 'center', marginTop: '0.75rem', fontSize: '1.6rem', fontWeight: 500, color: '#fff', fontFamily: "'Fraunces', serif" }}>{nsrActivationBefore}</div>
                            </div>
                        </div>
                        <div style={triggerFlowFooterStyle}>
                            <button type="button" className="popupButton" style={triggerPrimaryButtonStyle} onClick={() => setNsrStep(2)}>
                                Continue
                            </button>
                        </div>
                    </>
                ) : nsrStep === 2 ? (
                    <>
                        <div style={triggerFlowScrollStyle}>
                            <h2 style={{ ...triggerHeadlineStyle, marginTop: '0.35rem', marginBottom: '0.75rem', fontSize: 'clamp(1.05rem, 3.9vw, 1.4rem)' }}>
                                What do you notice in your body right now?
                            </h2>
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '0.4rem', width: '100%', maxWidth: '100%' }}>
                                {NSR_BODY_SIGNALS.map((sig) => (
                                    <button
                                        key={sig}
                                        type="button"
                                        onClick={() =>
                                            setNsrSignalsScan((prev) => (prev.includes(sig) ? prev.filter((x) => x !== sig) : [...prev, sig]))
                                        }
                                        style={{
                                            textAlign: 'left',
                                            padding: '0.55rem 0.65rem',
                                            borderRadius: '999px',
                                            border: nsrSignalsScan.includes(sig) ? '1px solid rgba(255, 255, 255, 0.45)' : '1px solid rgba(255, 255, 255, 0.2)',
                                            background: nsrSignalsScan.includes(sig) ? 'rgba(255, 255, 255, 0.2)' : 'rgba(255, 255, 255, 0.08)',
                                            fontSize: '0.88rem',
                                            cursor: 'pointer',
                                            width: '100%',
                                            maxWidth: '100%',
                                            boxSizing: 'border-box',
                                            color: 'rgba(255, 255, 255, 0.9)',
                                            fontFamily: "'DM Sans', sans-serif",
                                        }}
                                    >
                                        {sig}
                                    </button>
                                ))}
                            </div>
                        </div>
                        <div style={triggerFlowFooterStyle}>
                            <button type="button" className="popupButton" style={triggerPrimaryButtonStyle} onClick={() => setNsrStep(3)}>
                                Continue
                            </button>
                        </div>
                    </>
                ) : nsrStep === 3 ? (
                    <>
                        <div style={triggerFlowScrollStyle}>
                            <p className="questionInfo" style={triggerMetaStyle}>pick one</p>
                            <h2 style={{ ...triggerHeadlineStyle, marginBottom: '0.75rem', fontSize: 'clamp(1.05rem, 3.9vw, 1.4rem)' }}>Choose your drill</h2>
                            <button
                                type="button"
                                onClick={() => setNsrDrill('box')}
                                style={{
                                    width: '100%',
                                    maxWidth: '100%',
                                    textAlign: 'left',
                                    padding: '0.75rem',
                                    marginBottom: '0.5rem',
                                    borderRadius: '14px',
                                    border: nsrDrill === 'box' ? '1px solid rgba(255, 255, 255, 0.45)' : '1px solid rgba(255, 255, 255, 0.16)',
                                    background: 'linear-gradient(160deg, rgba(255, 255, 255, 0.09), rgba(255, 255, 255, 0.03))',
                                    cursor: 'pointer',
                                    boxSizing: 'border-box',
                                    color: 'rgba(255, 255, 255, 0.9)',
                                }}
                            >
                                <div style={{ fontWeight: 500, marginBottom: '0.35rem', fontFamily: "'Fraunces', serif", fontSize: '1.02rem', color: '#fff' }}>Box breathing</div>
                                <div style={{ fontSize: '0.78rem', opacity: 0.88, marginBottom: '0.35rem', fontFamily: "'DM Sans', sans-serif" }}>Inhale 4 · hold 4 · exhale 4 · hold 4</div>
                                <div style={{ fontSize: '0.8rem', opacity: 0.74, fontFamily: "'DM Sans', sans-serif" }}>Best for general stress and steadying.</div>
                            </button>
                            <button
                                type="button"
                                onClick={() => setNsrDrill('extended_exhale')}
                                style={{
                                    width: '100%',
                                    maxWidth: '100%',
                                    textAlign: 'left',
                                    padding: '0.75rem',
                                    borderRadius: '14px',
                                    border: nsrDrill === 'extended_exhale' ? '1px solid rgba(255, 255, 255, 0.45)' : '1px solid rgba(255, 255, 255, 0.16)',
                                    background: 'linear-gradient(160deg, rgba(255, 255, 255, 0.09), rgba(255, 255, 255, 0.03))',
                                    cursor: 'pointer',
                                    boxSizing: 'border-box',
                                    color: 'rgba(255, 255, 255, 0.9)',
                                }}
                            >
                                <div style={{ fontWeight: 500, marginBottom: '0.35rem', fontFamily: "'Fraunces', serif", fontSize: '1.02rem', color: '#fff' }}>Extended exhale</div>
                                <div style={{ fontSize: '0.78rem', opacity: 0.88, marginBottom: '0.35rem', fontFamily: "'DM Sans', sans-serif" }}>Inhale 4 · exhale 8</div>
                                <div style={{ fontSize: '0.8rem', opacity: 0.74, fontFamily: "'DM Sans', sans-serif" }}>Best when you feel revved or stuck high.</div>
                            </button>
                        </div>
                        <div style={triggerFlowFooterStyle}>
                            <button type="button" className="popupButton" disabled={!nsrDrill} style={{ ...triggerPrimaryButtonStyle, opacity: nsrDrill ? 1 : 0.45 }} onClick={() => { setNsrStep(4); nsrBeginDrillRound(); }}>
                                Begin
                            </button>
                        </div>
                    </>
                ) : nsrStep === 4 ? (
                    <div
                        style={{
                            flex: 1,
                            minHeight: 0,
                            display: 'flex',
                            flexDirection: 'column',
                            background: 'linear-gradient(170deg, rgba(255, 255, 255, 0.08), rgba(255, 255, 255, 0.02))',
                            color: 'rgba(255, 255, 255, 0.9)',
                            marginLeft: '-0.75rem',
                            marginRight: '-0.75rem',
                            marginBottom: '-1px',
                            width: 'calc(100% + 1.5rem)',
                            maxWidth: 'calc(100% + 1.5rem)',
                            boxSizing: 'border-box',
                        }}
                    >
                        <div style={{ flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', padding: '1rem 0.75rem' }}>
                            {!nsrDrillRoundComplete ? (
                                <>
                                    <div
                                        style={{
                                            width: 132,
                                            height: 132,
                                            borderRadius: '50%',
                                            border: '1px solid rgba(255, 255, 255, 0.35)',
                                            transform: `scale(${nsrDrillScale})`,
                                            transition: 'transform 0.35s ease-out',
                                            background: 'radial-gradient(circle at 30% 30%, rgba(255, 255, 255, 0.22), rgba(255, 255, 255, 0.05))',
                                        }}
                                    />
                                    <p style={{ marginTop: '1.25rem', fontSize: '0.68rem', letterSpacing: '0.14em', textTransform: 'uppercase', opacity: 0.85, color: 'rgba(255, 255, 255, 0.84)', fontFamily: "'DM Sans', sans-serif" }}>{nsrDrillPhaseLabel}</p>
                                    <p style={{ marginTop: '0.5rem', fontSize: '0.75rem', opacity: 0.65, color: 'rgba(255, 255, 255, 0.72)', fontFamily: "'DM Sans', sans-serif" }}>
                                        Round {Math.min(nsrDrillCycleCount + 1, 3)} of 3
                                    </p>
                                </>
                            ) : (
                                <div style={{ textAlign: 'center', padding: '0 0.5rem' }}>
                                    <p style={{ fontSize: '0.9rem', opacity: 0.88, marginBottom: '1rem', color: 'rgba(255, 255, 255, 0.88)', fontFamily: "'DM Sans', sans-serif" }}>Go again or continue?</p>
                                </div>
                            )}
                        </div>
                        {nsrDrillRoundComplete ? (
                            <div style={{ flexShrink: 0, display: 'flex', flexDirection: 'column', gap: '0.5rem', padding: '0.75rem', borderTop: '1px solid rgba(255, 255, 255, 0.14)' }}>
                                <button
                                    type="button"
                                    className="popupButton"
                                    onClick={() => {
                                        nsrBeginDrillRound();
                                    }}
                                    style={triggerPrimaryButtonStyle}
                                >
                                    Go again
                                </button>
                                <button
                                    type="button"
                                    onClick={() => setNsrStep(5)}
                                    style={{ ...triggerPrimaryButtonStyle, border: '1px solid rgba(255, 255, 255, 0.28)' }}
                                >
                                    Continue
                                </button>
                            </div>
                        ) : null}
                    </div>
                ) : nsrStep === 5 ? (
                    <>
                        <div style={triggerFlowScrollStyle}>
                            <h2 style={{ ...triggerHeadlineStyle, marginTop: '0.35rem', marginBottom: '1rem', textAlign: 'center', fontSize: 'clamp(1.05rem, 3.9vw, 1.4rem)' }}>How activated are you now?</h2>
                            <div style={{ width: '100%', maxWidth: '100%', padding: '0 0.25rem', boxSizing: 'border-box' }}>
                                <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '0.72rem', opacity: 0.72, marginBottom: '0.35rem', color: 'rgba(255, 255, 255, 0.75)', fontFamily: "'DM Sans', sans-serif" }}>
                                    <span>settled</span>
                                    <span>wired</span>
                                </div>
                                <input
                                    type="range"
                                    min={1}
                                    max={10}
                                    value={nsrActivationAfter}
                                    onChange={(e) => setNsrActivationAfter(Number(e.target.value))}
                                    style={{ width: '100%', maxWidth: '100%', boxSizing: 'border-box' }}
                                />
                                <div style={{ textAlign: 'center', marginTop: '0.75rem', fontSize: '1.6rem', fontWeight: 500, color: '#fff', fontFamily: "'Fraunces', serif" }}>{nsrActivationAfter}</div>
                            </div>
                            <div style={{ ...triggerCardStyle, marginTop: '1.25rem', padding: '0.75rem', marginBottom: 0 }}>
                                {nsrImproved ? (
                                    <p className="questionInfo" style={{ width: '100%', maxWidth: '100%', margin: 0, textAlign: 'center', opacity: 0.85 }}>
                                        You moved from {nsrActivationBefore} to {nsrActivationAfter}.
                                    </p>
                                ) : (
                                    <p className="questionInfo" style={{ width: '100%', maxWidth: '100%', margin: 0, textAlign: 'center', opacity: 0.85 }}>
                                        Some sessions take longer to land. That is normal.
                                    </p>
                                )}
                            </div>
                        </div>
                        <div style={triggerFlowFooterStyle}>
                            <button type="button" className="popupButton" style={triggerPrimaryButtonStyle} onClick={() => setNsrStep(6)}>
                                Continue
                            </button>
                        </div>
                    </>
                ) : nsrStep === 6 ? (
                    <>
                        <div style={triggerFlowScrollStyle}>
                            <p className="questionInfo" style={triggerMetaStyle}>optional</p>
                            <h2 style={{ ...triggerHeadlineStyle, marginBottom: '0.35rem', fontSize: 'clamp(1rem, 3.8vw, 1.28rem)' }}>
                                Did you notice any of these earlier today — before you opened this workout?
                            </h2>
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '0.4rem', width: '100%', maxWidth: '100%', marginTop: '0.5rem' }}>
                                {NSR_BODY_SIGNALS.map((sig) => (
                                    <button
                                        key={sig}
                                        type="button"
                                        onClick={() =>
                                            setNsrSignalsEarlier((prev) => (prev.includes(sig) ? prev.filter((x) => x !== sig) : [...prev, sig]))
                                        }
                                        style={{
                                            textAlign: 'left',
                                            padding: '0.5rem 0.6rem',
                                            borderRadius: '999px',
                                            border: nsrSignalsEarlier.includes(sig) ? '1px solid rgba(255, 255, 255, 0.45)' : '1px solid rgba(255, 255, 255, 0.2)',
                                            background: nsrSignalsEarlier.includes(sig) ? 'rgba(255, 255, 255, 0.2)' : 'rgba(255, 255, 255, 0.08)',
                                            fontSize: '0.85rem',
                                            cursor: 'pointer',
                                            width: '100%',
                                            maxWidth: '100%',
                                            boxSizing: 'border-box',
                                            color: 'rgba(255, 255, 255, 0.9)',
                                            fontFamily: "'DM Sans', sans-serif",
                                        }}
                                    >
                                        {sig}
                                    </button>
                                ))}
                            </div>
                            {nsrSignalsEarlier.length > 0 ? (
                                <div style={{ marginTop: '1rem', width: '100%', maxWidth: '100%' }}>
                                    <p className="questionInfo" style={{ textAlign: 'left', width: '100%', marginBottom: '0.35rem', opacity: 0.75 }}>When did you first notice them?</p>
                                    <select
                                        value={nsrWhenNoticedSlot}
                                        onChange={(e) => setNsrWhenNoticedSlot(e.target.value)}
                                        style={{ ...triggerInputStyle, padding: '0.45rem', marginBottom: '0.5rem' }}
                                    >
                                        <option value="">Pick a time (optional)</option>
                                        {NSR_TIME_SLOTS.map((t) => (
                                            <option key={t} value={t}>
                                                {t}
                                            </option>
                                        ))}
                                    </select>
                                    <textarea
                                        rows={2}
                                        value={nsrWhenNoticedText}
                                        onChange={(e) => setNsrWhenNoticedText(e.target.value)}
                                        placeholder="Or jot a quick note"
                                        style={{ ...triggerInputStyle, padding: '0.45rem', resize: 'vertical' }}
                                    />
                                </div>
                            ) : null}
                        </div>
                        <div style={triggerFlowFooterStyle}>
                            <button type="button" className="popupButton" style={triggerPrimaryButtonStyle} onClick={() => setNsrStep(7)}>
                                Continue
                            </button>
                            <button type="button" onClick={() => setNsrStep(7)} style={{ border: 'none', background: 'none', marginTop: '0.55rem', fontSize: '0.78rem', color: 'rgba(255, 255, 255, 0.72)', fontFamily: "'DM Sans', sans-serif" }}>
                                Skip
                            </button>
                        </div>
                    </>
                ) : (
                    <>
                        <div style={triggerFlowScrollStyle}>
                            <h2 style={{ ...triggerHeadlineStyle, marginTop: '0.75rem', textAlign: 'center', fontSize: 'clamp(1.1rem, 4vw, 1.45rem)' }}>Workout logged.</h2>
                            <p className="questionInfo" style={{ width: '100%', maxWidth: '100%', textAlign: 'center', marginTop: '0.75rem', opacity: 0.82, lineHeight: 1.45 }}>
                                {nsrCompleteReflection}
                            </p>
                        </div>
                        <div style={triggerFlowFooterStyle}>
                            <button
                                type="button"
                                className="popupButton"
                                style={triggerPrimaryButtonStyle}
                                onClick={() => {
                                    submitNsrSession();
                                    handleCloseLearningPopup();
                                }}
                            >
                                Back to training floor
                            </button>
                        </div>
                    </>
                )}
            </div>
        </div>
    );

    const maSurfaceQuoteBlock = (
        <div
            style={{
                opacity: 0.9,
                fontStyle: 'italic',
                fontFamily: "'Fraunces', serif",
                borderLeft: '3px solid rgba(255, 255, 255, 0.32)',
                paddingLeft: '0.65rem',
                marginBottom: '0.85rem',
                width: '100%',
                maxWidth: '100%',
                overflowWrap: 'break-word',
                wordBreak: 'break-word',
                boxSizing: 'border-box',
                color: 'rgba(255, 255, 255, 0.88)',
            }}
        >
            &ldquo;{maSurface.trim() || '…'}&rdquo;
        </div>
    );

    const maExerciseAssets = (
        <div
            className="learningFeedback"
            style={{
                flex: 1,
                minHeight: 0,
                maxHeight: '100%',
                height: '100%',
                textAlign: 'left',
                padding: '0 0.75rem',
                alignItems: 'stretch',
                display: 'flex',
                flexDirection: 'column',
                overflow: 'hidden',
                width: '100%',
                maxWidth: '100%',
                boxSizing: 'border-box',
                position: 'relative',
            }}
        >
            <div style={triggerFlowShellStyle}>
                {(maStep > 1 || (maStep === 4 && maExLevel > 1)) && !maExPause && !maBuildingArc && maStep < 7 ? (
                    <div className="popupButtonGroup" style={{ position: 'static', width: '100%', flexShrink: 0, marginTop: 0, marginBottom: '0.25rem' }}>
                        <button type="button" className="landing-onboarding-top-back" onClick={maStepBack} aria-label="Previous step">
                            <svg width="22" height="22" viewBox="0 0 14 14" fill="none" aria-hidden="true">
                                <path d="M11 7H3M7 3L3 7l4 4" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </button>
                    </div>
                ) : null}
                {maStep === 1 ? (
                    <>
                        <div style={triggerFlowScrollStyle}>
                            <p className="questionInfo" style={triggerMetaStyle}>
                                surface
                            </p>
                            <h2 style={{ ...triggerHeadlineStyle, marginBottom: '0.45rem', fontSize: 'clamp(1.05rem, 3.9vw, 1.38rem)' }}>
                                What&apos;s on your mind that you keep coming back to?
                            </h2>
                            <p className="questionInfo" style={{ ...triggerMetaStyle, textTransform: 'none', letterSpacing: 'normal', fontSize: '0.82rem', lineHeight: 1.45 }}>
                                It could be a thought, a situation, a decision, a feeling, or a pattern. Don&apos;t overthink the category — just name what&apos;s there.
                            </p>
                            <textarea
                                rows={3}
                                value={maSurface}
                                maxLength={100}
                                onChange={(e) => setMaSurface(e.target.value.slice(0, 100))}
                                placeholder={'e.g. "I keep saying yes when I mean no"'}
                                style={{ ...triggerInputStyle, marginTop: '0.65rem', resize: 'vertical' }}
                            />
                            <p className="questionInfo" style={{ textAlign: 'left', width: '100%', maxWidth: '100%', marginTop: '0.35rem', fontSize: '0.72rem', opacity: 0.65, color: 'rgba(255, 255, 255, 0.65)', fontFamily: "'DM Sans', sans-serif" }}>
                                {maSurface.length}/100
                            </p>
                            <p className="questionInfo" style={{ ...triggerMetaStyle, textTransform: 'none', letterSpacing: 'normal', marginTop: '0.5rem', fontSize: '0.82rem', lineHeight: 1.45 }}>
                                Examples: &ldquo;I keep saying yes when I mean no&rdquo; · &ldquo;I can&apos;t stop thinking about that conversation&rdquo; · &ldquo;I don&apos;t know why I keep starting things I don&apos;t finish&rdquo;
                            </p>
                            <p className="questionInfo" style={{ ...triggerMetaStyle, textTransform: 'none', letterSpacing: 'normal', marginTop: '0.85rem', fontSize: '0.82rem', lineHeight: 1.45 }}>
                                Write the version that&apos;s actually in your head. Don&apos;t clean it up.
                            </p>
                        </div>
                        <div style={triggerFlowFooterStyle}>
                            <button type="button" className="popupButton" disabled={!maSurface.trim()} style={{ ...triggerPrimaryButtonStyle, opacity: maSurface.trim() ? 1 : 0.45 }} onClick={() => { maStartSection('behavior'); setMaStep(2); }}>
                                Continue
                            </button>
                        </div>
                    </>
                ) : maStep === 2 ? (
                    <>
                        <div style={triggerFlowScrollStyle}>
                            {maSurfaceQuoteBlock}
                            <p className="questionInfo" style={triggerMetaStyle}>the behavior</p>
                            <h2 style={{ ...triggerHeadlineStyle, marginBottom: '0.45rem', fontSize: 'clamp(1.05rem, 3.9vw, 1.35rem)' }}>
                                When this comes up, what do you usually do?
                            </h2>
                            <p className="questionInfo" style={{ ...triggerMetaStyle, textTransform: 'none', letterSpacing: 'normal', fontSize: '0.82rem', lineHeight: 1.45 }}>
                                Not what you wish you did. What you actually do — avoid it, push through, go quiet, get busy, pick a fight.
                            </p>
                            <p className="questionInfo" style={{ ...triggerMetaStyle, textTransform: 'none', letterSpacing: 'normal', marginTop: '0.45rem', fontSize: '0.82rem', lineHeight: 1.45 }}>
                                Two or three sentences max. This grounds the work in behavior before belief — the gap between what you do and what you want to do is often where the real material lives.
                            </p>
                            <textarea
                                rows={4}
                                value={maBehavior}
                                onChange={(e) => setMaBehavior(e.target.value)}
                                placeholder="What you actually do when it shows up…"
                                style={{ ...triggerInputStyle, marginTop: '0.65rem', resize: 'vertical' }}
                            />
                        </div>
                        <div style={triggerFlowFooterStyle}>
                            <button type="button" className="popupButton" disabled={!maBehavior.trim()} style={{ ...triggerPrimaryButtonStyle, opacity: maBehavior.trim() ? 1 : 0.45 }} onClick={() => { maStartSection('protection'); setMaStep(3); }}>
                                Continue
                            </button>
                        </div>
                    </>
                ) : maStep === 3 ? (
                    <>
                        <div style={triggerFlowScrollStyle}>
                            {maSurfaceQuoteBlock}
                            <p className="questionInfo" style={triggerMetaStyle}>the protection layer</p>
                            <h2 style={{ ...triggerHeadlineStyle, marginBottom: '0.45rem', fontSize: 'clamp(1.05rem, 3.9vw, 1.35rem)' }}>
                                What does this thought or pattern protect you from?
                            </h2>
                            <p className="questionInfo" style={{ ...triggerMetaStyle, textTransform: 'none', letterSpacing: 'normal', fontSize: '0.82rem', lineHeight: 1.45 }}>
                                It might protect you from disappointment, from trying, from needing people, from being seen.
                            </p>
                            <textarea
                                rows={4}
                                value={maProtectionLayer}
                                onChange={(e) => setMaProtectionLayer(e.target.value)}
                                placeholder="What staying in this pattern keeps you safe from…"
                                style={{ ...triggerInputStyle, marginTop: '0.85rem', resize: 'vertical' }}
                            />
                        </div>
                        <div style={triggerFlowFooterStyle}>
                            <button
                                type="button"
                                className="popupButton"
                                disabled={!maProtectionLayer.trim()}
                                style={{ ...triggerPrimaryButtonStyle, opacity: maProtectionLayer.trim() ? 1 : 0.45 }}
                                onClick={() => {
                                    maStartSection('excavation');
                                    setMaStep(4);
                                    setMaExLevel(1);
                                    setMaExPause(false);
                                }}
                            >
                                Continue
                            </button>
                        </div>
                    </>
                ) : maStep === 4 && maExPause ? (
                    <div style={{ ...triggerFlowScrollStyle, display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '12rem' }}>
                        <p style={{ fontSize: '1.25rem', fontFamily: "'Fraunces', serif", fontStyle: 'italic', opacity: 0.9, letterSpacing: '0.02em', color: '#fff' }}>One more.</p>
                    </div>
                ) : maStep === 4 ? (
                    <>
                        <div style={{ ...triggerFlowScrollStyle, transition: 'opacity 0.35s ease' }}>
                            {maSurfaceQuoteBlock}
                            <p className="questionInfo" style={triggerMetaStyle}>excavation</p>
                            {maExLevel === 1 ? (
                                <>
                                    <h2 style={{ ...triggerHeadlineStyle, marginBottom: '0.45rem', fontSize: 'clamp(1.02rem, 3.8vw, 1.28rem)' }}>
                                        Belief
                                    </h2>
                                    <p className="questionInfo" style={{ textAlign: 'left', width: '100%', maxWidth: '100%', opacity: 0.78, lineHeight: 1.45, marginBottom: '0.5rem' }}>
                                        What does that tell you about what you believe — about yourself, about people, about how the world works?
                                    </p>
                                    <textarea rows={4} value={maBeliefLevel} onChange={(e) => setMaBeliefLevel(e.target.value)} style={{ ...triggerInputStyle, resize: 'vertical' }} />
                                </>
                            ) : null}
                            {maExLevel === 2 ? (
                                <>
                                    <h2 style={{ ...triggerHeadlineStyle, marginBottom: '0.45rem', fontSize: 'clamp(1.02rem, 3.8vw, 1.28rem)' }}>
                                        Value
                                    </h2>
                                    <p className="questionInfo" style={{ textAlign: 'left', width: '100%', maxWidth: '100%', opacity: 0.78, lineHeight: 1.45, marginBottom: '0.5rem' }}>
                                        What does that belief say about what you think you have to earn or prove?
                                    </p>
                                    <textarea rows={4} value={maValueLevel} onChange={(e) => setMaValueLevel(e.target.value)} style={{ ...triggerInputStyle, resize: 'vertical' }} />
                                </>
                            ) : null}
                            {maExLevel === 3 ? (
                                <>
                                    <h2 style={{ ...triggerHeadlineStyle, marginBottom: '0.45rem', fontSize: 'clamp(1.02rem, 3.8vw, 1.28rem)' }}>
                                        Origin
                                    </h2>
                                    <p className="questionInfo" style={{ textAlign: 'left', width: '100%', maxWidth: '100%', opacity: 0.78, lineHeight: 1.45, marginBottom: '0.5rem' }}>
                                        Where did you first learn that?
                                    </p>
                                    <textarea rows={4} value={maOriginLevel} onChange={(e) => setMaOriginLevel(e.target.value)} style={{ ...triggerInputStyle, resize: 'vertical' }} />
                                </>
                            ) : null}
                            {maExLevel === 4 ? (
                                <>
                                    <h2 style={{ ...triggerHeadlineStyle, marginBottom: '0.45rem', fontSize: 'clamp(1.02rem, 3.8vw, 1.28rem)' }}>
                                        Identity
                                    </h2>
                                    <p className="questionInfo" style={{ textAlign: 'left', width: '100%', maxWidth: '100%', opacity: 0.78, lineHeight: 1.45, marginBottom: '0.5rem' }}>
                                        What kind of person does believing this make you?
                                    </p>
                                    <textarea rows={4} value={maIdentityLevel} onChange={(e) => setMaIdentityLevel(e.target.value)} style={{ ...triggerInputStyle, resize: 'vertical' }} />
                                </>
                            ) : null}
                            {maExLevel === 5 ? (
                                <div style={{ ...triggerCardStyle, border: '1px solid rgba(255, 255, 255, 0.2)', borderRadius: '14px', padding: '0.85rem 0.75rem', marginTop: '0.15rem' }}>
                                    <p className="questionInfo" style={{ textAlign: 'left', width: '100%', maxWidth: '100%', opacity: 0.75, letterSpacing: '0.06em', fontSize: '0.62rem', textTransform: 'uppercase' }}>
                                        the inflection
                                    </p>
                                    <h2 style={{ ...triggerHeadlineStyle, marginTop: '0.35rem', marginBottom: '0.55rem', fontSize: '1.12rem', fontWeight: 500, lineHeight: 1.35 }}>
                                        Is that who you are — or just who you learned to be?
                                    </h2>
                                    <textarea
                                        rows={3}
                                        value={maInflectionLevel}
                                        onChange={(e) => setMaInflectionLevel(e.target.value)}
                                        placeholder="What comes up…"
                                        style={{ ...triggerInputStyle, resize: 'vertical' }}
                                    />
                                </div>
                            ) : null}
                        </div>
                        <div style={triggerFlowFooterStyle}>
                            <button
                                type="button"
                                className="popupButton"
                                disabled={
                                    (maExLevel === 1 && !maBeliefLevel.trim()) ||
                                    (maExLevel === 2 && !maValueLevel.trim()) ||
                                    (maExLevel === 3 && !maOriginLevel.trim()) ||
                                    (maExLevel === 4 && !maIdentityLevel.trim()) ||
                                    (maExLevel === 5 && !maInflectionLevel.trim())
                                }
                                style={{
                                    ...triggerPrimaryButtonStyle,
                                    opacity:
                                        (maExLevel === 1 && maBeliefLevel.trim()) ||
                                        (maExLevel === 2 && maValueLevel.trim()) ||
                                        (maExLevel === 3 && maOriginLevel.trim()) ||
                                        (maExLevel === 4 && maIdentityLevel.trim()) ||
                                        (maExLevel === 5 && maInflectionLevel.trim())
                                            ? 1
                                            : 0.45,
                                }}
                                onClick={() => {
                                    if (maExLevel < 4) {
                                        setMaExLevel((n) => n + 1);
                                        return;
                                    }
                                    if (maExLevel === 4) {
                                        setMaExPause(true);
                                        return;
                                    }
                                    maStartSection('newBelief');
                                    setMaStep(5);
                                    setMaExLevel(1);
                                }}
                            >
                                Continue
                            </button>
                        </div>
                    </>
                ) : maStep === 5 && !maBuildingArc ? (
                    <>
                        <div style={triggerFlowScrollStyle}>
                            {maSurfaceQuoteBlock}
                            <p className="questionInfo" style={triggerMetaStyle}>the new belief</p>
                            <h2 style={{ ...triggerHeadlineStyle, marginBottom: '0.45rem', fontSize: 'clamp(1.05rem, 3.9vw, 1.35rem)' }}>
                                What would you need to believe about yourself for this to shift?
                            </h2>
                            <p className="questionInfo" style={{ ...triggerMetaStyle, textTransform: 'none', letterSpacing: 'normal', fontSize: '0.82rem', lineHeight: 1.45 }}>
                                It doesn&apos;t have to feel true yet. You&apos;re not committing to it. You&apos;re just trying it on.
                            </p>
                            <textarea
                                rows={3}
                                value={maNewBelief}
                                maxLength={120}
                                onChange={(e) => setMaNewBelief(e.target.value.slice(0, 120))}
                                placeholder="One sentence you could try on…"
                                style={{ ...triggerInputStyle, marginTop: '0.65rem', resize: 'vertical' }}
                            />
                            <p className="questionInfo" style={{ textAlign: 'left', width: '100%', maxWidth: '100%', marginTop: '0.35rem', fontSize: '0.72rem', opacity: 0.65 }}>
                                {maNewBelief.length}/120 · one sentence
                            </p>
                        </div>
                        <div style={triggerFlowFooterStyle}>
                            <button
                                type="button"
                                className="popupButton"
                                disabled={!maNewBelief.trim()}
                                style={{ ...triggerPrimaryButtonStyle, opacity: maNewBelief.trim() ? 1 : 0.45 }}
                                onClick={() => {
                                    maFlushActiveSection();
                                    maActiveSectionKeyRef.current = null;
                                    maSectionStartedAtRef.current = 0;
                                    setMaBuildingArc(true);
                                }}
                            >
                                Continue
                            </button>
                        </div>
                    </>
                ) : maStep === 5 && maBuildingArc ? (
                    <div style={{ flex: 1, minHeight: '10rem' }} aria-hidden />
                ) : maStep === 6 ? (
                    <>
                        <div style={triggerFlowScrollStyle}>
                            <p className="questionInfo" style={triggerMetaStyle}>the arc</p>
                            <h2 style={{ ...triggerHeadlineStyle, marginBottom: '0.85rem', fontSize: 'clamp(1.05rem, 3.9vw, 1.35rem)' }}>
                                What you&apos;re carrying
                            </h2>
                            <div style={{ marginBottom: '1.1rem' }}>{maSurfaceQuoteBlock}</div>
                            <p className="questionInfo" style={{ fontSize: '0.62rem', letterSpacing: '0.08em', opacity: 0.65, marginBottom: '0.25rem' }}>What it protects</p>
                            <p style={{ marginBottom: '1rem', lineHeight: 1.45, overflowWrap: 'break-word', color: 'rgba(255, 255, 255, 0.86)', fontFamily: "'DM Sans', sans-serif" }}>{maProtectionLayer.trim() || '—'}</p>
                            <p className="questionInfo" style={{ fontSize: '0.62rem', letterSpacing: '0.08em', opacity: 0.65, marginBottom: '0.25rem' }}>Where it came from</p>
                            <p style={{ marginBottom: '1rem', lineHeight: 1.45, overflowWrap: 'break-word', color: 'rgba(255, 255, 255, 0.86)', fontFamily: "'DM Sans', sans-serif" }}>{maOriginLevel.trim() || '—'}</p>
                            <p className="questionInfo" style={{ fontSize: '0.62rem', letterSpacing: '0.08em', opacity: 0.65, marginBottom: '0.25rem' }}>Who it made you</p>
                            <p style={{ marginBottom: '1rem', lineHeight: 1.45, overflowWrap: 'break-word', color: 'rgba(255, 255, 255, 0.86)', fontFamily: "'DM Sans', sans-serif" }}>{maIdentityLevel.trim() || '—'}</p>
                            <p className="questionInfo" style={{ fontSize: '0.62rem', letterSpacing: '0.08em', opacity: 0.65, marginBottom: '0.25rem' }}>Who you&apos;re choosing instead</p>
                            <p style={{ fontWeight: 500, fontSize: '1.02rem', lineHeight: 1.45, overflowWrap: 'break-word', fontFamily: "'Fraunces', serif", color: '#fff' }}>{maNewBelief.trim() || '—'}</p>
                        </div>
                        <div style={triggerFlowFooterStyle}>
                            {maArcLogVisible ? (
                                <button
                                    type="button"
                                    className="popupButton"
                                    style={triggerPrimaryButtonStyle}
                                    onClick={() => {
                                        submitMindsetSession({ abandoned: false });
                                        maSessionLoggedRef.current = true;
                                        setMaStep(7);
                                    }}
                                >
                                    Log this rep
                                </button>
                            ) : (
                                <p className="questionInfo" style={{ margin: 0, opacity: 0.5, fontSize: '0.78rem' }}>&nbsp;</p>
                            )}
                        </div>
                    </>
                ) : (
                    <>
                        <div style={triggerFlowScrollStyle}>
                            <p className="questionInfo" style={{ textAlign: 'center', width: '100%', maxWidth: '100%', opacity: 0.82, lineHeight: 1.55, fontSize: '0.95rem', color: 'rgba(255, 255, 255, 0.86)', fontFamily: "'DM Sans', sans-serif" }}>
                                You came in carrying &ldquo;{maSurface.trim() || '…'}&rdquo;. You leave with &ldquo;{maNewBelief.trim() || '…'}&rdquo;. That distance is the rep.
                            </p>
                        </div>
                        <div style={triggerFlowFooterStyle}>
                            <button type="button" className="popupButton" style={triggerPrimaryButtonStyle} onClick={handleCloseLearningPopup}>
                                Back to Training Floor
                            </button>
                        </div>
                    </>
                )}
            </div>
            {maStep === 5 && maBuildingArc ? (
                <div
                    style={{
                        position: 'absolute',
                        inset: 0,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        background: 'rgba(10, 14, 18, 0.9)',
                        zIndex: 3,
                        flexDirection: 'column',
                    }}
                >
                    <p style={{ fontFamily: "'Fraunces', serif", fontSize: '1.2rem', fontStyle: 'italic', opacity: 0.95, color: '#fff', textAlign: 'center', padding: '0 1rem' }}>Building your arc.</p>
                </div>
            ) : null}
        </div>
    );

    const eceQuadrantLive = eceGetQuadrant(eceGridX, eceGridY);
    const eceLabelWords = ECE_QUADRANT_WORDS[eceQuadrantLive] || ECE_QUADRANT_WORDS.low_energy_pleasant;
    const eceFeelingForCopy = eceCurrentFeelingWord();
    const eceFeelingLower = eceFeelingForCopy.toLowerCase();
    const eceNormalizeLine =
        ECE_BODY_NORMALIZE[eceFeelingLower] ||
        'What you feel often shows up somewhere in the body before you can name it fully.';
    const eceReflectionQ =
        ECE_REFLECTION_PROMPT[eceFeelingLower] || "What matters about how you're feeling right now?";
    const eceReframeLine =
        ECE_REFRAME_BY_FEELING[eceFeelingLower] || ECE_REFRAME_BY_QUADRANT[eceQuadrantLive] || ECE_REFRAME_BY_QUADRANT.low_energy_pleasant;

    const eceEyebrowStyle = { textAlign: 'left', opacity: 0.68, color: 'rgba(255,255,255,0.72)', letterSpacing: '0.08em', textTransform: 'uppercase', fontSize: '0.65rem' };
    const eceHeadingStyle = { marginTop: '0.2rem', marginBottom: '0.5rem', fontSize: 'clamp(1.25rem, 4vw, 1.65rem)', fontWeight: 300, fontFamily: "'Fraunces', serif", color: '#fff', lineHeight: 1.2 };
    const eceBodyStyle = { textAlign: 'left', opacity: 0.82, color: 'rgba(255,255,255,0.82)', fontSize: '0.84rem', lineHeight: 1.45, marginBottom: '0.7rem' };
    const eceChipStyle = (isActive) => ({
        textAlign: 'center',
        padding: '0.62rem 0.55rem',
        borderRadius: '999px',
        border: `1px solid ${isActive ? 'rgba(255,255,255,0.62)' : 'rgba(255,255,255,0.35)'}`,
        background: isActive ? 'rgba(255,255,255,0.14)' : 'transparent',
        color: '#fff',
        fontFamily: "'DM Sans', sans-serif",
        fontSize: '0.84rem',
        fontWeight: 500,
        cursor: 'pointer',
        boxSizing: 'border-box',
    });

    const eceExerciseAssets = (
        <div
            className="learningFeedback"
            style={{
                flex: 1,
                minHeight: 0,
                maxHeight: '100%',
                height: '100%',
                textAlign: 'left',
                padding: '0 0.75rem',
                alignItems: 'stretch',
                display: 'flex',
                flexDirection: 'column',
                overflow: 'hidden',
                width: '100%',
                maxWidth: '100%',
                boxSizing: 'border-box',
            }}
        >
            <div style={triggerFlowShellStyle}>
                {eceStep > 1 && eceStep < 6 ? (
                    <div className="popupButtonGroup" style={{ position: 'static', width: '100%', flexShrink: 0, marginTop: 0, marginBottom: '0.25rem' }}>
                        <button type="button" className="landing-onboarding-top-back" onClick={eceStepBack} aria-label="Previous step">
                            <svg width="22" height="22" viewBox="0 0 14 14" fill="none" aria-hidden="true">
                                <path d="M11 7H3M7 3L3 7l4 4" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </button>
                    </div>
                ) : null}
                {eceStep === 1 ? (
                    <>
                        <div style={triggerFlowScrollStyle}>
                            <p className="questionInfo" style={eceEyebrowStyle}>the grid</p>
                            <h2 style={eceHeadingStyle}>Where are you right now?</h2>
                            <p className="questionInfo" style={eceBodyStyle}>
                                Place yourself where you are right now. Don&apos;t think too hard.
                            </p>
                            <div
                                style={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    alignItems: 'stretch',
                                    justifyContent: 'center',
                                    gap: '0.45rem',
                                    width: '100%',
                                    maxWidth: '100%',
                                    boxSizing: 'border-box',
                                }}
                            >
                                <div
                                    style={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'space-between',
                                        alignItems: 'center',
                                        fontSize: '0.65rem',
                                        letterSpacing: '0.04em',
                                        opacity: 0.68,
                                        width: '1.25rem',
                                        flexShrink: 0,
                                        paddingTop: '0.35rem',
                                        paddingBottom: '0.35rem',
                                        minHeight: 200,
                                    }}
                                >
                                    <span style={{ writingMode: 'vertical-rl', transform: 'rotate(180deg)', textAlign: 'center' }}>Unpleasant</span>
                                    <span style={{ writingMode: 'vertical-rl', transform: 'rotate(180deg)', textAlign: 'center' }}>Pleasant</span>
                                </div>
                                <div style={{ flex: '0 1 280px', maxWidth: '100%', minWidth: 0 }}>
                                    <div
                                        ref={eceGridRef}
                                        role="application"
                                        aria-label="Energy and mood grid. Drag to place how you feel."
                                        onPointerDown={(e) => {
                                            e.preventDefault();
                                            eceGridDraggingRef.current = true;
                                            try {
                                                e.currentTarget.setPointerCapture(e.pointerId);
                                            } catch (_) {
                                                /* ignore */
                                            }
                                            eceUpdateGridFromClient(e.clientX, e.clientY);
                                        }}
                                        onPointerMove={(e) => {
                                            if (!eceGridDraggingRef.current) return;
                                            eceUpdateGridFromClient(e.clientX, e.clientY);
                                        }}
                                        onPointerUp={(e) => {
                                            eceGridDraggingRef.current = false;
                                            try {
                                                e.currentTarget.releasePointerCapture(e.pointerId);
                                            } catch (_) {
                                                /* ignore */
                                            }
                                        }}
                                        onPointerCancel={() => {
                                            eceGridDraggingRef.current = false;
                                        }}
                                        style={{
                                            position: 'relative',
                                            width: '100%',
                                            aspectRatio: '1',
                                            maxHeight: 280,
                                            margin: '0 auto',
                                            borderRadius: '16px',
                                            border: '1px solid rgba(255,255,255,0.22)',
                                            background: 'linear-gradient(160deg, rgba(255,255,255,0.10), rgba(255,255,255,0.03))',
                                            touchAction: 'none',
                                            cursor: 'grab',
                                            overflow: 'hidden',
                                            boxShadow: eceGridPlaced ? 'inset 0 0 0 1px rgba(255,255,255,0.08)' : 'none',
                                        }}
                                    >
                                        {eceGridPlaced ? (
                                            <>
                                                <div
                                                    style={{
                                                        position: 'absolute',
                                                        left: 0,
                                                        top: 0,
                                                        width: '50%',
                                                        height: '50%',
                                                        background: 'rgba(120, 140, 180, 0.07)',
                                                        pointerEvents: 'none',
                                                    }}
                                                />
                                                <div
                                                    style={{
                                                        position: 'absolute',
                                                        left: '50%',
                                                        top: 0,
                                                        width: '50%',
                                                        height: '50%',
                                                        background: 'rgba(200, 120, 110, 0.08)',
                                                        pointerEvents: 'none',
                                                    }}
                                                />
                                                <div
                                                    style={{
                                                        position: 'absolute',
                                                        left: 0,
                                                        top: '50%',
                                                        width: '50%',
                                                        height: '50%',
                                                        background: 'rgba(130, 150, 140, 0.07)',
                                                        pointerEvents: 'none',
                                                    }}
                                                />
                                                <div
                                                    style={{
                                                        position: 'absolute',
                                                        left: '50%',
                                                        top: '50%',
                                                        width: '50%',
                                                        height: '50%',
                                                        background: 'rgba(220, 190, 120, 0.08)',
                                                        pointerEvents: 'none',
                                                    }}
                                                />
                                                <div
                                                    style={{
                                                        position: 'absolute',
                                                        left: '50%',
                                                        top: 0,
                                                        bottom: 0,
                                                        width: 1,
                                                        background: 'rgba(255,255,255,0.14)',
                                                        pointerEvents: 'none',
                                                    }}
                                                />
                                                <div
                                                    style={{
                                                        position: 'absolute',
                                                        top: '50%',
                                                        left: 0,
                                                        right: 0,
                                                        height: 1,
                                                        background: 'rgba(255,255,255,0.14)',
                                                        pointerEvents: 'none',
                                                    }}
                                                />
                                            </>
                                        ) : null}
                                        {!eceGridPlaced ? (
                                            <div
                                                style={{
                                                    position: 'absolute',
                                                    left: '50%',
                                                    top: '50%',
                                                    transform: 'translate(-50%, -50%)',
                                                    fontSize: '0.78rem',
                                                    opacity: 0.55,
                                                    color: 'rgba(255,255,255,0.85)',
                                                    pointerEvents: 'none',
                                                    textAlign: 'center',
                                                    padding: '0 0.5rem',
                                                }}
                                            >
                                                Tap or drag
                                            </div>
                                        ) : (
                                            <div
                                                style={{
                                                    position: 'absolute',
                                                    left: `${eceGridX * 100}%`,
                                                    top: `${eceGridY * 100}%`,
                                                    width: 22,
                                                    height: 22,
                                                    marginLeft: -11,
                                                    marginTop: -11,
                                                    borderRadius: '50%',
                                                    background: 'radial-gradient(circle at 32% 32%, #ffffff, #cfd8e1)',
                                                    boxShadow: '0 2px 10px rgba(255,255,255,0.26)',
                                                    pointerEvents: 'none',
                                                    transition: 'box-shadow 0.2s ease',
                                                }}
                                            />
                                        )}
                                    </div>
                                    <div
                                        style={{
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            alignItems: 'center',
                                            fontSize: '0.65rem',
                                            opacity: 0.68,
                                            marginTop: '0.45rem',
                                            paddingLeft: '0.15rem',
                                            paddingRight: '0.15rem',
                                        }}
                                    >
                                        <span>Low energy</span>
                                        <span>High energy</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div style={triggerFlowFooterStyle}>
                            <button type="button" className="popupButton" disabled={!eceGridPlaced} style={{ opacity: eceGridPlaced ? 1 : 0.45 }} onClick={() => setEceStep(2)}>
                                Continue
                            </button>
                        </div>
                    </>
                ) : eceStep === 2 ? (
                    <>
                        <div style={triggerFlowScrollStyle}>
                            <p className="questionInfo" style={eceEyebrowStyle}>the label</p>
                            <h2 style={eceHeadingStyle}>Which word fits best?</h2>
                            <p className="questionInfo" style={eceBodyStyle}>
                                One tap. This expands your vocabulary without forcing a perfect label.
                            </p>
                            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0.45rem', width: '100%', maxWidth: '100%' }}>
                                {eceLabelWords.map((w) => (
                                    <button
                                        key={w}
                                        type="button"
                                        onClick={() => {
                                            setEceFeelingKey(w);
                                            setEceUseCustomFeeling(false);
                                            setEceCustomFeeling('');
                                        }}
                                        style={eceChipStyle(eceFeelingKey === w && !eceUseCustomFeeling)}
                                    >
                                        {eceFormatFeelingLabel(w)}
                                    </button>
                                ))}
                            </div>
                            <button
                                type="button"
                                onClick={() => {
                                    setEceUseCustomFeeling(true);
                                    setEceFeelingKey(null);
                                }}
                                style={{
                                    marginTop: '0.65rem',
                                    border: 'none',
                                    background: 'none',
                                    fontSize: '0.8rem',
                                    color: 'rgba(255,255,255,0.72)',
                                    textDecoration: 'underline',
                                    cursor: 'pointer',
                                    padding: '0.25rem 0',
                                    fontFamily: "'DM Sans', sans-serif",
                                }}
                            >
                                None of these
                            </button>
                            {eceUseCustomFeeling ? (
                                <textarea
                                    rows={2}
                                    value={eceCustomFeeling}
                                    onChange={(e) => setEceCustomFeeling(e.target.value)}
                                    placeholder="Name it in your own words (short)"
                                    style={{ ...triggerFieldStyle, padding: '0.5rem', borderRadius: '0.4rem', marginTop: '0.45rem', resize: 'vertical' }}
                                />
                            ) : null}
                        </div>
                        <div style={triggerFlowFooterStyle}>
                            <button
                                type="button"
                                className="popupButton"
                                disabled={!eceCurrentFeelingWord()}
                                style={{ opacity: eceCurrentFeelingWord() ? 1 : 0.45 }}
                                onClick={() => setEceStep(3)}
                            >
                                Continue
                            </button>
                        </div>
                    </>
                ) : eceStep === 3 ? (
                    <>
                        <div style={triggerFlowScrollStyle}>
                            <p className="questionInfo" style={eceEyebrowStyle}>body scan</p>
                            <h2 style={eceHeadingStyle}>Where do you feel this in your body?</h2>
                            <p className="questionInfo" style={eceBodyStyle}>
                                Tap all that apply.
                            </p>
                            <p className="questionInfo" style={{ textAlign: 'left', opacity: 0.78, lineHeight: 1.5, marginBottom: '0.65rem', fontStyle: 'italic', fontFamily: 'serif' }}>
                                {eceNormalizeLine}
                            </p>
                            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.4rem', width: '100%', maxWidth: '100%' }}>
                                {ECE_BODY_ZONES.map((z) => (
                                    <button
                                        key={z}
                                        type="button"
                                        onClick={() =>
                                            setEceBodyZonesSel((prev) => (prev.includes(z) ? prev.filter((x) => x !== z) : [...prev, z]))
                                        }
                                        style={eceChipStyle(eceBodyZonesSel.includes(z))}
                                    >
                                        {z}
                                    </button>
                                ))}
                            </div>
                        </div>
                        <div style={triggerFlowFooterStyle}>
                            <button
                                type="button"
                                className="popupButton"
                                disabled={eceBodyZonesSel.length === 0}
                                style={{ opacity: eceBodyZonesSel.length ? 1 : 0.45 }}
                                onClick={() => setEceStep(4)}
                            >
                                Continue
                            </button>
                        </div>
                    </>
                ) : eceStep === 4 ? (
                    <>
                        <div style={triggerFlowScrollStyle}>
                            <p className="questionInfo" style={eceEyebrowStyle}>reflection</p>
                            <h2 style={{ ...eceHeadingStyle, marginBottom: '0.45rem', lineHeight: 1.35 }}>{eceReflectionQ}</h2>
                            <p className="questionInfo" style={{ textAlign: 'left', opacity: 0.68, fontSize: '0.78rem', marginBottom: '0.4rem' }}>
                                Two or three sentences max. You can skip.
                            </p>
                            <textarea
                                rows={4}
                                value={eceReflectionText}
                                onChange={(e) => setEceReflectionText(e.target.value)}
                                placeholder="Optional…"
                                style={{ ...triggerFieldStyle, padding: '0.55rem', borderRadius: '0.4rem', resize: 'vertical' }}
                            />
                            <div
                                style={{
                                    marginTop: '1.25rem',
                                    padding: '0.85rem 0.75rem',
                                    borderLeft: '3px solid rgba(255,255,255,0.42)',
                                    background: 'rgba(255,255,255,0.06)',
                                    borderRadius: '0 0.45rem 0.45rem 0',
                                }}
                            >
                                <p className="questionInfo" style={{ margin: 0, fontSize: '0.62rem', letterSpacing: '0.07em', opacity: 0.65, textTransform: 'uppercase' }}>
                                    Say it out loud
                                </p>
                                <p style={{ margin: '0.45rem 0 0', fontSize: '0.95rem', lineHeight: 1.45, fontFamily: 'serif', fontStyle: 'italic' }}>
                                    I am feeling {eceFormatFeelingLabel(eceFeelingForCopy || 'this')}.
                                </p>
                                <p className="questionInfo" style={{ margin: '0.5rem 0 0', fontSize: '0.78rem', opacity: 0.72, lineHeight: 1.4 }}>
                                    Before you continue, say that line once — the saying-it-out-loud is the expression rep.
                                </p>
                            </div>
                        </div>
                        <div style={triggerFlowFooterStyle}>
                            <button type="button" className="popupButton" onClick={() => setEceStep(5)}>
                                Continue
                            </button>
                        </div>
                    </>
                ) : eceStep === 5 ? (
                    <>
                        <div style={triggerFlowScrollStyle}>
                            <p className="questionInfo" style={eceEyebrowStyle}>the close</p>
                            <p style={{ fontSize: '0.95rem', lineHeight: 1.55, marginTop: '0.35rem' }}>
                                Right now you&apos;re feeling <strong>{eceFormatFeelingLabel(eceFeelingForCopy || 'this')}</strong>.
                            </p>
                            <p style={{ fontSize: '0.95rem', lineHeight: 1.55, marginTop: '0.65rem' }}>
                                You feel it in your <strong>{eceFormatBodyZonesPhrase(eceBodyZonesSel)}</strong>.
                            </p>
                            <p style={{ fontSize: '0.95rem', lineHeight: 1.55, marginTop: '0.65rem' }}>That makes sense.</p>
                            <p
                                style={{
                                    marginTop: '1.1rem',
                                    fontSize: '0.9rem',
                                    lineHeight: 1.5,
                                    fontStyle: 'italic',
                                    fontFamily: 'serif',
                                    opacity: 0.88,
                                    borderTop: '1px solid #d8d6d3',
                                    paddingTop: '0.85rem',
                                }}
                            >
                                {eceReframeLine}
                            </p>
                        </div>
                        <div style={triggerFlowFooterStyle}>
                            <button
                                type="button"
                                className="popupButton"
                                onClick={() => {
                                    submitEceSession({ abandoned: false });
                                    eceSessionLoggedRef.current = true;
                                    setEceStep(6);
                                }}
                            >
                                Log this rep
                            </button>
                        </div>
                    </>
                ) : (
                    <>
                        <div style={triggerFlowScrollStyle}>
                            <p style={{ textAlign: 'center', fontSize: '0.95rem', lineHeight: 1.55, opacity: 0.82, marginTop: '0.5rem' }}>
                                Understanding how you feel is an important step in building emotional fitness.
                            </p>
                        </div>
                        <div style={triggerFlowFooterStyle}>
                            <button type="button" className="popupButton" onClick={handleCloseLearningPopup}>
                                Back to Training Floor
                            </button>
                        </div>
                    </>
                )}
            </div>
        </div>
    );

    const rrQuotedStyle = {
        opacity: 0.9,
        fontStyle: 'italic',
        fontFamily: "'Fraunces', serif",
        borderLeft: '3px solid rgba(255, 255, 255, 0.3)',
        paddingLeft: '0.65rem',
        marginBottom: '0.85rem',
        width: '100%',
        maxWidth: '100%',
        overflowWrap: 'break-word',
        wordBreak: 'break-word',
        boxSizing: 'border-box',
        color: 'rgba(255, 255, 255, 0.88)',
    };

    const rrWorkoutAssets = (
        <div
            className="learningFeedback"
            style={{
                flex: 1,
                minHeight: 0,
                maxHeight: '100%',
                height: '100%',
                textAlign: 'left',
                padding: '0 0.75rem',
                alignItems: 'stretch',
                display: 'flex',
                flexDirection: 'column',
                overflow: 'hidden',
                width: '100%',
                maxWidth: '100%',
                boxSizing: 'border-box',
            }}
        >
            <div style={triggerFlowShellStyle}>
                {(rrStep > 1 && rrStep < 5) ? (
                    <div className="popupButtonGroup" style={{ position: 'static', width: '100%', flexShrink: 0, marginTop: 0, marginBottom: '0.25rem' }}>
                        <button type="button" className="landing-onboarding-top-back" onClick={rrStepBack} aria-label="Previous step">
                            <svg width="22" height="22" viewBox="0 0 14 14" fill="none" aria-hidden="true">
                                <path d="M11 7H3M7 3L3 7l4 4" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </button>
                    </div>
                ) : null}
                {rrStep === 1 ? (
                    <>
                        <div style={triggerFlowScrollStyle}>
                            <p style={{ textAlign: 'left', opacity: 0.78, fontSize: '0.86rem', lineHeight: 1.45, fontStyle: 'italic', fontFamily: "'Fraunces', serif", color: 'rgba(255, 255, 255, 0.82)' }}>
                                This workout asks you to look at something hard. You&apos;ll leave with more than you came in with.
                            </p>
                            <p className="questionInfo" style={{ ...triggerMetaStyle, marginTop: '0.9rem' }}>
                                Resilience &amp; Purpose
                            </p>
                            <h2 style={{ ...triggerHeadlineStyle, marginBottom: '0.5rem', fontSize: 'clamp(1.07rem, 4vw, 1.38rem)' }}>
                                What&apos;s something that didn&apos;t go the way you wanted recently?
                            </h2>
                            <input
                                value={rrHeadline}
                                maxLength={120}
                                onChange={(e) => setRrHeadline(e.target.value.slice(0, 120))}
                                placeholder="A conversation, a decision, a moment you'd handle differently."
                                style={{ ...triggerInputStyle, padding: '0.52rem', marginTop: '0.5rem' }}
                            />
                            <p className="questionInfo" style={{ textAlign: 'left', marginTop: '0.35rem', fontSize: '0.72rem', opacity: 0.65, color: 'rgba(255, 255, 255, 0.65)', fontFamily: "'DM Sans', sans-serif" }}>{rrHeadline.length}/120</p>
                            <p className="questionInfo" style={{ textAlign: 'left', marginTop: '0.7rem', opacity: 0.74, color: 'rgba(255, 255, 255, 0.74)', fontFamily: "'DM Sans', sans-serif" }}>
                                Just the headline. You don&apos;t need to explain it.
                            </p>
                        </div>
                        <div style={triggerFlowFooterStyle}>
                            <button
                                type="button"
                                className="popupButton"
                                disabled={!rrHeadline.trim()}
                                style={{ ...triggerPrimaryButtonStyle, opacity: rrHeadline.trim() ? 1 : 0.45 }}
                                onClick={() => {
                                    setRrStep(2);
                                    setRrExtractBeatVisible(true);
                                    rrStartScreen('extract_data');
                                }}
                            >
                                Continue
                            </button>
                        </div>
                    </>
                ) : rrStep === 2 ? (
                    <>
                        <div style={triggerFlowScrollStyle}>
                            <div style={rrQuotedStyle}>&ldquo;{rrHeadline.trim() || '…'}&rdquo;</div>
                            {rrExtractBeatVisible ? (
                                <div style={{ minHeight: '8rem', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                    <p style={{ opacity: 0.88, fontFamily: "'Fraunces', serif", color: '#fff', fontStyle: 'italic', transition: 'opacity 0.4s ease' }}>
                                        That happened. And you&apos;re still here.
                                    </p>
                                </div>
                            ) : (
                                <>
                                    <h2 style={{ ...triggerHeadlineStyle, marginBottom: '0.45rem', fontSize: 'clamp(1.05rem, 3.9vw, 1.35rem)' }}>
                                        What did this actually teach you?
                                    </h2>
                                    <input
                                        value={rrLearningExtracted}
                                        maxLength={200}
                                        onChange={(e) => setRrLearningExtracted(e.target.value.slice(0, 200))}
                                        style={{ ...triggerInputStyle, padding: '0.52rem', marginTop: '0.5rem' }}
                                    />
                                    <p className="questionInfo" style={{ textAlign: 'left', marginTop: '0.35rem', fontSize: '0.72rem', opacity: 0.65, color: 'rgba(255, 255, 255, 0.65)', fontFamily: "'DM Sans', sans-serif" }}>{rrLearningExtracted.length}/200</p>
                                    <p className="questionInfo" style={{ textAlign: 'left', marginTop: '0.7rem', opacity: 0.74, color: 'rgba(255, 255, 255, 0.74)', fontFamily: "'DM Sans', sans-serif" }}>
                                        Not what you wish had happened — what you now know that you didn&apos;t before.
                                    </p>
                                </>
                            )}
                        </div>
                        <div style={triggerFlowFooterStyle}>
                            <button
                                type="button"
                                className="popupButton"
                                disabled={rrExtractBeatVisible || !rrLearningExtracted.trim()}
                                style={{ ...triggerPrimaryButtonStyle, opacity: !rrExtractBeatVisible && rrLearningExtracted.trim() ? 1 : 0.45 }}
                                onClick={() => {
                                    setRrStep(3);
                                    rrStartScreen('identity_close');
                                }}
                            >
                                Continue
                            </button>
                        </div>
                    </>
                ) : rrStep === 3 ? (
                    <>
                        <div style={triggerFlowScrollStyle}>
                            <div style={rrQuotedStyle}>&ldquo;{rrLearningExtracted.trim() || '…'}&rdquo;</div>
                            <h2 style={{ marginTop: '0.2rem', marginBottom: '0.45rem', textAlign: 'left', width: '100%', maxWidth: '100%', fontSize: '1.05rem', fontWeight: 600, lineHeight: 1.4 }}>
                            
                                What does the fact that you&apos;re here — looking at this honestly — say about you?
                            </h2>
                            <input
                                value={rrIdentityReflection}
                                maxLength={180}
                                onChange={(e) => setRrIdentityReflection(e.target.value.slice(0, 180))}
                                style={{ ...triggerInputStyle, padding: '0.52rem', marginTop: '0.5rem' }}
                            />
                            <p className="questionInfo" style={{ textAlign: 'left', marginTop: '0.35rem', fontSize: '0.72rem', opacity: 0.65, color: 'rgba(255, 255, 255, 0.65)', fontFamily: "'DM Sans', sans-serif" }}>{rrIdentityReflection.length}/180</p>
                        </div>
                        <div style={triggerFlowFooterStyle}>
                            <button
                                type="button"
                                className="popupButton"
                                disabled={!rrIdentityReflection.trim()}
                                style={{ ...triggerPrimaryButtonStyle, opacity: rrIdentityReflection.trim() ? 1 : 0.45 }}
                                onClick={() => {
                                    setRrStep(4);
                                    setRrValuesBeatVisible(true);
                                    rrStartScreen('values_check');
                                }}
                            >
                                Continue
                            </button>
                        </div>
                    </>
                ) : rrStep === 4 ? (
                    <>
                        <div style={triggerFlowScrollStyle}>
                            {rrValuesBeatVisible ? (
                                <div style={{ minHeight: '8rem', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                    <p style={{ opacity: 0.88, fontFamily: "'Fraunces', serif", color: '#fff', fontStyle: 'italic' }}>One more look at this.</p>
                                </div>
                            ) : (
                                <>
                                    <h2 style={{ ...triggerHeadlineStyle, marginBottom: '0.65rem', fontSize: 'clamp(1.05rem, 3.9vw, 1.35rem)' }}>
                                        Did how you handled it align with who you want to be?
                                    </h2>
                                    <div style={{ display: 'flex', flexDirection: 'column', gap: '0.45rem', width: '100%', maxWidth: '100%' }}>
                                        {[
                                            { key: 'yes', label: 'Yes — I acted in line with my values', response: 'That alignment under pressure is harder than it looks. Note it.' },
                                            { key: 'partially', label: "Partially — some of it did, some didn't", response: 'Most moments are partial. The honesty to say so is its own form of alignment.' },
                                            { key: 'not_really', label: "Not really — I'd handle it differently now", response: "The gap between who you were and who you want to be — that's exactly what Thursday trains." },
                                        ].map((opt) => (
                                            <button
                                                key={opt.key}
                                                type="button"
                                                onClick={() => {
                                                    setRrValuesAlignment(opt.key);
                                                    setRrValuesAlignmentResponse(opt.response);
                                                }}
                                                style={{
                                                    textAlign: 'left',
                                                    padding: '0.75rem 0.65rem',
                                                    borderRadius: '14px',
                                                    border: rrValuesAlignment === opt.key ? '1px solid rgba(255, 255, 255, 0.45)' : '1px solid rgba(255, 255, 255, 0.16)',
                                                    background: 'linear-gradient(160deg, rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0.03))',
                                                    cursor: 'pointer',
                                                    boxSizing: 'border-box',
                                                    color: 'rgba(255, 255, 255, 0.9)',
                                                    fontFamily: "'DM Sans', sans-serif",
                                                }}
                                            >
                                                {opt.label}
                                            </button>
                                        ))}
                                    </div>
                                    {rrValuesAlignmentResponse ? (
                                        <p className="questionInfo" style={{ marginTop: '0.8rem', opacity: 0.66, fontSize: '0.82rem', lineHeight: 1.45 }}>
                                            {rrValuesAlignmentResponse}
                                        </p>
                                    ) : null}
                                </>
                            )}
                        </div>
                        <div style={triggerFlowFooterStyle}>
                            <button
                                type="button"
                                className="popupButton"
                                disabled={rrValuesBeatVisible || !rrValuesAlignment}
                                style={{ ...triggerPrimaryButtonStyle, opacity: !rrValuesBeatVisible && rrValuesAlignment ? 1 : 0.45 }}
                                onClick={() => {
                                    setRrStep(5);
                                    setRrSettleDone(false);
                                    rrStartScreen('settle');
                                }}
                            >
                                Continue
                            </button>
                        </div>
                    </>
                ) : rrStep === 5 ? (
                    <>
                        <div style={triggerFlowScrollStyle}>
                            <p className="questionInfo" style={{ textAlign: 'left', width: '100%', maxWidth: '100%', opacity: 0.7 }}>Before you go</p>
                            <h2 style={{ ...triggerHeadlineStyle, marginBottom: '0.5rem', fontSize: 'clamp(1.07rem, 4vw, 1.38rem)' }}>
                                Take one breath.
                            </h2>
                            <p className="questionInfo" style={{ textAlign: 'left', width: '100%', maxWidth: '100%', opacity: 0.78, color: 'rgba(255, 255, 255, 0.78)', fontFamily: "'DM Sans', sans-serif" }}>In through the nose, out through the mouth.</p>
                            <div style={{ width: '100%', display: 'flex', justifyContent: 'center', marginTop: '1.05rem' }}>
                                <div
                                    style={{
                                        width: 120,
                                        height: 120,
                                        borderRadius: '50%',
                                        border: '1px solid rgba(255, 255, 255, 0.35)',
                                        background: 'radial-gradient(circle at 30% 30%, rgba(255, 255, 255, 0.2), rgba(255, 255, 255, 0.04))',
                                        transform: `scale(${1 + (rrSettlePhase === 'Breathe in' ? rrSettleProgress / 300 : (100 - rrSettleProgress) / 300)})`,
                                        transition: 'transform 120ms linear',
                                    }}
                                />
                            </div>
                            <p className="questionInfo" style={{ textAlign: 'center', marginTop: '0.65rem', letterSpacing: '0.08em', fontSize: '0.62rem', opacity: 0.7 }}>
                                {rrSettlePhase}
                            </p>
                            <div style={{ width: '100%', height: 4, borderRadius: 4, background: 'rgba(255, 255, 255, 0.2)', overflow: 'hidden', marginTop: '0.35rem' }}>
                                <div style={{ width: `${rrSettleProgress}%`, height: '100%', background: 'rgba(255, 255, 255, 0.92)' }} />
                            </div>
                            {rrSettleCloseVisible ? (
                                <p style={{ marginTop: '1rem', fontStyle: 'italic', fontFamily: "'Fraunces', serif", color: '#fff', fontSize: '0.95rem', lineHeight: 1.45, opacity: 0.9 }}>
                                    You just turned a hard moment into training data. That&apos;s endurance.
                                </p>
                            ) : null}
                        </div>
                        <div style={triggerFlowFooterStyle}>
                            {rrSettleCtaVisible ? (
                                <button
                                    type="button"
                                    className="popupButton"
                                    style={triggerPrimaryButtonStyle}
                                    onClick={() => {
                                        submitResilienceSession({ abandoned: false });
                                        rrSessionLoggedRef.current = true;
                                        setRrStep(6);
                                    }}
                                >
                                    Log this rep
                                </button>
                            ) : (
                                <p className="questionInfo" style={{ margin: 0, opacity: 0.45, fontSize: '0.78rem' }}>&nbsp;</p>
                            )}
                        </div>
                    </>
                ) : (
                    <>
                        <div style={triggerFlowScrollStyle}>
                            <div style={{ width: '100%', display: 'flex', justifyContent: 'center', marginTop: '0.5rem' }}>
                                <div style={{ width: 34, height: 34, borderRadius: '50%', border: '1px solid rgba(255, 255, 255, 0.45)', color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1rem' }}>✓</div>
                            </div>
                            <h2 style={{ ...triggerHeadlineStyle, textAlign: 'center', marginTop: '0.7rem', marginBottom: '0.4rem', fontSize: '1.1rem' }}>Rep logged.</h2>
                            <p className="questionInfo" style={{ textAlign: 'center', opacity: 0.86, lineHeight: 1.5, color: 'rgba(255, 255, 255, 0.86)', fontFamily: "'DM Sans', sans-serif" }}>
                                {rrValuesAlignment === 'yes'
                                    ? "You showed up for something hard and stayed true to yourself. That's the work."
                                    : rrValuesAlignment === 'partially'
                                      ? 'Partial alignment honestly named is more valuable than perfect alignment performed.'
                                      : 'Seeing the gap clearly is the beginning of closing it. You did that today.'}
                            </p>
                        </div>
                        <div style={triggerFlowFooterStyle}>
                            <button type="button" className="popupButton" style={triggerPrimaryButtonStyle} onClick={handleCloseLearningPopup}>
                                Back to training floor
                            </button>
                        </div>
                    </>
                )}
            </div>
        </div>
    );

    const cccCardBase = {
        textAlign: 'left',
        padding: '0.85rem 0.75rem',
        borderRadius: '14px',
        border: '1px solid rgba(255, 255, 255, 0.16)',
        background: 'linear-gradient(160deg, rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0.03))',
        boxShadow: '0 10px 24px rgba(4, 8, 16, 0.16)',
        cursor: 'pointer',
        transition: 'transform 0.15s ease, box-shadow 0.15s ease',
        boxSizing: 'border-box',
        color: 'rgba(255, 255, 255, 0.9)',
    };

    const cccWorkoutAssets = (
        <div
            className="learningFeedback"
            style={{
                flex: 1,
                minHeight: 0,
                maxHeight: '100%',
                height: '100%',
                textAlign: 'left',
                padding: '0 0.75rem',
                alignItems: 'stretch',
                display: 'flex',
                flexDirection: 'column',
                overflow: 'hidden',
                width: '100%',
                maxWidth: '100%',
                boxSizing: 'border-box',
            }}
        >
            <div style={triggerFlowShellStyle}>
                {cccStep > 1 && cccStep < 6 ? (
                    <div className="popupButtonGroup" style={{ position: 'static', width: '100%', flexShrink: 0, marginTop: 0, marginBottom: '0.25rem' }}>
                        <button type="button" className="landing-onboarding-top-back" onClick={cccStepBack} aria-label="Previous step">
                            <svg width="22" height="22" viewBox="0 0 14 14" fill="none" aria-hidden="true">
                                <path d="M11 7H3M7 3L3 7l4 4" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </button>
                    </div>
                ) : null}
                {cccStep === 1 ? (
                    <>
                        <div style={triggerFlowScrollStyle}>
                            <p className="questionInfo" style={{ ...triggerMetaStyle, marginBottom: '0.35rem' }}>
                                Connection &amp; Communication
                            </p>
                            <h2 style={{ ...triggerHeadlineStyle, marginTop: 0, marginBottom: '0.35rem', fontSize: 'clamp(1.08rem, 4vw, 1.4rem)', lineHeight: 1.35 }}>
                                Choose your category
                            </h2>
                            <p style={{ fontSize: '0.86rem', lineHeight: 1.45, opacity: 0.82, marginBottom: '0.85rem', color: 'rgba(255, 255, 255, 0.82)', fontFamily: "'DM Sans', sans-serif" }}>
                                Pick the story door that feels closest today. These are prompts — not labels.
                            </p>
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '0.55rem' }}>
                                {CCC_STORY_OPTIONS.map((opt) => {
                                    const selected = cccStoryId === opt.id;
                                    return (
                                        <button
                                            key={opt.id}
                                            type="button"
                                            onClick={() => setCccStoryId(opt.id)}
                                            style={{
                                                ...cccCardBase,
                                                border: selected ? '1px solid rgba(255, 255, 255, 0.5)' : cccCardBase.border,
                                                boxShadow: selected ? '0 12px 24px rgba(4, 8, 16, 0.22)' : cccCardBase.boxShadow,
                                                transform: selected ? 'scale(1.01)' : undefined,
                                            }}
                                        >
                                            <div style={{ fontSize: '1.02rem', fontWeight: 500, color: '#fff', fontFamily: "'Fraunces', serif" }}>{opt.title}</div>
                                            <div style={{ fontSize: '0.78rem', opacity: 0.78, marginTop: '0.35rem', lineHeight: 1.4, color: 'rgba(255, 255, 255, 0.78)', fontFamily: "'DM Sans', sans-serif" }}>{opt.muscle}</div>
                                        </button>
                                    );
                                })}
                            </div>
                        </div>
                        <div style={triggerFlowFooterStyle}>
                            <button type="button" className="popupButton" disabled={!cccStoryId} style={{ ...triggerPrimaryButtonStyle, opacity: cccStoryId ? 1 : 0.45 }} onClick={() => setCccStep(2)}>
                                Continue
                            </button>
                        </div>
                    </>
                ) : cccStep === 2 ? (
                    <>
                        <div style={triggerFlowScrollStyle}>
                            <p className="questionInfo" style={triggerMetaStyle}>Your story</p>
                            <div style={{ fontSize: '0.96rem', fontWeight: 500, fontFamily: "'Fraunces', serif", marginBottom: '0.65rem', color: '#fff' }}>{cccStoryTitle(cccStoryId)}</div>
                            <h2 style={{ ...triggerHeadlineStyle, marginTop: 0, marginBottom: '0.45rem', fontSize: 'clamp(1.05rem, 3.9vw, 1.35rem)', lineHeight: 1.35 }}>Find the moment</h2>
                            <p style={{ fontSize: '0.84rem', lineHeight: 1.5, opacity: 0.82, marginBottom: '0.55rem', color: 'rgba(255, 255, 255, 0.82)', fontFamily: "'DM Sans', sans-serif" }}>
                                Don&apos;t think of the general experience — find <strong>one specific moment</strong>. Where were you? What was happening right before?
                            </p>
                            <div
                                style={{
                                    borderRadius: '14px',
                                    border: '1px solid rgba(255, 255, 255, 0.14)',
                                    background: 'linear-gradient(160deg, rgba(255, 255, 255, 0.08), rgba(255, 255, 255, 0.03))',
                                    padding: '0.55rem 0.65rem',
                                    marginBottom: '0.65rem',
                                    fontSize: '0.76rem',
                                    lineHeight: 1.45,
                                    opacity: 0.88,
                                    color: 'rgba(255, 255, 255, 0.86)',
                                    fontFamily: "'DM Sans', sans-serif",
                                }}
                            >
                                <div style={{ marginBottom: '0.35rem' }}>
                                    <span style={{ fontWeight: 600 }}>Vague:</span> &ldquo;We always fight about work.&rdquo;
                                </div>
                                <div>
                                    <span style={{ fontWeight: 600 }}>Specific:</span> &ldquo;I was sitting in my car outside their office, engine off, rehearsing what I&apos;d say when they walked out.&rdquo;
                                </div>
                            </div>
                            <textarea
                                value={cccMoment}
                                onChange={(e) => setCccMoment(e.target.value.slice(0, 900))}
                                rows={5}
                                placeholder={'I was sitting in my car outside…\nIt was the moment right before…'}
                                style={{ ...triggerInputStyle, padding: '0.55rem', borderRadius: '12px', resize: 'vertical', minHeight: '6.5rem' }}
                            />
                            <p style={{ fontSize: '0.78rem', opacity: 0.76, marginTop: '0.5rem', fontStyle: 'italic', color: 'rgba(255, 255, 255, 0.78)', fontFamily: "'Fraunces', serif" }}>
                                Specificity is what makes stories connect. Details are the point.
                            </p>
                        </div>
                        <div style={triggerFlowFooterStyle}>
                            <button type="button" className="popupButton" disabled={!cccMoment.trim()} style={{ ...triggerPrimaryButtonStyle, opacity: cccMoment.trim() ? 1 : 0.45 }} onClick={() => { setCccBeatPhase(1); setCccStep(3); }}>
                                Continue
                            </button>
                        </div>
                    </>
                ) : cccStep === 3 ? (
                    <>
                        <div style={triggerFlowScrollStyle}>
                            <p className="questionInfo" style={triggerMetaStyle}>The three beats</p>
                            <div style={{ display: 'flex', justifyContent: 'center', gap: '0.45rem', marginBottom: '0.5rem' }}>
                                {[1, 2, 3].map((n) => (
                                    <div
                                        key={n}
                                        style={{
                                            width: 11,
                                            height: 11,
                                            borderRadius: '50%',
                                            background: cccBeatPhase >= n ? 'rgba(255, 255, 255, 0.92)' : 'rgba(255, 255, 255, 0.28)',
                                            opacity: cccBeatPhase === n ? 1 : 0.55,
                                            transform: cccBeatPhase === n ? 'scale(1.15)' : 'scale(1)',
                                            transition: 'background 0.2s ease, transform 0.2s ease',
                                        }}
                                    />
                                ))}
                            </div>
                            <p style={{ fontSize: '0.72rem', textAlign: 'center', opacity: 0.66, letterSpacing: '0.12em', marginBottom: '0.35rem', color: 'rgba(255, 255, 255, 0.72)', fontFamily: "'DM Sans', sans-serif" }}>
                                BEAT {cccBeatPhase} OF 3
                            </p>
                            {cccBeatPhase === 1 ? (
                                <>
                                    <h2 style={{ ...triggerHeadlineStyle, marginTop: 0, marginBottom: '0.45rem', fontSize: 'clamp(1.05rem, 3.9vw, 1.35rem)' }}>The setup</h2>
                                    <p style={{ fontSize: '0.84rem', lineHeight: 1.5, opacity: 0.82, marginBottom: '0.5rem' }}>What was the situation and what were you feeling going in?</p>
                                    <textarea
                                        value={cccBeatSetup}
                                        onChange={(e) => setCccBeatSetup(e.target.value.slice(0, 900))}
                                        rows={5}
                                        placeholder="Two or three sentences…"
                                        style={{ ...triggerInputStyle, padding: '0.55rem', borderRadius: '12px', resize: 'vertical' }}
                                    />
                                </>
                            ) : null}
                            {cccBeatPhase === 2 ? (
                                <>
                                    <h2 style={{ ...triggerHeadlineStyle, marginTop: 0, marginBottom: '0.45rem', fontSize: 'clamp(1.05rem, 3.9vw, 1.35rem)' }}>The turn</h2>
                                    <p style={{ fontSize: '0.84rem', lineHeight: 1.5, opacity: 0.82, marginBottom: '0.5rem' }}>What happened — and what shifted inside you?</p>
                                    <textarea
                                        value={cccBeatTurn}
                                        onChange={(e) => setCccBeatTurn(e.target.value.slice(0, 900))}
                                        rows={5}
                                        placeholder="Two or three sentences…"
                                        style={{ ...triggerInputStyle, padding: '0.55rem', borderRadius: '12px', resize: 'vertical' }}
                                    />
                                </>
                            ) : null}
                            {cccBeatPhase === 3 ? (
                                <>
                                    <h2 style={{ ...triggerHeadlineStyle, marginTop: 0, marginBottom: '0.45rem', fontSize: 'clamp(1.05rem, 3.9vw, 1.35rem)' }}>The meaning</h2>
                                    <p style={{ fontSize: '0.84rem', lineHeight: 1.5, opacity: 0.82, marginBottom: '0.5rem' }}>What did this moment tell you — about yourself or about life?</p>
                                    <textarea
                                        value={cccBeatMeaning}
                                        onChange={(e) => setCccBeatMeaning(e.target.value.slice(0, 900))}
                                        rows={5}
                                        placeholder="Two or three sentences…"
                                        style={{ ...triggerInputStyle, padding: '0.55rem', borderRadius: '12px', resize: 'vertical' }}
                                    />
                                </>
                            ) : null}
                        </div>
                        <div style={triggerFlowFooterStyle}>
                            <button
                                type="button"
                                className="popupButton"
                                disabled={
                                    (cccBeatPhase === 1 && !cccBeatSetup.trim()) ||
                                    (cccBeatPhase === 2 && !cccBeatTurn.trim()) ||
                                    (cccBeatPhase === 3 && !cccBeatMeaning.trim())
                                }
                                style={{
                                    ...triggerPrimaryButtonStyle,
                                    opacity:
                                        (cccBeatPhase === 1 && cccBeatSetup.trim()) ||
                                        (cccBeatPhase === 2 && cccBeatTurn.trim()) ||
                                        (cccBeatPhase === 3 && cccBeatMeaning.trim())
                                            ? 1
                                            : 0.45,
                                }}
                                onClick={() => {
                                    if (cccBeatPhase < 3) {
                                        setCccBeatPhase((p) => p + 1);
                                        return;
                                    }
                                    setCccReflectPhase('read');
                                    setCccStep(4);
                                }}
                            >
                                Continue
                            </button>
                        </div>
                    </>
                ) : cccStep === 4 ? (
                    <>
                        <div style={triggerFlowScrollStyle}>
                            {cccReflectPhase === 'read' ? (
                                <>
                                    <p className="questionInfo" style={triggerMetaStyle}>Your story</p>
                                    <h2 style={{ ...triggerHeadlineStyle, marginTop: 0, marginBottom: '0.65rem', fontSize: 'clamp(1.05rem, 3.9vw, 1.35rem)' }}>Read it once</h2>
                                    <div style={{ ...rrQuotedStyle, marginBottom: '0.65rem' }}>{cccMoment.trim()}</div>
                                    <p style={{ fontSize: '0.72rem', fontWeight: 600, letterSpacing: '0.06em', opacity: 0.55, marginBottom: '0.2rem' }}>SETUP</p>
                                    <div style={{ ...rrQuotedStyle, marginBottom: '0.65rem' }}>{cccBeatSetup.trim()}</div>
                                    <p style={{ fontSize: '0.72rem', fontWeight: 600, letterSpacing: '0.06em', opacity: 0.55, marginBottom: '0.2rem' }}>TURN</p>
                                    <div style={{ ...rrQuotedStyle, marginBottom: '0.65rem' }}>{cccBeatTurn.trim()}</div>
                                    <p style={{ fontSize: '0.72rem', fontWeight: 600, letterSpacing: '0.06em', opacity: 0.55, marginBottom: '0.2rem' }}>MEANING</p>
                                    <div style={{ ...rrQuotedStyle }}>{cccBeatMeaning.trim()}</div>
                                </>
                            ) : (
                                <>
                                    <h2 style={{ ...triggerHeadlineStyle, marginTop: 0, marginBottom: '0.55rem', fontSize: 'clamp(1.05rem, 3.9vw, 1.35rem)' }}>Two last questions</h2>
                                    <p style={{ fontSize: '0.8rem', opacity: 0.78, marginBottom: '0.65rem', lineHeight: 1.45 }}>Optional — but they&apos;re where surface storytelling turns into connection training.</p>
                                    <label style={{ fontSize: '0.82rem', fontWeight: 600, display: 'block', marginBottom: '0.25rem' }}>
                                        What did you leave out that might actually be the most important part?
                                    </label>
                                    <textarea
                                        value={cccLeftOut}
                                        onChange={(e) => setCccLeftOut(e.target.value.slice(0, 600))}
                                        rows={3}
                                        style={{ ...triggerInputStyle, padding: '0.5rem', borderRadius: '12px', resize: 'vertical', marginBottom: '0.75rem' }}
                                    />
                                    <label style={{ fontSize: '0.82rem', fontWeight: 600, display: 'block', marginBottom: '0.25rem' }}>
                                        Would you tell this story differently to someone you completely trusted?
                                    </label>
                                    <textarea
                                        value={cccTrusted}
                                        onChange={(e) => setCccTrusted(e.target.value.slice(0, 600))}
                                        rows={3}
                                        style={{ ...triggerInputStyle, padding: '0.5rem', borderRadius: '12px', resize: 'vertical' }}
                                    />
                                </>
                            )}
                        </div>
                        <div style={triggerFlowFooterStyle}>
                            {cccReflectPhase === 'read' ? (
                                <button type="button" className="popupButton" style={triggerPrimaryButtonStyle} onClick={() => setCccReflectPhase('questions')}>
                                    Continue
                                </button>
                            ) : (
                                <button type="button" className="popupButton" style={triggerPrimaryButtonStyle} onClick={() => setCccStep(5)}>
                                    Continue
                                </button>
                            )}
                        </div>
                    </>
                ) : cccStep === 5 ? (
                    <>
                        <div style={triggerFlowScrollStyle}>
                            <p className="questionInfo" style={triggerMetaStyle}>Before you log it</p>
                            <p style={{ fontSize: '1.02rem', lineHeight: 1.55, fontFamily: "'Fraunces', serif", fontStyle: 'italic', opacity: 0.95, color: '#fff' }}>
                                {CCC_CLOSE_LINES[cccStoryId] || 'Stories are how we practice being known.'}
                            </p>
                        </div>
                        <div style={triggerFlowFooterStyle}>
                            <button
                                type="button"
                                className="popupButton"
                                style={triggerPrimaryButtonStyle}
                                onClick={() => {
                                    submitConnectionCommSession({ abandoned: false, completed: true });
                                    cccSessionLoggedRef.current = true;
                                    setCccStep(6);
                                }}
                            >
                                Log this rep
                            </button>
                        </div>
                    </>
                ) : (
                    <>
                        <div style={triggerFlowScrollStyle}>
                            <div style={{ width: '100%', display: 'flex', justifyContent: 'center', marginTop: '0.35rem' }}>
                                <div style={{ width: 34, height: 34, borderRadius: '50%', border: '1px solid rgba(255, 255, 255, 0.45)', color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1rem' }}>✓</div>
                            </div>
                            <h2 style={{ ...triggerHeadlineStyle, textAlign: 'center', marginTop: '0.75rem', marginBottom: '0.45rem', fontSize: '1.12rem' }}>Workout complete</h2>
                            <p className="questionInfo" style={{ textAlign: 'center', opacity: 0.86, lineHeight: 1.55, maxWidth: '100%', color: 'rgba(255, 255, 255, 0.86)', fontFamily: "'DM Sans', sans-serif" }}>
                                Storytelling is how humans have always found each other. You just practiced it.
                            </p>
                        </div>
                        <div style={triggerFlowFooterStyle}>
                            <button type="button" className="popupButton" style={triggerPrimaryButtonStyle} onClick={handleCloseLearningPopup}>
                                Back to Training Floor
                            </button>
                        </div>
                    </>
                )}
            </div>
        </div>
    );

    const selectedExposureChallenge = exposureChallenges.find((c) => c.id === selectedExposureChallengeId) || null;
    const selectedExposureSessions = selectedExposureChallenge
        ? exposureSessions
              .filter((s) => s.challengeId === selectedExposureChallenge.id)
              .sort((a, b) => b.timestamp - a.timestamp)
        : [];
    const exposureLatestSessionByChallenge = exposureSessions.reduce((acc, s) => {
        if (!acc[s.challengeId] || Number(acc[s.challengeId].timestamp || 0) < Number(s.timestamp || 0)) {
            acc[s.challengeId] = s;
        }
        return acc;
    }, {});
    const exposureElapsedSeconds = exposureTimerStartedAtRef.current
        ? Math.max(0, Math.floor(((exposureNowTick || Date.now()) - exposureTimerStartedAtRef.current) / 1000))
        : 0;
    const exposureCanLogRep = exposureElapsedSeconds >= 30;
    const exposureBeliefPromptIsNo = exposureRepOutcome === 'no';

    const exposureWorkoutAssets = (
        <div className="learningFeedback" style={{ flex: 1, minHeight: 0, maxHeight: '100%', height: '100%', textAlign: 'left', padding: '0 0.75rem', alignItems: 'stretch', display: 'flex', flexDirection: 'column', overflow: 'hidden', width: '100%', maxWidth: '100%', boxSizing: 'border-box' }}>
            <div style={triggerFlowShellStyle}>
                {exposureLoading ? (
                    <p className="relapseQuestion" style={{ textAlign: 'center', marginTop: '3rem' }}>Loading challenges…</p>
                ) : exposureView === 'board' ? (
                    <>
                        <div style={triggerFlowScrollStyle}>
                            <p className="questionInfo" style={triggerMetaStyle}>challenge board</p>
                            <h2 style={{ ...triggerHeadlineStyle, marginTop: '0.2rem', marginBottom: '0.8rem', textAlign: 'left' }}>Exposure Training</h2>
                            {!exposureChallenges.length ? (
                                <div style={{ minHeight: '56%', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', textAlign: 'center', padding: '0.5rem' }}>
                                    <p className="questionInfo" style={{ opacity: 0.85, maxWidth: 320 }}>
                                        You haven&apos;t built any challenges yet. The things you avoid are exactly where the training is.
                                    </p>
                                </div>
                            ) : (
                                <div style={{ display: 'grid', gridTemplateColumns: 'minmax(0, 1fr)', gap: '0.55rem' }}>
                                    {exposureChallenges.map((ch) => {
                                        const latest = exposureLatestSessionByChallenge[ch.id];
                                        return (
                                            <button key={ch.id} type="button" onClick={() => { setSelectedExposureChallengeId(ch.id); setExposureView('detail'); }} style={{ border: '1px solid rgba(255, 255, 255, 0.14)', borderRadius: '14px', padding: '0.65rem', background: 'linear-gradient(160deg, rgba(255, 255, 255, 0.09), rgba(255, 255, 255, 0.03))', textAlign: 'left', color: 'rgba(255, 255, 255, 0.9)' }}>
                                                <div style={{ fontSize: '1rem', fontFamily: "'Fraunces', serif", color: '#fff' }}>{ch.name}</div>
                                                <div style={{ fontSize: '0.78rem', opacity: 0.75, marginTop: '0.2rem', fontFamily: "'DM Sans', sans-serif" }}>{ch.fearStatement}</div>
                                                <div style={{ marginTop: '0.45rem', display: 'flex', gap: '0.35rem', flexWrap: 'wrap', fontSize: '0.72rem', opacity: 0.8, fontFamily: "'DM Sans', sans-serif" }}>
                                                    <span>{Number(ch.repCount || 0)} reps</span>
                                                    <span>·</span>
                                                    <span>{ch.lastTrainedAt ? convertTimestampToDateString(ch.lastTrainedAt) : 'Not trained yet'}</span>
                                                </div>
                                                <div style={{ marginTop: '0.35rem', fontFamily: 'monospace', fontSize: '0.76rem', opacity: 0.8, color: 'rgba(255, 255, 255, 0.82)' }}>
                                                    {latest ? `${latest.activationBefore} → ${latest.activationDuring} → ${latest.activationAfter}` : '—'}
                                                </div>
                                            </button>
                                        );
                                    })}
                                </div>
                            )}
                        </div>
                        <div style={triggerFlowFooterStyle}>
                            <button type="button" onClick={openExposureCreateFlow} style={{ ...triggerPrimaryButtonStyle, textAlign: 'left', border: '1px dashed rgba(255, 255, 255, 0.35)' }}>
                                <span style={{ marginRight: '0.35rem', fontWeight: 600 }}>+</span> New Challenge
                            </button>
                        </div>
                    </>
                ) : exposureView === 'create' ? (
                    <>
                        <div style={triggerFlowScrollStyle}>
                            {exposureShowDisclaimer ? (
                                <>
                                    <p className="questionInfo" style={triggerMetaStyle}>before you begin</p>
                                    <h2 style={{ ...triggerHeadlineStyle, marginTop: '0.2rem', textAlign: 'left' }}>Important</h2>
                                    <p className="questionInfo" style={{ textAlign: 'left', opacity: 0.82, lineHeight: 1.6 }}>
                                        This workout is for everyday fears that are holding you back - the conversations you avoid, the risks you don&apos;t take, the rooms you don&apos;t walk into. It&apos;s not designed for trauma or clinical anxiety. If what you&apos;re working with feels bigger than that, a therapist is the right support.
                                    </p>
                                </>
                            ) : exposureCreateStep === 1 ? (
                                <>
                                    <p className="questionInfo" style={triggerMetaStyle}>new challenge</p>
                                    <h2 style={{ ...triggerHeadlineStyle, marginTop: '0.2rem', textAlign: 'left' }}>What&apos;s the challenge?</h2>
                                    <input value={exposureNameInput} maxLength={80} onChange={(e) => setExposureNameInput(e.target.value)} placeholder="Talking to people I&apos;m attracted to" style={{ ...triggerInputStyle, marginTop: '0.5rem', padding: '0.55rem' }} />
                                </>
                            ) : exposureCreateStep === 2 ? (
                                <>
                                    <p className="questionInfo" style={triggerMetaStyle}>new challenge</p>
                                    <h2 style={{ ...triggerHeadlineStyle, marginTop: '0.2rem', textAlign: 'left' }}>What specifically are you afraid will happen?</h2>
                                    <p className="questionInfo" style={{ textAlign: 'left', opacity: 0.75 }}>Be specific. &quot;I&apos;ll embarrass myself&quot; is less useful than &quot;I&apos;ll say something wrong and they&apos;ll think less of me.&quot;</p>
                                    <input value={exposureFearInput} maxLength={140} onChange={(e) => setExposureFearInput(e.target.value)} placeholder="I&apos;ll say something wrong and they&apos;ll think less of me." style={{ ...triggerInputStyle, marginTop: '0.5rem', padding: '0.55rem' }} />
                                </>
                            ) : (
                                <>
                                    <p className="questionInfo" style={triggerMetaStyle}>new challenge</p>
                                    <h2 style={{ ...triggerHeadlineStyle, marginTop: '0.2rem', textAlign: 'left' }}>Why does conquering this matter to you?</h2>
                                    <p className="questionInfo" style={{ textAlign: 'left', opacity: 0.75 }}>This becomes your anchor. You&apos;ll see it every time you run this rep.</p>
                                    <input value={exposureWhyInput} maxLength={140} onChange={(e) => setExposureWhyInput(e.target.value)} placeholder="I want to stop shrinking and live with more courage." style={{ ...triggerInputStyle, marginTop: '0.5rem', padding: '0.55rem' }} />
                                </>
                            )}
                        </div>
                        <div style={triggerFlowFooterStyle}>
                            {exposureShowDisclaimer ? (
                                <button type="button" className="popupButton" style={triggerPrimaryButtonStyle} onClick={() => { localStorage.setItem(EXPOSURE_DISCLAIMER_SEEN_KEY, '1'); setExposureShowDisclaimer(false); }}>
                                    I understand - let&apos;s build.
                                </button>
                            ) : (
                                <button
                                    type="button"
                                    className="popupButton"
                                    style={triggerPrimaryButtonStyle}
                                    onClick={() => {
                                        if (exposureCreateStep < 3) setExposureCreateStep((s) => s + 1);
                                        else saveExposureChallenge();
                                    }}
                                    disabled={
                                        (exposureCreateStep === 1 && !exposureNameInput.trim()) ||
                                        (exposureCreateStep === 2 && !exposureFearInput.trim()) ||
                                        (exposureCreateStep === 3 && !exposureWhyInput.trim())
                                    }
                                >
                                    {exposureCreateStep < 3 ? 'Continue' : 'Save Challenge'}
                                </button>
                            )}
                        </div>
                    </>
                ) : exposureView === 'detail' && selectedExposureChallenge ? (
                    <>
                        <div style={triggerFlowScrollStyle}>
                            <p className="questionInfo" style={triggerMetaStyle}>challenge detail</p>
                            <h2 style={{ ...triggerHeadlineStyle, marginTop: '0.2rem', textAlign: 'left' }}>{selectedExposureChallenge.name}</h2>
                            <p style={{ fontSize: '0.85rem', opacity: 0.78, fontStyle: 'italic', marginTop: '0.35rem', color: 'rgba(255, 255, 255, 0.82)', fontFamily: "'Fraunces', serif" }}>&quot;{selectedExposureChallenge.fearStatement}&quot;</p>
                            <div style={{ marginTop: '0.6rem', border: '1px solid rgba(255, 255, 255, 0.16)', background: 'linear-gradient(160deg, rgba(255,255,255,0.08), rgba(255,255,255,0.03))', borderRadius: '14px', padding: '0.6rem' }}>
                                <p className="questionInfo" style={{ margin: 0, textAlign: 'left', opacity: 0.72 }}>Anchor</p>
                                <div style={{ marginTop: '0.2rem', color: 'rgba(255, 255, 255, 0.88)', opacity: 0.9, fontFamily: "'Fraunces', serif" }}>{selectedExposureChallenge.why}</div>
                            </div>
                            <div style={{ marginTop: '0.8rem', display: 'flex', flexDirection: 'column', gap: '0.45rem' }}>
                                {selectedExposureSessions.length ? selectedExposureSessions.map((s) => (
                                    <div key={s.id} style={{ border: '1px solid rgba(255, 255, 255, 0.14)', borderRadius: '12px', padding: '0.5rem', background: 'rgba(255,255,255,0.03)' }}>
                                        <div style={{ display: 'flex', justifyContent: 'space-between', gap: '0.35rem', fontSize: '0.72rem', opacity: 0.78 }}>
                                            <span>{convertTimestampToDateString(s.timestamp)}</span>
                                            <span style={{ fontFamily: 'monospace' }}>{s.activationBefore} → {s.activationDuring} → {s.activationAfter}</span>
                                        </div>
                                        <div style={{ marginTop: '0.3rem', fontSize: '0.82rem', opacity: 0.9 }}>{s.whatTheyDid}</div>
                                        <div style={{ marginTop: '0.24rem', fontSize: '0.76rem', opacity: 0.75 }}>{(s.logText || '').slice(0, 120)}</div>
                                    </div>
                                )) : <p className="questionInfo" style={{ opacity: 0.7 }}>No reps logged yet.</p>}
                            </div>
                        </div>
                        <div style={triggerFlowFooterStyle}>
                            <button type="button" className="popupButton" style={triggerPrimaryButtonStyle} onClick={() => openExposureRepForChallenge(selectedExposureChallenge.id)}>Start Rep</button>
                        </div>
                    </>
                ) : (
                    <>
                        <div style={{ ...triggerFlowScrollStyle, textAlign: 'center' }}>
                            {selectedExposureChallenge && (exposureRepStep === 1 || exposureRepStep === 1.5 || exposureRepStep === 2) ? (
                                <p style={{ textAlign: 'left', opacity: 0.75, marginBottom: '0.3rem', color: 'rgba(255,255,255,0.8)', fontFamily: "'DM Sans', sans-serif" }}>{selectedExposureChallenge.name}</p>
                            ) : null}
                            {exposureRepStep === 1 ? (
                                <>
                                    <h2 style={{ ...triggerHeadlineStyle, textAlign: 'left', marginTop: '0.2rem' }}>What exactly are you going to do today?</h2>
                                    <input value={exposureRepWhat} onChange={(e) => setExposureRepWhat(e.target.value)} maxLength={120} placeholder="Walk up and introduce myself" style={{ ...triggerInputStyle, marginTop: '0.6rem', padding: '0.55rem' }} />
                                    <div style={{ marginTop: '0.65rem', color: 'rgba(255,255,255,0.82)', opacity: 0.84, textAlign: 'left', fontFamily: "'Fraunces', serif" }}>{selectedExposureChallenge?.why}</div>
                                </>
                            ) : exposureRepStep === 1.5 ? (
                                <>
                                    <h2 style={{ ...triggerHeadlineStyle, textAlign: 'left', marginTop: '0.2rem' }}>Before your first rep</h2>
                                    <p className="questionInfo" style={{ textAlign: 'left', opacity: 0.82, lineHeight: 1.56 }}>
                                        Here&apos;s what&apos;s about to happen. Your activation will go up. That&apos;s correct - it means you&apos;re in the right territory. The goal isn&apos;t to feel calm. It&apos;s to stay in the experience long enough for your nervous system to learn that it can tolerate this. That learning is the rep.
                                    </p>
                                </>
                            ) : exposureRepStep === 2 ? (
                                <>
                                    <div style={{ marginTop: '1.3rem', color: '#9b6b2f', opacity: 0.8, fontFamily: 'Fraunces, serif', fontSize: '1.05rem' }}>{selectedExposureChallenge?.why}</div>
                                    <div style={{ marginTop: '0.7rem', opacity: 0.66, fontSize: '0.84rem', color: 'rgba(255,255,255,0.72)', fontFamily: "'DM Sans', sans-serif" }}>{exposureElapsedSeconds}s</div>
                                    <button type="button" className="popupButton" onClick={() => setExposureRepStep(3)} disabled={!exposureCanLogRep} style={{ ...triggerPrimaryButtonStyle, marginTop: '0.8rem', opacity: exposureCanLogRep ? 1 : 0.45, transition: 'opacity 220ms ease' }}>
                                        Log the rep
                                    </button>
                                    <p className="questionInfo" style={{ marginTop: '0.75rem', opacity: 0.68 }}>Discomfort means it&apos;s working. Stay with it.</p>
                                    <p className="questionInfo" style={{ marginTop: '0.2rem', opacity: 0.68 }}>Stay until the activation starts to drop - that&apos;s when the learning happens.</p>
                                </>
                            ) : exposureRepStep === 3 ? (
                                <div style={{ textAlign: 'left' }}>
                                    <h2 style={{ ...triggerHeadlineStyle, marginTop: '0.2rem' }}>Did you do it?</h2>
                                    <div style={{ marginTop: '0.55rem', display: 'grid', gridTemplateColumns: 'minmax(0, 1fr)', gap: '0.42rem' }}>
                                        {[
                                            { id: 'yes', label: 'Yes - I did it' },
                                            { id: 'partially', label: 'Partially - I went partway' },
                                            { id: 'no', label: "No - I didn't go through with it" },
                                        ].map((opt) => (
                                            <button key={opt.id} type="button" onClick={() => { setExposureRepOutcome(opt.id); setExposureOutcomeTouched(true); }} style={{ border: '1px solid rgba(255,255,255,0.16)', borderRadius: '12px', padding: '0.62rem', textAlign: 'left', background: 'linear-gradient(160deg, rgba(255,255,255,0.08), rgba(255,255,255,0.03))', color: 'rgba(255,255,255,0.9)', fontFamily: "'DM Sans', sans-serif" }}>
                                                {opt.label}
                                            </button>
                                        ))}
                                    </div>
                                    {exposureOutcomeTouched ? (
                                        <p className="questionInfo" style={{ marginTop: '0.5rem', opacity: 0.72 }}>
                                            {exposureRepOutcome === 'yes'
                                                ? 'You did the thing. The activation you felt was real and you moved through it anyway.'
                                                : exposureRepOutcome === 'partially'
                                                  ? "Partial exposure is still exposure. The nervous system doesn't grade on completion."
                                                  : 'Showing up and choosing not to go through with it is still data. What stopped you is worth knowing.'}
                                        </p>
                                    ) : null}
                                    {exposureRepOutcome ? (
                                        <>
                                            <div style={{ marginTop: '0.65rem' }}>
                                                <div style={{ fontSize: '0.78rem', opacity: 0.75 }}>Before - how activated were you going in?</div>
                                                <input type="range" min={1} max={10} value={exposureActivationBefore} onChange={(e) => { setExposureActivationBefore(Number(e.target.value)); setExposureActivationTouched((prev) => ({ ...prev, before: true })); }} style={{ width: '100%' }} />
                                                <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '0.7rem', opacity: 0.65 }}><span>settled</span><span>activated</span></div>
                                            </div>
                                            <div style={{ marginTop: '0.5rem' }}>
                                                <div style={{ fontSize: '0.78rem', opacity: 0.75 }}>During - peak activation in the moment</div>
                                                <input type="range" min={1} max={10} value={exposureActivationDuring} onChange={(e) => { setExposureActivationDuring(Number(e.target.value)); setExposureActivationTouched((prev) => ({ ...prev, during: true })); }} style={{ width: '100%' }} />
                                                <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '0.7rem', opacity: 0.65 }}><span>settled</span><span>activated</span></div>
                                            </div>
                                            <div style={{ marginTop: '0.5rem' }}>
                                                <div style={{ fontSize: '0.78rem', opacity: 0.75 }}>After - how activated are you now?</div>
                                                <input type="range" min={1} max={10} value={exposureActivationAfter} onChange={(e) => { setExposureActivationAfter(Number(e.target.value)); setExposureActivationTouched((prev) => ({ ...prev, after: true })); }} style={{ width: '100%' }} />
                                                <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '0.7rem', opacity: 0.65 }}><span>settled</span><span>activated</span></div>
                                            </div>
                                            {exposureActivationTouched.before && exposureActivationTouched.during && exposureActivationTouched.after ? (
                                                <div style={{ marginTop: '0.65rem' }}>
                                                    <div style={{ fontSize: '0.8rem', opacity: 0.75 }}>What happened - what did you notice?</div>
                                                    <input value={exposureLogText} maxLength={300} onChange={(e) => setExposureLogText(e.target.value)} placeholder="Not an evaluation. Just what you observed." style={{ ...triggerInputStyle, marginTop: '0.35rem', padding: '0.5rem' }} />
                                                </div>
                                            ) : null}
                                        </>
                                    ) : null}
                                </div>
                            ) : exposureRepStep === 4 ? (
                                <div style={{ textAlign: 'left' }}>
                                    {!exposureBeliefPromptIsNo ? (
                                        <>
                                            <div style={{ marginTop: '0.3rem', color: 'rgba(255,255,255,0.88)', fontFamily: "'DM Sans', sans-serif" }}>I used to think I couldn&apos;t <input value={exposureBeliefFrom} maxLength={100} onChange={(e) => setExposureBeliefFrom(e.target.value)} style={{ width: '58%', border: 'none', borderBottom: '1px solid rgba(255,255,255,0.45)', background: 'transparent', color: '#fff' }} />.</div>
                                            <div style={{ marginTop: '0.8rem', color: 'rgba(255,255,255,0.88)', fontFamily: "'DM Sans', sans-serif" }}>Now I know <input value={exposureBeliefTo} maxLength={100} onChange={(e) => setExposureBeliefTo(e.target.value)} style={{ width: '70%', border: 'none', borderBottom: '1px solid rgba(255,255,255,0.45)', background: 'transparent', color: '#fff' }} />.</div>
                                            <p className="questionInfo" style={{ marginTop: '0.8rem', opacity: 0.7 }}>{exposureRepOutcome === 'yes' ? "The gap between who you were before this rep and who you are now - that's what endurance is made of." : "Every partial rep is a full data point. You'll know more next time than you did today."}</p>
                                        </>
                                    ) : (
                                        <>
                                            <div style={{ marginTop: '0.3rem', color: 'rgba(255,255,255,0.88)', fontFamily: "'DM Sans', sans-serif" }}>What stopped me was <input value={exposureBeliefFrom} maxLength={100} onChange={(e) => setExposureBeliefFrom(e.target.value)} style={{ width: '62%', border: 'none', borderBottom: '1px solid rgba(255,255,255,0.45)', background: 'transparent', color: '#fff' }} />.</div>
                                            <div style={{ marginTop: '0.8rem', color: 'rgba(255,255,255,0.88)', fontFamily: "'DM Sans', sans-serif" }}>What I want to remember for next time is <input value={exposureBeliefTo} maxLength={100} onChange={(e) => setExposureBeliefTo(e.target.value)} style={{ width: '44%', border: 'none', borderBottom: '1px solid rgba(255,255,255,0.45)', background: 'transparent', color: '#fff' }} />.</div>
                                            <p className="questionInfo" style={{ marginTop: '0.8rem', opacity: 0.7 }}>Knowing what stopped you is the beginning of getting past it. That&apos;s not nothing - that&apos;s the work.</p>
                                        </>
                                    )}
                                </div>
                            ) : (
                                <div style={{ textAlign: 'center' }}>
                                    <h2 style={{ ...triggerHeadlineStyle, marginTop: '0.65rem', marginBottom: '0.35rem', textAlign: 'center' }}>{exposureRepCompleteSnapshot?.repCount || 0} reps</h2>
                                    <p className="questionInfo" style={{ opacity: 0.8 }}>
                                        {exposureRepCompleteSnapshot?.outcome === 'yes'
                                            ? "You trained the thing you've been avoiding. That's the whole rep."
                                            : exposureRepCompleteSnapshot?.outcome === 'partially'
                                              ? 'You went further than not going at all. The nervous system noticed.'
                                              : "You showed up. Next time you'll know more about what you're working with."}
                                    </p>
                                </div>
                            )}
                        </div>
                        <div style={triggerFlowFooterStyle}>
                            {exposureRepStep === 1 ? (
                                <button type="button" className="popupButton" style={triggerPrimaryButtonStyle} disabled={!exposureRepWhat.trim()} onClick={() => { if (!selectedExposureChallenge?.firstRepCompleted) setExposureRepStep(1.5); else { setExposureRepStep(2); exposureTimerStartedAtRef.current = Date.now(); setExposureNowTick(Date.now()); } }}>
                                    I&apos;m ready. Start the timer.
                                </button>
                            ) : exposureRepStep === 1.5 ? (
                                <button type="button" className="popupButton" style={triggerPrimaryButtonStyle} onClick={() => { setExposureRepStep(2); exposureTimerStartedAtRef.current = Date.now(); setExposureNowTick(Date.now()); }}>
                                    I understand. Start the timer.
                                </button>
                            ) : exposureRepStep === 3 ? (
                                <button type="button" className="popupButton" style={triggerPrimaryButtonStyle} disabled={!(exposureRepOutcome && exposureActivationTouched.before && exposureActivationTouched.during && exposureActivationTouched.after && exposureLogText.trim())} onClick={() => setExposureRepStep(4)}>
                                    Continue
                                </button>
                            ) : exposureRepStep === 4 ? (
                                <button type="button" className="popupButton" style={triggerPrimaryButtonStyle} disabled={!(exposureBeliefFrom.trim() && exposureBeliefTo.trim())} onClick={submitExposureRep}>
                                    Log this rep
                                </button>
                            ) : (
                                <div style={{ width: '100%', display: 'flex', gap: '0.45rem' }}>
                                    <button type="button" className="popupButton" style={{ ...triggerPrimaryButtonStyle, flex: 1 }} onClick={() => { setExposureView('board'); setExposureRepStep(1); }}>
                                        Back to training floor
                                    </button>
                                    <button type="button" className="popupButton" style={{ ...triggerPrimaryButtonStyle, flex: 1, opacity: 0.78 }} onClick={() => { setExposureView('detail'); setExposureRepStep(1); setSelectedExposureChallengeId(exposureRepCompleteSnapshot?.challengeId || selectedExposureChallengeId); }}>
                                        View challenge
                                    </button>
                                </div>
                            )}
                        </div>
                    </>
                )}
            </div>
        </div>
    );

    let questionsLearning = [
        {
            question: 'Guided Journal Entry',
            assets: dailyJournalBody,
        },
        {
            question: 'Breathing Exercise',
            assets: motivationPrompts,
        },
        {
            question: 'Wellness Coach',
            assets: chat,
        },
        {
            question: 'Guided Meditation',
            assets: meditation,
        },
        {
            question: 'Capacity & Expression',
            assets: eceExerciseAssets,
        },
        {
            question: 'Manage Triggers',
            assets: triggerExerciseAssets,
        },
        {
            question: 'Nervous System Regulation',
            assets: nsrExerciseAssets,
        },
        {
            question: 'Mindset & Awareness',
            assets: maExerciseAssets,
        },
        {
            question: 'TH Community',
            assets: null,
        },
        {
            question: 'Resilience & Purpose',
            assets: rrWorkoutAssets,
        },
        {
            question: 'Connection & Communication',
            assets: cccWorkoutAssets,
        },
        {
            question: 'Exposure Training',
            assets: exposureWorkoutAssets,
        },
    ];

    const handleNextQuestion = () => {
        setCurrentQuestion(currentQuestion + 1);
    };

    const handlePreviousQuestion = () => {
        setCurrentQuestion(currentQuestion - 1);
    };

    const handleSubmitLearningClosePopup = () => {
        // //console.log('lesss navigate to the home screen homes')
        setShowPopup(false);
        setCurrentQuestion(0); // Reset the current question when the popup is closed
        setAnswers([]); // Clear the answers when the popup is closed

    };

    // const handleOpenLearningPopup = () => {
    //     setShowPopup(true);
    //     document.getElementById('learning-popup').style.display = "block";
    //     document.getElementsByClassName("popupContainer")[0].style.visibility =  "visible"
    //     document.getElementsByClassName("popupButtonGroup")[0].style.visibility =  "visible"
    // };
    const handleOpenLearningPopup = (pageNumber = 0) => {
        if(pageNumber === 8){
            window.open("https://whop.com/joined/trampoline-health/wins-goals-and-takeaways-5Hrc6ecDw1APCe/app/", "_blank");
            return
        }
        setShowPopup(true);

        if (pageNumber === 6) {
            resetNsrFlow();
            nsrSessionStartedAtRef.current = Date.now();
        }
        if (pageNumber === 7) {
            resetMaFlow();
            maSessionStartedAtRef.current = Date.now();
            maStartSection('surface');
        }
        if (pageNumber === 4) {
            resetEceFlow();
            eceSessionStartedAtRef.current = Date.now();
        }
        if (pageNumber === 9) {
            resetResilienceFlow();
            rrSessionStartedAtRef.current = Date.now();
            rrStartScreen('name_it');
        }
        if (pageNumber === 10) {
            resetConnectionCommFlow();
            cccSessionStartedAtRef.current = Date.now();
            setCccStep(1);
        }
        if (pageNumber === 11) {
            resetExposureFlow();
            setExposureLoading(true);
            exposureHydrate();
            setExposureLoading(false);
        }

        // Set the page number (assumes you track it in state)
        setCurrentQuestion(pageNumber);

        // Show popup UI
        document.getElementById('learning-popup').style.display = "block";
        document.getElementsByClassName("popupContainer")[0].style.visibility = "visible";
        document.getElementsByClassName("popupButtonGroup")[0].style.visibility = "visible";
    };

    const handleSubmitGymExercises= (event) => {
        // Process form submission or save answers
        // For example, you can send the answers to a backend server here

        //Send the stuff to the backend
        // Show a success message or close the popup form
        //console.log('sending the stuff to the back end homie')
        //console.log('start')
        event.preventDefault();
        

        //console.log('passed check')
        setErrorMessage(null)
        
        //TODO: move this to an environment variable
        const requestConfig = {
            headers: {
                'x-api-key': 'mCQrNSvy7X5AUdJlF2ybc3LdEFGndN885kzttyvB'
            }
        }
        
        console.log(dateObj.getTime())
        const requestBody = {
            username: username,
            token: token,
            date: convertTimestampToFullDateString(dateObj.getTime()),
            exerciseSubmission: withWorkoutTracking({
                content: journalEntry,
                mode: 'text',
                exercise_type: 'wellness_journal_entry',
                timestamp: dateObj.getTime(),
            }, username),
        }


        console.log(requestBody)

        console.log('closing the popup')
    
        axios.post(gymSubmitUrl, requestBody, requestConfig).then(response => {
            // setUserSession(response.data.user, response.data.token);
            console.log('submitted wellness exercise')
            console.log('response: ', response)
            handleCloseLearningPopup()
           
        }).catch(error => {
            //TODO: fix error of receiving null error
            console.log(error, typeof error);
            console.log('error content: ', error)
            handleCloseLearningPopup()
            if (error === undefined || error === null || error === '') {
                // catches both null and undefined
                setErrorMessage('Sorry the server is down. Please try again later.')
                console.log('response is null')
                handleCloseLearningPopup()
                return
            }
            if(error.response.status === 401 || error.response.status === 403 ){
                setErrorMessage(error.response.data.message);
            }
            else{
                setErrorMessage('Sorry the server is down. Please try again later.');

            }
            console.log('error submitting the wellness exercise')
            handleCloseLearningPopup()
        })

    };

    const renderFormLearning = () => {
        try{
            const currentQ = questionsLearning[currentQuestion];
            const { question, options } = currentQ;
            const nsrDrillFullBleed = currentQuestion === 6 && nsrStep === 4;
            const resilienceSettleLock = currentQuestion === 9 && rrStep === 5;
            const exposureDuringLock = currentQuestion === 11 && exposureView === 'rep' && exposureRepStep === 2;
            return (
                <div className="formContainer" style={nsrDrillFullBleed ? { backgroundColor: '#0d0d0d' } : undefined}>
                    <div className="daily-popup-top-right">
                        {resilienceSettleLock || exposureDuringLock ? null : (
                            <button
                                type="button"
                                className="landing-onboarding-top-close"
                                onClick={handleCloseLearningPopup}
                                aria-label="Close popup"
                                style={nsrDrillFullBleed ? { color: 'rgba(255, 255, 255, 0.9)' } : undefined}
                            >
                                x
                            </button>
                        )}
                    </div>
                    {nsrDrillFullBleed ? null : (
                        <h2 className="onboarding-popup-title">{question}</h2>
                    )}
                    <div
                        className="learningTextContent"
                        style={
                            currentQuestion === 4 || currentQuestion === 5 || currentQuestion === 6 || currentQuestion === 7 || currentQuestion === 9 || currentQuestion === 10
                                ? {
                                      overflow: 'hidden',
                                      height: '80%',
                                      minHeight: 0,
                                      textAlign: 'center',
                                      boxSizing: 'border-box',
                                      display: 'flex',
                                      flexDirection: 'column',
                                  }
                                : { overflowY: 'auto', height: '80%', minHeight: '470px', textAlign: 'center' }
                        }
                    >
                        {currentQ.assets}
                    </div>
                    <div className="popupButtonGroup">
                    {/* {currentQuestion > 0 && currentQuestion < questionsLearning.length - 2 ? (
                        <button className="popupNavigationBttn" onClick={handlePreviousQuestion} style={{border:'none', background: 'none'}}>
                            <img className="previousBttn" src={nextBttn} alt="previousBttn" />
                        </button>
                    ) : (
                        null
                    )} */}
                    {/* {currentQuestion < questionsLearning.length - 2 ? (
                        <button className="popupNavigationBttn" onClick={handleNextQuestion} >Next</button>
                    ) : (
                        <button id="learningSubmit" className="popupNavigationBttn" onClick={handleSubmitLearning} >Submit</button>
                    )} */}
                    {/* {currentQuestion >= 0 && currentQuestion < questionsLearning.length - 1 ? (
                        <button className="popupNavigationBttn" onClick={handleNextQuestion} style={{border:'none', background: 'none', marginLeft: 'auto'}}>
                            <img className="nextBttn" src={nextBttn} alt="nextBttn" />
                        </button>
                    ) : (
                        null
                    )}
                    {currentQuestion === questionsLearning.length - 1 ? (
                        <button id="relapseSubmit" className="popupNavigationBttn" style={{border:'none', background: 'none', marginLeft: 'auto'}}>
                            <img className="nextBttn" src={nextBttn} alt="nextBttn" />
                        </button>
                    ) : (
                        null
                    )} */}
                    </div>
                </div>
            );
        
        }
        catch{
            //console.log('some error yo -- need to fix this')
        }
        
    };

    useEffect(() => {    
        fetchRelapseLog()

    }, []) 

    const foundationalWorkoutTitles = [
        'Guided Journaling',
        'Breath Exercise',
        'Guided Meditation',
        'Manage Triggers',
        'Wellness Coach',
        'TH Community',
        'Exposure Training',
    ];
    const foundationalWorkouts = categories.filter((cat) => foundationalWorkoutTitles.includes(cat.title));
    const pillarWorkouts = categories.filter((cat) => !foundationalWorkoutTitles.includes(cat.title));

    return (
        <div className="wrapper wellnessGymScreen">
            <div className="dailyPopup">
                {/* <button onClick={handleOpenPopup}>hello</button> */}
                {/* #4490C3 */}
                <div className="popupContainer" id="learning-popup"  style={{ display: 'none' }} >{renderFormLearning()}</div>
                {/* <div className="popupContainer"  id="regulation-popup"  style={{ display: 'none' }}>{renderFormRegulation()}</div> */}
            </div>
            <div className='donut-parent'>
                <div className="donut"></div>
            </div>
            <div className="wellnessGymSurface">
                <div>
                    {/* <div className="container"> <button onClick = { relapseHandler }> Log Problematic Use </button> </div> */}
                    {/* <h3 className="container"> Digital Wellness is a journey -- Not a destination</h3> */}
                    <div className="wellnessGymHeader">
                        <h2 className="dailyMainTitle">Pick A Workout And Grow Your <br/>Awareness, Self Control, And Resilience</h2>
                    </div>
                    <div className="wellnessGymTabs">
                        <button
                            type="button"
                            onClick={() => setGymWorkoutTab('core')}
                            className={`wellnessGymTab ${gymWorkoutTab === 'core' ? 'isActive' : ''}`}
                        >
                            Core workouts
                        </button>
                        <button
                            type="button"
                            onClick={() => setGymWorkoutTab('my')}
                            className={`wellnessGymTab ${gymWorkoutTab === 'my' ? 'isActive' : ''}`}
                        >
                            My workouts
                        </button>
                    </div>
                    {/* <h4 className="text-center" style={{ marginTop:'0.5rem' }}> <span className="highlight">latest insight:</span> You're always practicing something. Choose growth, curiosity, and love.</h4> */}

                    {/* <p className="text-center"> The why: I will { user.currentGoal }</p> */}
                    {/* <p className="text-center"> Today's goal: { goal.textcontent } </p> */}
                    
                </div>
                <div>
                    <div>
                        {gymWorkoutTab === 'core' ? (
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '1.05rem', paddingBottom: '0.35rem' }}>
                            {[
                                { title: 'FOUNDATIONAL WORKOUTS', items: foundationalWorkouts },
                                { title: '5 PILLARS', items: pillarWorkouts },
                            ].map((section) => (
                                <div key={section.title}>
                                    <div
                                        style={{
                                            width: '100%',
                                            borderTop: '1px solid rgba(255, 255, 255, 0.2)',
                                            paddingTop: '0.62rem',
                                            marginBottom: '0.52rem',
                                            color: 'rgba(255, 255, 255, 0.9)',
                                            fontFamily: "'DM Sans', sans-serif",
                                            fontSize: '0.76rem',
                                            letterSpacing: '0.08em',
                                            textTransform: 'uppercase',
                                        }}
                                    >
                                        {section.title}
                                    </div>
                                    <div
                                        style={{
                                            display: 'flex',
                                            gap: '0.75rem',
                                            overflowX: 'auto',
                                            scrollSnapType: 'x mandatory',
                                            WebkitOverflowScrolling: 'touch',
                                            msOverflowStyle: 'none',
                                            scrollbarWidth: 'none',
                                            paddingBottom: '0.25rem',
                                        }}
                                    >
                                        {section.items.map((cat) => {
                                            const cardImage = WORKOUT_BACKGROUND_BY_TITLE[cat.title] || cat.image;
                                            return (
                                            <button
                                                key={cat.title}
                                                type="button"
                                                onClick={() => handleOpenLearningPopup(cat.page)}
                                                style={{
                                                    flex: '0 0 min(92%, 530px)',
                                                    minWidth: 0,
                                                    height: '210px',
                                                    border: '1px solid rgba(255, 255, 255, 0.16)',
                                                    borderRadius: '18px',
                                                    backgroundColor: '#101720',
                                                    backgroundImage: `linear-gradient(180deg, rgba(0,0,0,0.06) 8%, rgba(0,0,0,0.72) 88%), url(${cardImage})`,
                                                    backgroundSize: 'cover',
                                                    backgroundPosition: 'center',
                                                    color: '#fff',
                                                    textAlign: 'left',
                                                    padding: '0',
                                                    position: 'relative',
                                                    overflow: 'hidden',
                                                    cursor: 'pointer',
                                                    scrollSnapAlign: 'start',
                                                    boxShadow: '0 16px 32px rgba(4, 8, 16, 0.3)',
                                                }}
                                            >
                                                <div
                                                    style={{
                                                        position: 'absolute',
                                                        left: '0.95rem',
                                                        right: '0.95rem',
                                                        bottom: '0.95rem',
                                                        display: 'flex',
                                                        flexDirection: 'column',
                                                        gap: '0.25rem',
                                                    }}
                                                >
                                                    <div style={{ fontFamily: "'Fraunces', serif", fontSize: 'clamp(1.28rem, 4.6vw, 1.9rem)', lineHeight: 1.08, color: '#fff' }}>
                                                        {cat.title}
                                                    </div>
                                                    <div style={{ fontFamily: "'DM Sans', sans-serif", fontSize: '0.86rem', color: 'rgba(255, 255, 255, 0.8)' }}>
                                                        {cat.subtitle}
                                                    </div>
                                                </div>
                                            </button>
                                            );
                                        })}
                                    </div>
                                </div>
                            ))}
                        </div>
                        ) : (
                        <WellnessGymCustomWorkoutFeature
                            username={username}
                            token={token}
                            gymSubmitUrl={gymSubmitUrl}
                            apiKeyHeader={apiKeyHeader}
                            convertTimestampToFullDateString={convertTimestampToFullDateString}
                            triggerFlowShellStyle={triggerFlowShellStyle}
                            triggerFlowScrollStyle={triggerFlowScrollStyle}
                            triggerFlowFooterStyle={triggerFlowFooterStyle}
                            triggerFieldStyle={triggerFieldStyle}
                            nsrBoxPhases={NSR_BOX_PHASES}
                            nsrExtPhases={NSR_EXT_PHASES}
                        />
                        )}
                        {/* <h4 className="text-center"> Last Set Back: { lastTitle } </h4> */}
                        {/* <h4 className="text-center" style={{ marginTop:'3rem' }}> <span className="highlight">{name}'s big goal:</span> <TextExpander text={currentGoal} /></h4> */}

                        {/* <h4 className="text-center" style={{ marginTop:'3rem' }}> <span className="highlight">Latest Insight:</span> <TextExpander text={lastLesson} /></h4>
                        <h6 className="text-center" style={{ marginTop:'0.5rem', marginBottom:'0.5rem' }}> <span > Current Streak: { lastTitle } </span> </h6>
                        <div className="timer-container">
                       
                        <div className="item">
                            <Timer lastRelapseDate={lastRelapseDate}/>
                        </div>
                        </div> */}
                        {/* <p className="text-center"> { lastDescription } </p>
                        <div className="container">
                            <div className="item">
                                Key Lessons
                                <div className='left-text'>
                                    <p> { lastLesson } </p>
                                </div>
                            </div>
                            <div className="item">
                                Impact
                                <div>
                                    <p> { lastImpact } </p>
                                </div>
                            </div>
                        </div> */}
                    </div>
                    {/* <div> 
                        <div className="homeBttnContainer" style={{ display:'flex', flexDirection:'column', marginTop:"2.5rem" }}>
                            <button className="homeBttn" onClick={handleOpenLearningPopup} >Show Set Back Log</button>

                        </div>
                        <br></br>
                        <br></br>
                
                    </div> */}
                </div>
            </div>
            {errorMessage && <p className="message"> { errorMessage } </p>}
        </div>
    )
}

export default WellnessGym;